/* Generated by scripts/build-shopify-js.mjs. Do not edit this file directly. */
const I18N = window.TOOLKIT_TRANSLATIONS || {};

function tr(key, fallback = "") {
  return I18N[key] || fallback;
}

function h(value) {
  return String(value ?? "")
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;")
    .replaceAll("'", "&#39;");
}

const SHOPIFY_SHELL_HTML = `<div id="fabActions" class="fixed bottom-6 right-6 z-50 group print:hidden">
    <button
      type="button"
      class="relative flex h-14 w-14 items-center justify-center rounded-full bg-black text-white shadow-lg transition"
      aria-label="${h(tr("actions", "Actions"))}"
      data-fab-toggle="true"
    >
      <svg viewBox="0 0 24 24" class="h-6 w-6 stroke-white opacity-100 transition duration-300 group-[.active]:opacity-0" fill="none" stroke-width="2" stroke-linecap="round">
        <line x1="3" y1="6" x2="21" y2="6"/>
        <line x1="3" y1="12" x2="21" y2="12"/>
        <line x1="3" y1="18" x2="21" y2="18"/>
      </svg>
      <span class="absolute left-1/2 top-1/2 h-[2px] w-[1.6rem] -translate-x-1/2 -translate-y-1/2 bg-white opacity-0 transition duration-300 group-[.active]:rotate-[135deg] group-[.active]:opacity-100"></span>
      <span class="absolute left-1/2 top-1/2 h-[2px] w-[1.6rem] -translate-x-1/2 -translate-y-1/2 bg-white opacity-0 transition duration-300 group-[.active]:rotate-[405deg] group-[.active]:opacity-100"></span>
    </button>

    <ul class="absolute bottom-16 right-0 flex flex-col gap-3 opacity-0 pointer-events-none transition duration-300 group-[.active]:opacity-100 group-[.active]:pointer-events-auto">
      <li>
        <button id="loadFromJson" type="button" class="fab-item bg-black" aria-label="${h(tr("loadConfiguration", "Load configuration"))}">
          <span class="fab-tooltip">${h(tr("loadConfiguration", "Load configuration"))}</span>
          <svg viewBox="0 0 24 24" aria-hidden="true" class="h-5 w-5 stroke-current" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M20 20a2 2 0 0 0 2-2V8l-6-6H6a2 2 0 0 0-2 2v4"></path>
            <polyline points="14 2 14 8 20 8"></polyline>
            <path d="M12 18H2"></path>
            <polyline points="8 14 12 18 8 22"></polyline>
          </svg>
        </button>
      </li>

      <li class="hidden md:block">
        <button id="saveToJson" type="button" class="fab-item bg-black" aria-label="${h(tr("saveConfiguration", "Save configuration"))}">
          <span class="fab-tooltip">${h(tr("saveConfiguration", "Save configuration"))}</span>
          <svg viewBox="0 0 24 24" aria-hidden="true" class="h-5 w-5 stroke-current" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"></path>
            <polyline points="17 21 17 13 7 13 7 21"></polyline>
            <polyline points="7 3 7 8 15 8"></polyline>
          </svg>
        </button>
      </li>

      <li>
        <button id="loadPredefinedToolKit" type="button" class="fab-item bg-black" aria-label="${h(tr("loadToolkit", "Load toolkit"))}">
          <span class="fab-tooltip">${h(tr("loadToolkit", "Load toolkit"))}</span>
          <svg viewBox="0 0 24 24" aria-hidden="true" class="h-5 w-5 stroke-current" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="3.2 8.2 3.2 13.7 6 16.4 22 16.4 22 7.6 18.7 4.4 8 4.4"></polyline>
            <path d="M6.5 19.4a1.5 1.5 0 0 0 3 0z"></path>
            <path d="M18 19.4a1.5 1.5 0 0 0 3 0z"></path>
            <line x1="9" y1="13.5" x2="18.8" y2="13.5"></line>
            <line x1="9" y1="9.1" x2="18.8" y2="9.1"></line>
            <line x1="5" y1="5.5" x2="2" y2="3.4"></line>
          </svg>
        </button>
      </li>

      <li>
        <button id="exportTableBtn" type="button" class="fab-item bg-black" aria-label="${h(tr("exportTable", "Export table"))}">
          <span class="fab-tooltip">${h(tr("exportTable", "Export table"))}</span>
          <svg viewBox="0 0 24 24" aria-hidden="true" class="h-5 w-5 stroke-current" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M3 3h18v18H3z"></path>
            <path d="M3 9h18"></path>
            <path d="M3 15h18"></path>
            <path d="M9 3v18"></path>
            <path d="M15 3v18"></path>
          </svg>
        </button>
      </li>

      <li>
        <button id="printToPdf" type="button" class="fab-item bg-black" aria-label="${h(tr("printPdf", "Print PDF"))}">
          <span class="fab-tooltip">${h(tr("printPdf", "Print PDF"))}</span>
          <svg viewBox="0 0 24 24" aria-hidden="true" class="h-5 w-5 stroke-current" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="6 9 6 2 18 2 18 9"></polyline>
            <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"></path>
            <rect x="6" y="14" width="12" height="8"></rect>
          </svg>
        </button>
      </li>
    </ul>
  </div>
  <main class="w-full bg-gray-100 print:bg-transparent">
    <section class="grid md:grid-cols-[minmax(0,1fr)_minmax(0,2fr)]">

      <section aria-labelledby="setup-title" class="self-start p-5 px-6 flex print:hidden md:sticky md:top-sticky">
        <div class="w-full">
          <div data-dismissible="configurator-hint" class="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-3 rounded-md border border-dashed border-yellow-900 bg-yellow-50 px-3 py-2 text-sm text-yellow-900 print:hidden">
            <ul class="space-y-2">
              <li class="flex items-start gap-2">
                <svg class="mt-0.5 h-4 w-4 shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M9 18l6-6-6-6"></path>
                  <path d="M15 18l6-6-6-6"></path>
                </svg>
                <span>${h(tr("selectYourStorage", "1. Select your storage."))}</span>
              </li>
              <li class="flex items-start gap-2">
                <svg class="mt-0.5 h-4 w-4 shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M9 18l6-6-6-6"></path>
                  <path d="M15 18l6-6-6-6"></path>
                </svg>
                <span>${h(tr("selectYourSets", "2. Select your sets."))}</span>
              </li>
              <li class="flex items-start gap-2">
                <svg class="mt-0.5 h-4 w-4 shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M9 18l6-6-6-6"></path>
                  <path d="M15 18l6-6-6-6"></path>
                </svg>
                <span>${h(tr("organiseStorage", "3. Organise your storage with drag and drop."))}</span>
              </li>
            </ul>

            <button
              type="button"
              aria-label="${h(tr("dismissHint", "Dismiss hint"))}"
              class="self-end sm:self-start shrink-0 rounded p-1 text-yellow-900 transition hover:bg-yellow-300"
              data-action="dismiss-configurator-hint"
            >
              <svg class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </button>
          </div>
          <form id="toolstorageForm" class="grid gap-4">
            <input id="toolstorageInput" type="hidden" value="">
            <div class="grid gap-2">
              <div class="w-full max-w-2xl mx-auto">
                <div role="tablist" aria-label="${h(tr("sampleTabs", "Sample tabs"))}" class="border-b border-gray-200 text-sm font-medium text-center text-gray-500">
                  <ul class="flex -mb-px">
                    <li class="w-1/2">
                      <button id="tab-btn-1" role="tab" aria-selected="true" aria-controls="panel-1" data-tab="panel-1" class="tab-btn inline-block font-bold w-full rounded-t-lg border-b-2 border-red-600 p-3 text-red-600 uppercase" type="button">
                        ${h(tr("toolStorage", "Tool storage"))}
                      </button>
                    </li>
                    <li class="w-1/2">
                      <button id="tab-btn-2" role="tab" aria-selected="false" aria-controls="panel-2" data-tab="panel-2" class="tab-btn inline-block font-bold w-full rounded-t-lg border-b-2 border-transparent p-3 uppercase" type="button">
                        ${h(tr("toolSets", "Tool sets"))}
                      </button>
                    </li>
                  </ul>
                </div>

                <div id="panel-1" role="tabpanel" aria-labelledby="tab-btn-1" class="tab-panel pt-4 pr-2">
                  <div class="grid gap-4 pb-4">
                    <div class="grid gap-2">
                      <div class="relative flex items-center gap-2">
                        <input id="toolStorageSearch" type="search" placeholder="${h(tr("searchByNameIdType", "Search by name, ID, or type"))}" class="h-10 w-full rounded-md border border-gray-300 px-3 text-sm focus:border-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-200">
                        <details class="z-10">
                            <summary class="inline-flex h-10 cursor-pointer items-center gap-2 rounded-md border border-gray-200 bg-black px-3 text-xs font-semibold uppercase tracking-wide text-white" data-filter-summary="toolStorageTypeFilters">
                                <svg viewBox="0 0 24 24" aria-hidden="true"
                                          class="h-4 w-4 stroke-current" fill="none" stroke-width="2"
                                          stroke-linecap="round" stroke-linejoin="round" data-filter-icon="inactive">
                                  <path d="M10 5H3"/><path d="M12 19H3"/>
                                  <path d="M14 3v4"/>
                                  <path d="M16 17v4"/>
                                  <path d="M21 12h-9"/>
                                  <path d="M21 19h-5"/>
                                  <path d="M21 5h-7"/>
                                  <path d="M8 10v4"/>
                                  <path d="M8 12H3"/>
                                </svg>
                                <svg viewBox="0 0 24 24" aria-hidden="true"
                                          class="hidden h-4 w-4 stroke-current" fill="none" stroke-width="2"
                                          stroke-linecap="round" stroke-linejoin="round" data-filter-icon="active">
                                  <circle cx="12" cy="12" r="9"></circle>
                                  <path d="m8.5 12 2.5 2.5 4.5-4.5"></path>
                                </svg>
    <span class="hidden sm:inline">${h(tr("filters", "Filters"))}</span>
  </summary>
                          <div class="absolute left-0 right-0 top-full z-50 mt-2 rounded-md border border-gray-200 bg-white p-3 shadow-lg">
                            <div class="grid gap-2">
                              <span class="text-xs font-semibold uppercase tracking-wide text-gray-600">${h(tr("productType", "Product type"))}</span>
                              <div id="toolStorageTypeFilters" class="flex flex-wrap gap-2"></div>
                            </div>
                          </div>
                        </details>
                        <div class="relative group inline-block">
  <button id="toolStorageClearFilters" type="button" aria-label="${h(tr("clearFilters", "Clear filters"))}"
    class="inline-flex h-10 items-center justify-center gap-2 rounded-md border border-gray-300 px-3 text-gray-600 transition hover:bg-gray-100">
    
    <svg viewBox="0 0 24 24" aria-hidden="true"
      class="h-4 w-4 stroke-current" fill="none" stroke-width="2"
      stroke-linecap="round" stroke-linejoin="round">
      <path d="m13.5 8.5-5 5"/>
      <path d="m8.5 8.5 5 5"/>
      <circle cx="11" cy="11" r="8"/>
      <path d="m21 21-4.3-4.3"/>
    </svg>

    <span class="hidden sm:inline text-xs font-semibold uppercase tracking-wide text-gray-600">${h(tr("clear", "Clear"))}</span>
  </button>

  <!-- Tooltip -->
  <div class="pointer-events-none absolute left-1/2 top-full z-50 mt-2 -translate-x-1/2 whitespace-nowrap rounded bg-gray-900 px-2 py-1 text-xs text-white opacity-0 transition-opacity group-hover:opacity-100">
    ${h(tr("clearFilters", "Clear filters"))}
  </div>
</div>
                      </div>
                    </div>
                  </div>
                  <div id="toolStorageCatalog" class="no-overscroll grid max-h-[55vh] grid-cols-2 overflow-y-auto md:max-h-[63vh] xl:grid-cols-3"></div>
                </div>

                <div id="panel-2" role="tabpanel" aria-labelledby="tab-btn-2" class="tab-panel hidden pt-4 pr-2">
                  <div class="grid gap-4 pb-4">
                    <div class="grid gap-2">
                      <div class="relative flex items-center gap-2">
                        <input id="toolSetSearch" type="search" placeholder="${h(tr("searchByNameIdType", "Search by name, ID, or type"))}" class="h-10 w-full rounded-md border border-gray-300 px-3 text-sm focus:border-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-200">
                        <details class="z-10">
                          <summary class="inline-flex h-10 cursor-pointer items-center gap-2 rounded-md border border-gray-200 bg-black px-3 text-xs font-semibold uppercase tracking-wide text-white" data-filter-summary="toolSetTypeFilters">
                            <svg viewBox="0 0 24 24" aria-hidden="true" class="h-4 w-4 stroke-current" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" data-filter-icon="inactive">
                              <path d="M10 5H3"/><path d="M12 19H3"/>
                                                          <path d="M14 3v4"/>
                                                          <path d="M16 17v4"/>
                                                          <path d="M21 12h-9"/>
                                                          <path d="M21 19h-5"/>
                                                          <path d="M21 5h-7"/>
                                                          <path d="M8 10v4"/>
                                                          <path d="M8 12H3"/>
                            </svg>
                            <svg viewBox="0 0 24 24" aria-hidden="true" class="hidden h-4 w-4 stroke-current" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" data-filter-icon="active">
                              <circle cx="12" cy="12" r="9"></circle>
                              <path d="m8.5 12 2.5 2.5 4.5-4.5"></path>
                            </svg>
                            <span class="hidden sm:inline">${h(tr("filters", "Filters"))}</span>
                          </summary>

  <div class="absolute left-0 right-0 top-full z-50 mt-2 rounded-md border border-gray-200 bg-white p-3 shadow-lg">
    <div class="grid gap-2">
      <span class="text-xs font-semibold uppercase tracking-wide text-gray-600">${h(tr("type", "Type"))}</span>
      <div id="toolSetTypeFilters" class="flex flex-wrap gap-2"></div>
    </div>

    <div class="grid gap-2 pt-3">
      <span class="text-xs font-semibold uppercase tracking-wide text-gray-600">${h(tr("filterByItemId", "Filter by Item Id"))}</span>
      <textarea
        class="min-h-[220px] rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-200"
        id="toolsetsInput"
        rows="7"
        placeholder="${h(tr("pasteOneToolSetIdPerLine", "Paste one tool set ID per line"))}"
      ></textarea>

      <div class="flex flex-wrap items-center gap-2 sm:ml-auto">
        <button id="recommendBtn" type="button" class="inline-flex items-center justify-center rounded-md border border-red-400 bg-red-700 px-3 py-2 text-xs font-semibold uppercase tracking-wide text-white transition hover:bg-red-300">
          ${h(tr("placeListItems", "Place list items"))}
        </button>
      </div>
    </div>
  </div>
</details>

<div class="relative group inline-block">
  <button
    id="toolSetClearFilters"
    type="button"
    aria-label="${h(tr("clearFilters", "Clear filters"))}"
    class="inline-flex h-10 items-center justify-center gap-2 rounded-md border border-gray-300 px-3 text-gray-600 transition hover:bg-gray-100"
  >
    <svg viewBox="0 0 24 24" aria-hidden="true" class="h-4 w-4 stroke-current" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <path d="m13.5 8.5-5 5"/>
      <path d="m8.5 8.5 5 5"/>
      <circle cx="11" cy="11" r="8"/>
      <path d="m21 21-4.3-4.3"/>
    </svg>
    <span class="hidden sm:inline text-xs font-semibold uppercase tracking-wide text-gray-600">${h(tr("clear", "Clear"))}</span>
  </button>

  <!-- Tooltip -->
  <div class="pointer-events-none absolute left-1/2 top-full z-50 mt-2 -translate-x-1/2 whitespace-nowrap rounded bg-gray-900 px-2 py-1 text-xs text-white opacity-0 transition-opacity group-hover:opacity-100 group-focus-within:opacity-100">
    ${h(tr("clearFilters", "Clear filters"))}
  </div>
</div>
                      </div>
                    </div>
                  </div>
                  <div id="toolSetCatalog" class="no-overscroll grid max-h-[55vh] grid-cols-2 overflow-y-auto md:max-h-[63vh] xl:grid-cols-3"></div>
                </div>
              </div>
            </div>

          </form>
         <div class="mt-6 sm:hidden flex items-center justify-center gap-2 text-xs text-gray-500 animate-bounce">
           <span>${h(tr("configureTheToolStorage", "Configure the tool storage"))}</span>
           <svg class="h-4 w-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
             <path d="m10 15 5 5 5-5"/>
             <path d="M4 4h7a4 4 0 0 1 4 4v12"/>
           </svg>
         </div>
        </div>
      </section>
      <section aria-labelledby="recommendations-title" class="min-h-screen bg-white px-6 p-6 print:bg-white">
        <div id="fromToolstorageInput" class="relative grid gap-6">
            <!-- PRINT HEADER -->
          <div class="hidden px-0 pb-0 mb-3 print:flex w-[250mm] h-[50mm] bg-[#ffffff] text-black">
              <!-- Left red bar -->
              <div class="w-[6mm] bg-red-600"></div>

              <!-- Content -->
              <div class="flex w-full items-start justify-between px-[12mm] py-[10mm]">
                <!-- Left side -->
                <div class="flex flex-col">
                  <div class="mb-2">
                    <svg id="printLogo" xmlns="http://www.w3.org/2000/svg" width="85" height="55" version="1.1" viewBox="0 0 85 55" class="p-1"><path d="M16.56,6.68s-3.39,5.17,1.6,8.14c0,0,3.92,2.26,6.72-1.72,0,0-1.43,3.63,3.86,6.9,0,0,4.87,3.45,9.1.42,0,0,2.53-.95,1.63-5.41,0,0,5.1,10.77-.16,13.6.24,1.52,4.92,1.88,4.69-2.29,0-3.85,1.63-6,2.02-6.81-.26-3.05.12-4.95,2.55-7.84-.56,2.06-1.07,3.12.05,5.43.87-.5,1.59-1.04,2.6-1.04-.7.7-1.27,1.63-1.66,2.62.42.45,1.54,2.46,4.04,1.47,1.99-1.04,3.09-3.7,2.82-8.16.72.65,1.99,1.72,2.69,2.41.8.89,1.39,1.39,1.99,2.61.59,1.19,1.03,3.38.49,5.49.3.59,1.55,3.12,1.1,5.47.03.56.06,1.28.83,1.25,1.72-.12,11.58-.28,13.52,6.18-1.81,0-69.67,0-69.67,0-.69-5.21.99-8.86,4.6-11.29-3.99-5.06-.88-12.17,4.59-17.43Z"></path><path d="M62.01,30.28c-3.95.42-11.24,1.31-15.72,2.82-1.78.36-3.6.62-4.25-2.23-1.13.18-3.03.27-3.98-1.6-.51.15-1.52.15-2.14-.12-.98,3.83-8,6.15-15.04,2.76-6.3-3.54-6.6-9.27,2.85-10.43-2.56-.89-7.98.56-9.23,4.54-.34-.05-.62-.17-.94-.36-.34-.2-.71-.52-.82-.64-2.69,2.17-4.65,4.81-3.58,10.38h66.1c-1.1-2.76-3.6-5.71-13.26-5.11Z" fill="#ed1c24"></path><path d="M59.43,23.08s2.62,2.59-.18,6.12c.36-1.01,1.31-2.65.18-6.12Z" fill="#ed1c24"></path><path d="M26.05,22.64c-1.9-.06-4.16-.18-6.75,1.13-1.04.74-1.28.36-.89,2.35.45,1.72,1.4,3.8,5.14,5.08,2.26.68,8.62,2.29,11.15-2.65,0,0-6.12-5.14-8.65-5.92ZM28.65,31.26c-1.29,0-2.33-1.04-2.33-2.33s1.04-2.33,2.33-2.33,2.33,1.04,2.33,2.33-1.04,2.33-2.33,2.33Z" fill="#ffd400"></path><path d="M54.34,30.36c-.35-.37-.57-.87-.57-1.43,0-1.15.93-2.08,2.08-2.08s2.08.93,2.08,2.08c0,.15-.02.3-.05.45.52-.27,2.28-2.77.7-5.89-.51.09-3.39,1.69-7.01,5.47-.51.59-1.04,1.28-2.67,1.66-.48.09-.65,1.01.45.8,1.1-.21,4.99-1.07,4.99-1.07Z" fill="#ffd400"></path><path d="M55.47,28.17c0,.2-.16.36-.36.36s-.36-.16-.36-.36.16-.36.36-.36.36.16.36.36Z" fill="#fff"></path><path d="M28.19,28.23c0,.29-.23.52-.52.52s-.52-.23-.52-.52.23-.52.52-.52.52.23.52.52Z" fill="#fff"></path><path d="M70.8,35.41c.49-.45.67-1.07.41-1.54-.32-.57-1.2-.69-1.96-.26-.76.43-1.11,1.24-.78,1.81l2.33-.02Z" fill="#fff"></path><polygon points="12.54 39.24 11.33 49.16 8.62 49.16 9.83 39.24 6.57 39.24 6.9 37.07 37.31 37.07 36.97 39.24 12.54 39.24"></polygon><polygon points="25.55 49.16 27.94 49.16 29.04 40.25 26.42 40.25 25.89 44.53 23.31 40.25 20.66 40.25 19.55 49.16 22.17 49.16 22.77 44.36 25.55 49.16"></polygon><polygon points="13.3 49.16 14.4 40.25 19.6 40.25 19.31 42.57 16.74 42.57 16.63 43.47 18.92 43.47 18.65 45.69 16.36 45.69 16.22 46.79 18.79 46.8 18.5 49.16 13.3 49.16"></polygon><path d="M38.26,43.87v.51c0,5.08-4.44,4.78-4.44,4.78-4.73,0-4.42-4.57-4.42-4.57,0-4.88,4.78-4.58,4.78-4.58,0,0,2.59-.1,3.91,2.45l-2.19,1.09s-.6-1.23-1.93-1.23c0,0-1.87-.08-1.87,2.28,0,0-.05,2.35,1.81,2.35,0,0,1.16-.03,1.5-1.01h-1.86l.53-2.07h4.18Z"></path><polygon points="43.26 39.24 42.06 49.16 39.43 49.16 40.64 39.24 37.74 39.24 38.07 37.07 76.63 37.07 76.29 39.24 43.26 39.24"></polygon><path d="M46.18,44.58c0-1.01.85-2.1,2.11-2.1s2.11,1.09,2.11,2.1-.85,2.1-2.11,2.1-2.11-1.1-2.11-2.1ZM48.28,44.58,48.28,49.25c2.58,0,4.67-2.09,4.67-4.67s-2.09-4.67-4.67-4.67-4.67,2.09-4.67,4.67,2.09,4.67,4.67,4.67ZM48.28,44.58"></path><path d="M56.1,44.58c0-1.01.85-2.1,2.11-2.1s2.11,1.09,2.11,2.1-.85,2.1-2.11,2.1-2.11-1.1-2.11-2.1ZM58.2,44.58,58.2,49.25c2.58,0,4.67-2.09,4.67-4.67s-2.09-4.67-4.67-4.67-4.67,2.09-4.67,4.67,2.09,4.67,4.67,4.67ZM58.2,44.58"></path><polygon points="65.93 46.79 68.5 46.79 68.2 49.16 63.01 49.16 64.11 40.25 66.8 40.25 65.93 46.79"></polygon><path d="M72.73,39.96c-1.58,0-2.82,1.29-2.82,2.71,0,1,.53,1.73,1.19,2.22.26.2,1.28.73,1.28.73.23.12.34.39.34.63,0,.34-.32.7-.74.64,0,0-.58-.04-1.8-.85l-1.21,1.93c1.71,1.38,3.5,1.19,3.5,1.19,1.62,0,2.94-1.31,2.94-2.89,0-.99-.6-2.03-1.38-2.48,0,0-1.06-.62-1.24-.75-.17-.11-.24-.32-.22-.46.1-.71,1.11-.41,2.12.15l1.12-1.73s-.87-1.06-3.08-1.06Z"></path><path d="M78.34,36.94c.19,0,.38.05.57.15.18.1.33.24.43.43.1.18.15.38.15.58s-.05.39-.15.57c-.1.18-.24.33-.43.43-.18.1-.37.15-.57.15s-.39-.05-.57-.15c-.18-.1-.32-.24-.43-.43-.1-.18-.15-.37-.15-.57s.05-.39.15-.58c.1-.18.25-.33.43-.43.18-.1.37-.15.57-.15ZM78.34,37.13c-.16,0-.32.04-.47.12-.15.08-.27.2-.36.36-.09.15-.13.31-.13.48s.04.32.13.48c.08.15.2.27.36.36.15.08.31.13.48.13s.33-.04.48-.13c.15-.08.27-.2.36-.36.08-.15.13-.31.13-.48s-.04-.33-.13-.48c-.09-.15-.21-.27-.36-.36-.15-.08-.31-.12-.47-.12ZM77.83,38.73v-1.24h.43c.15,0,.25.01.32.03.07.02.12.06.16.12.04.06.06.12.06.18,0,.09-.03.17-.1.24-.06.07-.15.1-.26.11.04.02.08.04.11.07.05.05.11.13.18.25l.15.24h-.24l-.11-.2c-.09-.15-.16-.25-.21-.29-.04-.03-.09-.04-.16-.04h-.12v.53h-.2ZM78.03,38.03h.24c.12,0,.2-.02.24-.05.04-.03.06-.08.06-.14,0-.04-.01-.07-.03-.1-.02-.03-.05-.05-.08-.06-.04-.01-.1-.02-.2-.02h-.23v.37Z"></path></svg>
                  </div>
                  <div class="mx-3 leading-none">
                    <div class="text-[18px] font-bold uppercase tracking-tight text-neutral-600">
                      ${h(tr("customised", "CUSTOMISED"))}
                    </div>
                    <div class="text-[36px] font-black uppercase tracking-tight">
                      ${h(tr("toolKit", "TOOL KIT"))}
                    </div>
                  </div>
                </div>

                <!-- Right side -->
                <div class="max-w-[130mm]">
                  <div class="text-[18px] font-semibold uppercase tracking-tight">
                    ${h(tr("expertSolutionsForIndustrialEfficiency", "EXPERT SOLUTIONS FOR INDUSTRIAL EFFICIENCY"))}
                  </div>

                  <p class="mt-1 mb-5 text-[12px] leading-[1.45] text-neutral-600">
                    ${h(tr("printIntroLine1", "TengTools provide demanding professionals with hand tools in"))}<br>
                    ${h(tr("printIntroLine2", "modular storage solutions that are built to last."))}
                  </p>

                  <div class="mt-3 flex items-center gap-2 text-[18px] font-bold uppercase tracking-tight">
                      <div class="inline-flex overflow-hidden">
                        <svg id="sweflag" xmlns="http://www.w3.org/2000/svg" width="32" height="32" version="1.1" viewBox="0 0 32 32">
                         <rect x="1.3" y="5.88" width="29.4" height="20.25" fill="#2e72b8"/>
                         <polygon points="30.7 14 14.68 14 14.68 5.87 10.68 5.87 10.68 14 1.3 14 1.3 18 10.68 18 10.68 26.12 14.68 26.12 14.68 18 30.7 18 30.7 14" fill="#fcc00d"/>
                        </svg>
                      </div>
                    <span>${h(tr("designedInSweden", "Designed in Sweden"))}</span>
                  </div>
                </div>
              </div>
            </div>
           <!-- END OF PRINT HEADER -->
          <div id="selectedToolstorageCard" class="bg-white p-3 text-sm text-gray-500">
            <div class="text-center text-sm text-gray-500">
              <div class="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-gray-100 text-gray-400">
                <svg viewBox="0 0 24 24" aria-hidden="true" class="h-6 w-6 stroke-current" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <rect x="3" y="7" width="18" height="13" rx="2"></rect>
                  <path d="M8 7V5a4 4 0 0 1 8 0v2"></path>
                </svg>
              </div>
              <h3 class="mt-4 text-base font-semibold text-gray-900">${h(tr("selectedToolStorage", "Selected tool storage"))}</h3>
              <p class="mx-auto mt-2 max-w-md text-sm leading-6 text-gray-500">${h(tr("noToolStorageSelected", "No tool storage selected."))}</p>
            </div>
          </div>
        </div>
        <div id="recommendationsGrid" class="mt-6 grid gap-6">
        </div>
      </section>
    </section>
  </main>

  <div id="exportTableModal" class="fixed inset-0 z-50 hidden items-center justify-center bg-gray-900/40 p-4">
    <div class="w-full max-w-2xl rounded-lg bg-white p-4 shadow-lg">
      <div class="flex items-center justify-between">
        <h3 class="text-sm font-semibold uppercase tracking-wide text-gray-700">${h(tr("exportSelectedItems", "Export Selected Items"))}</h3>
        <button id="exportTableClose" type="button" aria-label="${h(tr("close", "Close"))}" class="inline-flex h-8 w-8 items-center justify-center rounded-md border border-gray-200 text-gray-500 transition hover:bg-gray-100">
          <svg viewBox="0 0 24 24" aria-hidden="true" class="h-4 w-4 stroke-current" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      </div>
      <p class="mt-1 text-xs text-gray-500">${h(tr("copyPasteFourColumnTable", "Copy and paste this four-column table into Excel or Sheets."))}</p>
      <textarea id="exportTableText" class="mt-3 h-64 w-full rounded-md border border-gray-200 px-3 py-2 text-xs text-gray-700" readonly></textarea>
      <div class="mt-3 flex items-center gap-3">
        <button id="exportTableCopy" type="button" class="inline-flex items-center justify-center rounded-md border border-red-400 bg-red-700 px-3 py-2 text-xs font-semibold uppercase tracking-wide text-white transition  hover:bg-red-300">
          ${h(tr("copy", "Copy"))}
        </button>
        <span id="exportTableStatus" class="text-xs text-gray-500"></span>
      </div>
    </div>
  </div>

  <div id="downloadConfigModal" class="fixed inset-0 z-50 hidden items-center justify-center bg-gray-900/40 p-4 print:hidden">
    <div class="w-full max-w-lg rounded-lg bg-white p-4 shadow-lg">
      <div class="flex items-center justify-between">
        <h3 class="text-sm font-semibold uppercase tracking-wide text-gray-700">${h(tr("downloadConfiguration", "Download Configuration"))}</h3>
        <button id="downloadConfigClose" type="button" aria-label="${h(tr("close", "Close"))}" class="inline-flex h-8 w-8 items-center justify-center rounded-md border border-gray-200 text-gray-500 transition hover:bg-gray-100">
          <svg viewBox="0 0 24 24" aria-hidden="true" class="h-4 w-4 stroke-current" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      </div>
      <p class="mt-2 text-xs text-gray-600">
        ${h(tr("emptyDownloadHint", "If your browser creates empty downloads, use the link below (a real tap) to download the export."))}
      </p>
      <div class="mt-3 rounded-md border border-gray-200 bg-gray-50 px-3 py-2">
        <div class="text-[11px] font-semibold uppercase tracking-wide text-gray-500">${h(tr("file", "File"))}</div>
        <div id="downloadConfigFileName" class="mt-1 break-all text-xs text-gray-900"></div>
      </div>
      <div class="mt-4 grid gap-3">
        <a
          id="downloadConfigLink"
          href="#"
          class="inline-flex items-center justify-center rounded-md border border-red-400 bg-red-700 px-3 py-2 text-xs font-semibold uppercase tracking-wide text-white transition hover:bg-red-300"
          download
          rel="noopener"
        >
          ${h(tr("tapToDownload", "Tap to download"))}
        </a>
        <button id="downloadConfigCopy" type="button" class="inline-flex items-center justify-center rounded-md border border-gray-300 bg-white px-3 py-2 text-xs font-semibold uppercase tracking-wide text-gray-800 transition hover:bg-gray-100">
          ${h(tr("copyJson", "Copy JSON"))}
        </button>
        <span id="downloadConfigStatus" class="text-xs text-gray-500"></span>
      </div>
    </div>
  </div>

  <div id="predefinedToolKitModal" class="fixed inset-0 z-50 hidden items-center justify-center bg-gray-900/50 p-4 print:hidden">
    <div class="w-full max-w-5xl rounded-lg bg-white p-4 shadow-lg">
      <div class="flex items-center justify-between gap-3">
        <h3 class="text-sm font-semibold uppercase tracking-wide text-gray-700">${h(tr("loadPredefinedToolKit", "Load predefined tool kit"))}</h3>
        <button id="predefinedToolKitClose" type="button" aria-label="${h(tr("close", "Close"))}" class="inline-flex h-8 w-8 items-center justify-center rounded-md border border-gray-200 text-gray-500 transition hover:bg-gray-100">
          <svg viewBox="0 0 24 24" aria-hidden="true" class="h-4 w-4 stroke-current" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      </div>
      <p class="mt-1 text-xs text-gray-500">${h(tr("selectToolKitToMakeCustomLayout", "Select a TengTools tool kit to make a custom layout."))}</p>
      <div id="predefinedToolKitStatus" class="mt-3 text-xs text-gray-500"></div>
      <div id="predefinedToolKitList" class="mt-3 grid max-h-[70vh] grid-cols-2 gap-4 overflow-y-auto md:grid-cols-3"></div>
    </div>
  </div>

	  <div id="productDetailModal" role="dialog" aria-modal="true" aria-labelledby="productDetailTitle" class="fixed inset-0 z-50 hidden items-center justify-center bg-gray-900/50 p-3">
    <div class="no-overscroll max-h-[80vh] w-full max-w-2xl overflow-y-auto bg-white p-3 shadow-lg">
      <div class="flex items-center justify-end">
        <h3 id="productDetailTitle" class="hidden text-sm font-semibold uppercase tracking-wide text-gray-700">${h(tr("productDetails", "Product details"))}</h3>
        <button id="productDetailClose" type="button" aria-label="${h(tr("close", "Close"))}" class="inline-flex h-8 w-8 items-center justify-center rounded-md border border-gray-200 text-gray-500 transition hover:bg-gray-100">
          <svg viewBox="0 0 24 24" aria-hidden="true" class="h-4 w-4 stroke-current" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      </div>
      <div id="productDetailBody" class="grid gap-4 md:grid-cols-[minmax(0,1fr)_minmax(0,1fr)]"></div>
    </div>
  </div>`;

const __modules = Object.create(null);

function __define(id, factory) {
  __modules[id] = {
    factory,
    exports: {},
    initialized: false,
  };
}

function __require(id) {
  const record = __modules[id];
  if (!record) {
    throw new Error(`Missing bundled module: ${id}`);
  }

  if (!record.initialized) {
    record.initialized = true;
    record.factory(record.exports, __require);
  }

  return record.exports;
}

__define("app.js", (exports, __require) => {
const { createConfiguratorState, createDragState } = __require("features/configurator/configurator-state.js");
const { initConfiguratorController } = __require("features/configurator/configurator-controller.js");
const { fetchToolStorageRows, fetchToolSetRows } = __require("features/toolstorage-data/toolstorage-data-api.js");
const { normalizeToolStorages, normalizeToolSets } = __require("features/toolstorage-data/toolstorage-normalizer.js");
const { t } = __require("shared/i18n/toolkit-i18n.js");
async function startConfiguratorApp() {
  const state = createConfiguratorState();
  const dragState = createDragState();

  const [toolStorageRows, toolSetRows] = await Promise.all([
    fetchToolStorageRows(),
    fetchToolSetRows()
  ]);

  state.toolStorages = normalizeToolStorages(toolStorageRows);
  state.toolSets = normalizeToolSets(toolSetRows);
  state.toolStorageMap = new Map(state.toolStorages.map(k => [k.itemId, k]));
  state.toolSetMap = new Map(state.toolSets.map(set => [set.itemId, set]));

  initConfiguratorController(state, dragState);
}

if (!window.__TOOLKIT_CONFIGURATOR_DISABLE_AUTO_INIT__) {
  startConfiguratorApp().catch(err => {
    console.error(err);
    alert(t("configuratorDataCouldNotBeLoaded", "The configurator data could not be loaded."));
  });
}

exports.startConfiguratorApp = startConfiguratorApp;
});

__define("features/catalog/catalog-filters.js", (exports, __require) => {
const { t } = __require("shared/i18n/toolkit-i18n.js");
const { cleanString, escapeHtml } = __require("shared/utils/string-utils.js");
function buildToolStorageFilters(toolStorages) {
  const container = document.getElementById("toolStorageTypeFilters");
  if (!container) return;

  const types = Array.from(
    new Set((toolStorages || []).map((storage) => cleanString(storage.productType)).filter(Boolean)),
  ).sort((a, b) => a.localeCompare(b));

  if (!types.length) {
    container.innerHTML = `
      <span class="text-xs text-gray-500">${escapeHtml(t("noFiltersAvailable", "No filters available."))}</span>
    `;
    return;
  }

  container.innerHTML = types
    .map((type, index) => {
      const safeType = escapeHtml(type);
      const inputId = `toolStorageType-${index}`;

      return `
      <label class="inline-flex items-center gap-2 rounded-full border border-gray-200 px-3 py-1 text-xs font-semibold uppercase tracking-wide text-gray-600">
        <input id="${inputId}" type="checkbox" value="${safeType}" class="h-3 w-3 rounded border-gray-300 text-gray-900 focus:ring-gray-300" />
        <span>${safeType}</span>
      </label>
    `;
    })
    .join("");

  updateFilterSummaryIcon("toolStorageTypeFilters");
}

function filterToolStorages(toolStorages) {
  const searchInput = document.getElementById("toolStorageSearch");
  const query = cleanString(searchInput ? searchInput.value : "").toLowerCase();
  const selectedTypes = getSelectedToolStorageTypeFilters();

  return (toolStorages || []).filter((storage) => {
    if (query) {
      const includesText = Array.isArray(storage.includes) ? storage.includes.join(" ") : "";
      const haystack = `${storage.itemId} ${storage.description} ${storage.productType} ${storage.storageColour} ${includesText}`.toLowerCase();
      if (!haystack.includes(query)) return false;
    }

    if (selectedTypes.size && !selectedTypes.has(storage.productType)) return false;

    return true;
  });
}

function getSelectedToolStorageTypeFilters() {
  const container = document.getElementById("toolStorageTypeFilters");
  if (!container) return new Set();

  const checked = Array.from(container.querySelectorAll("input[type=\"checkbox\"]:checked"));
  return new Set(checked.map((input) => input.value));
}

function buildToolSetFilters(toolSets) {
  const container = document.getElementById("toolSetTypeFilters");
  if (!container) return;

  const types = Array.from(
    new Set((toolSets || []).map((set) => cleanString(set.typeOfSet)).filter(Boolean)),
  ).sort((a, b) => a.localeCompare(b));

  if (!types.length) {
    container.innerHTML = `
      <span class="text-xs text-gray-500">${escapeHtml(t("noFiltersAvailable", "No filters available."))}</span>
    `;
    return;
  }

  container.innerHTML = types
    .map((type, index) => {
      const safeType = escapeHtml(type);
      const inputId = `toolSetType-${index}`;

      return `
      <label class="inline-flex items-center gap-2 rounded-full border border-gray-200 px-3 py-1 text-xs font-semibold uppercase tracking-wide text-gray-600">
        <input id="${inputId}" type="checkbox" value="${safeType}" class="h-3 w-3 rounded border-gray-300 text-gray-900 focus:ring-gray-300" />
        <span>${safeType}</span>
      </label>
    `;
    })
    .join("");

  updateFilterSummaryIcon("toolSetTypeFilters");
}

function updateFilterSummaryIcon(containerId) {
  const container = document.getElementById(containerId);
  if (!container) return;

  const summary = document.querySelector(`summary[data-filter-summary="${containerId}"]`);
  if (!summary) return;

  const hasChecked = !!container.querySelector("input[type=\"checkbox\"]:checked");
  const inactiveIcon = summary.querySelector("[data-filter-icon=\"inactive\"]");
  const activeIcon = summary.querySelector("[data-filter-icon=\"active\"]");

  if (inactiveIcon) {
    inactiveIcon.classList.toggle("hidden", hasChecked);
  }
  if (activeIcon) {
    activeIcon.classList.toggle("hidden", !hasChecked);
  }
  summary.setAttribute("data-has-filters", hasChecked ? "true" : "false");
}

function filterToolSets(toolSets) {
  const searchInput = document.getElementById("toolSetSearch");
  const query = cleanString(searchInput ? searchInput.value : "").toLowerCase();
  const selectedTypes = getSelectedTypeFilters();

  return (toolSets || []).filter((set) => {
    if (query) {
      const haystack = `${set.itemId} ${set.altId || ""} ${set.description} ${set.typeOfSet}`.toLowerCase();
      if (!haystack.includes(query)) return false;
    }

    if (selectedTypes.size && !selectedTypes.has(set.typeOfSet)) return false;

    return true;
  });
}

function getSelectedTypeFilters() {
  const container = document.getElementById("toolSetTypeFilters");
  if (!container) return new Set();

  const checked = Array.from(container.querySelectorAll("input[type=\"checkbox\"]:checked"));
  return new Set(checked.map((input) => input.value));
}

exports.buildToolStorageFilters = buildToolStorageFilters;
exports.filterToolStorages = filterToolStorages;
exports.getSelectedToolStorageTypeFilters = getSelectedToolStorageTypeFilters;
exports.buildToolSetFilters = buildToolSetFilters;
exports.updateFilterSummaryIcon = updateFilterSummaryIcon;
exports.filterToolSets = filterToolSets;
exports.getSelectedTypeFilters = getSelectedTypeFilters;
});

__define("features/catalog/catalog-selection.js", (exports, __require) => {
const { t } = __require("shared/i18n/toolkit-i18n.js");
const { cleanString } = __require("shared/utils/string-utils.js");
const { parseSelectedToolStorageIds, resolveSelectedToolStorages, serializeSelectedToolStorageIds, validateToolStorageSelection } = __require("features/toolstorage-selection/toolstorage-selection-service.js");
function parseMultilineIds(value) {
  return cleanString(value)
    .split(/\r?\n/)
    .map(cleanString)
    .filter(Boolean);
}

function updateToolstorageCatalogButtons(state) {
  const container = document.getElementById("toolStorageCatalog");
  const input = document.getElementById("toolstorageInput");
  const toolStorageMap = state?.toolStorageMap;
  if (!container || !input || !toolStorageMap) return;

  const selectedIds = parseSelectedToolStorageIds(input.value);
  const selectedIdSet = new Set(selectedIds);
  const selectedStorages = resolveSelectedToolStorages(selectedIds, toolStorageMap);
  const buttons = container.querySelectorAll("[data-action=\"select-toolstorage\"]");
  const validCards = [];
  const invalidCards = [];

  buttons.forEach((button) => {
    const itemId = button.getAttribute("data-item-id");
    const storage = itemId ? toolStorageMap.get(itemId) : null;
    const isSelected = itemId ? selectedIdSet.has(itemId) : false;
    const validation = !storage || isSelected
      ? { valid: true, message: "" }
      : validateToolStorageSelection(selectedStorages.concat(storage));

    setToolStorageButtonState(button, {
      isSelected,
      isDisabled: !validation.valid,
      disabledMessage: validation.message,
    });

    const card = button.closest("[data-toolstorage-card]");
    if (!card) return;

    card.classList.add("border", "bg-white");
    card.classList.remove("bg-red-200");

    if (!validation.valid && !isSelected) {
      card.classList.add("bg-red-200");
      card.classList.remove("bg-white");
      invalidCards.push(card);
    } else {
      validCards.push(card);
    }
  });

  if (validCards.length || invalidCards.length) {
    const fragment = document.createDocumentFragment();
    validCards.forEach((card) => fragment.appendChild(card));
    invalidCards.forEach((card) => fragment.appendChild(card));
    container.appendChild(fragment);
  }
}

function updateCatalogButtons() {
  const container = document.getElementById("toolSetCatalog");
  const textarea = document.getElementById("toolsetsInput");
  if (!container || !textarea) return;

  const selected = new Set(parseMultilineIds(textarea.value));
  const buttons = container.querySelectorAll("[data-action=\"add-toolset\"]");
  buttons.forEach((button) => {
    const itemId = button.getAttribute("data-item-id");
    const isSelected = itemId ? selected.has(itemId) : false;
    setToolSetButtonState(button, isSelected);
  });
}

function updateToolstoragePreviewFromInput(state, value, { onPreviewChanged } = {}) {
  const toolstorageIds = parseSelectedToolStorageIds(value);
  if (!toolstorageIds.length) {
    onPreviewChanged?.([]);
    updateToolstorageCatalogButtons(state);
    return;
  }

  const toolstorages = resolveSelectedToolStorages(toolstorageIds, state.toolStorageMap);
  const validation = validateToolStorageSelection(toolstorages);
  if (!validation.valid) {
    onPreviewChanged?.([]);
    updateToolstorageCatalogButtons(state);
    return;
  }

  onPreviewChanged?.(toolstorages);
  updateToolstorageCatalogButtons(state);
}

function wireToolstorageCatalogButtons(
  state,
  { onPreviewChanged, onToolstorageCleared, onToolstorageReady } = {},
) {
  const container = document.getElementById("toolStorageCatalog");
  const input = document.getElementById("toolstorageInput");
  if (!container || !input) return;

  container.addEventListener("click", (event) => {
    const button = event.target.closest("[data-action=\"select-toolstorage\"]");
    if (!button) return;
    if (button.disabled) return;

    const itemId = button.getAttribute("data-item-id");
    if (!itemId) return;

    const currentIds = parseSelectedToolStorageIds(input.value);
    const isSelected = currentIds.includes(itemId);
    const nextIds = isSelected
      ? currentIds.filter((currentId) => currentId !== itemId)
      : currentIds.concat(itemId);
    const nextStorages = resolveSelectedToolStorages(nextIds, state.toolStorageMap);
    const validation = validateToolStorageSelection(nextStorages);
    if (!validation.valid) return;

    input.value = serializeSelectedToolStorageIds(nextStorages.map((storage) => storage.itemId));
    updateToolstoragePreviewFromInput(state, input.value, { onPreviewChanged });

    if (!nextStorages.length) {
      onToolstorageCleared?.();
      return;
    }

    onToolstorageReady?.();
  });
}

function wireCatalogButtons(state, { onSelectionChanged } = {}) {
  void state;

  const container = document.getElementById("toolSetCatalog");
  const textarea = document.getElementById("toolsetsInput");
  if (!container || !textarea) return;

  container.addEventListener("click", (event) => {
    const button = event.target.closest("[data-action=\"add-toolset\"]");
    if (!button) return;
    if (button.disabled) return;

    const itemId = button.getAttribute("data-item-id");
    if (!itemId) return;

    const ids = parseMultilineIds(textarea.value);
    // Allow duplicates: each click adds another instance of the same ItemId.
    const nextIds = ids.concat(itemId);

    textarea.value = nextIds.join("\n");
    textarea.focus();
    updateCatalogButtons();
    onSelectionChanged?.();
  });
}

function setToolSetButtonState(button, isSelected) {
  const iconPath = button.querySelector("path");
  const addClasses = ["border-gray-200", "bg-gray-100", "text-gray-700", "hover:bg-gray-300"];
  const selectedClasses = ["border-amber-500", "bg-amber-500", "text-white", "hover:bg-amber-600"];

  if (isSelected) {
    button.classList.remove(...addClasses);
    button.classList.add(...selectedClasses);
    button.setAttribute("aria-label", t("addAnother", "Add"));
    button.dataset.state = "added";
    if (iconPath) {
      iconPath.setAttribute("d", "M9 4a1 1 0 0 1 2 0v5h5a1 1 0 0 1 0 2h-5v5a1 1 0 1 1-2 0v-5H4a1 1 0 1 1 0-2h5V4z");
    }
    return;
  }

  button.classList.remove(...selectedClasses);
  button.classList.add(...addClasses);
  button.setAttribute("aria-label", t("addToList", "Add to list"));
  button.dataset.state = "add";
  if (iconPath) {
    iconPath.setAttribute("d", "M9 4a1 1 0 0 1 2 0v5h5a1 1 0 0 1 0 2h-5v5a1 1 0 1 1-2 0v-5H4a1 1 0 1 1 0-2h5V4z");
  }
}

function setToolStorageButtonState(button, { isSelected, isDisabled, disabledMessage }) {
  const iconPath = button.querySelector("path");
  const addClasses = ["border-gray-200", "bg-gray-100", "text-gray-700", "hover:bg-gray-300"];
  const selectedClasses = ["border-amber-500", "bg-amber-500", "text-white", "hover:bg-amber-600"];

  button.disabled = false;
  button.removeAttribute("aria-disabled");
  button.removeAttribute("title");
  button.classList.remove("opacity-40", "cursor-not-allowed");

  if (isSelected) {
    button.classList.remove(...addClasses);
    button.classList.add(...selectedClasses);
    button.setAttribute("aria-label", t("selected", "Selected"));
    button.dataset.state = "selected";
    if (iconPath) {
      iconPath.setAttribute("d", "M7.5 13.5 3.5 9.5 4.9 8.1 7.5 10.7 15.1 3.1 16.5 4.5z");
    }
    return;
  }

  button.classList.remove(...selectedClasses);
  button.classList.add(...addClasses);
  button.setAttribute("aria-label", t("selectToolStorage", "Select tool storage"));
  button.dataset.state = "select";
  if (iconPath) {
    iconPath.setAttribute("d", "M9 4a1 1 0 0 1 2 0v5h5a1 1 0 0 1 0 2h-5v5a1 1 0 1 1-2 0v-5H4a1 1 0 1 1 0-2h5V4z");
  }

  if (!isDisabled) return;

  button.disabled = true;
  button.setAttribute("aria-disabled", "true");
  button.setAttribute("title", disabledMessage || t("invalidToolStorageSelection", "This storage selection is not allowed."));
  button.classList.add("opacity-40", "cursor-not-allowed");
  button.classList.remove("hover:bg-gray-300", "hover:bg-amber-600");
}

exports.updateToolstorageCatalogButtons = updateToolstorageCatalogButtons;
exports.updateCatalogButtons = updateCatalogButtons;
exports.updateToolstoragePreviewFromInput = updateToolstoragePreviewFromInput;
exports.wireToolstorageCatalogButtons = wireToolstorageCatalogButtons;
exports.wireCatalogButtons = wireCatalogButtons;
});

__define("features/catalog/toolset-catalog-view.js", (exports, __require) => {
const { t } = __require("shared/i18n/toolkit-i18n.js");
const { cleanString, escapeHtml } = __require("shared/utils/string-utils.js");
const { buildDrawersForStorages } = __require("features/drawer-layout/drawer-layout-service.js");
const { buildMaxRectsState } = __require("features/drawer-layout/maxrects-service.js");
const { canDrawerAcceptSetWeight } = __require("features/drawer-layout/drawer-weight-service.js");
const { buildToolStorageSelectionKey, parseSelectedToolStorageIds, resolveSelectedToolStorages } = __require("features/toolstorage-selection/toolstorage-selection-service.js");
function doesSetFitAnyDrawer(set, drawerStates) {
  const width = set?.setWidth;
  const depth = set?.setDepth;
  const height = set?.setHeight;

  // Only flag as "cannot fit" when dimensions are known and positive.
  if (!Number.isFinite(width) || !Number.isFinite(depth) || !Number.isFinite(height)) return true;
  if (width <= 0 || depth <= 0 || height <= 0) return true;

  return (drawerStates || []).some(({ drawer, freeRects }) => {
    if (drawer?.locked) return false;

    const drawerHeight = drawer?.drawerHeight ?? 0;
    if (height > drawerHeight) return false;
    if (!canDrawerAcceptSetWeight(drawer, set)) return false;

    return (freeRects || []).some((rect) => width <= rect.width && depth <= rect.height);
  });
}

function setAddButtonDisabled(button, isDisabled) {
  if (!button) return;

  const disabled = Boolean(isDisabled);
  button.disabled = disabled;

  if (disabled) {
    button.setAttribute("aria-disabled", "true");
    button.setAttribute("title", t("doesNotFitCurrentDrawerLayout", "Does not fit in the current drawer layout."));
    button.classList.add("opacity-40", "cursor-not-allowed");
    button.classList.remove("hover:bg-gray-100", "hover:bg-amber-600");
    return;
  }

  button.removeAttribute("aria-disabled");
  button.removeAttribute("title");
  button.classList.remove("opacity-40", "cursor-not-allowed");
  if (button.classList.contains("bg-amber-500")) {
    button.classList.add("hover:bg-amber-600");
  } else {
    button.classList.add("hover:bg-gray-100");
  }
}

function updateToolSetCatalogFitBorders(state) {
  const container = document.getElementById("toolSetCatalog");
  if (!container) return;

  const toolstorageInput = document.getElementById("toolstorageInput");
  const toolstorageIds = parseSelectedToolStorageIds(toolstorageInput?.value);
  const toolstorages = resolveSelectedToolStorages(toolstorageIds, state?.toolStorageMap || new Map());

  const setMap = state?.toolSetMap;
  const hasCurrentLayout =
    toolstorages.length &&
    state?.currentToolstorageSelectionKey === buildToolStorageSelectionKey(toolstorages) &&
    Array.isArray(state?.currentDrawers) &&
    state.currentDrawers.length > 0;
  const drawers = toolstorages.length ? (hasCurrentLayout ? state.currentDrawers : buildDrawersForStorages(toolstorages)) : null;
  const drawerStates = (drawers || []).map((drawer) => ({ drawer, freeRects: buildMaxRectsState(drawer) }));

  const okCards = [];
  const warnCards = [];

  container.querySelectorAll("[data-toolset-card]").forEach((card) => {
    const itemId = card.getAttribute("data-item-id") || "";

    const shouldWarn = Boolean(
      toolstorages.length &&
      setMap &&
      itemId &&
      !doesSetFitAnyDrawer(setMap.get(itemId), drawerStates),
    );

    const addButton = card.querySelector("[data-action=\"add-toolset\"]");
    setAddButtonDisabled(addButton, shouldWarn);

    card.classList.add("border", "bg-white");
    card.classList.remove("bg-red-200");
    if (shouldWarn) {
      card.classList.add("bg-red-200");
      card.classList.remove("bg-white");
      warnCards.push(card);
    } else {
      card.classList.add("bg-white");
      card.classList.remove("bg-red-200");
      okCards.push(card);
    }
  });

  // Keep existing order within each group, but ensure "cannot fit" cards render last.
  if (okCards.length || warnCards.length) {
    const fragment = document.createDocumentFragment();
    okCards.forEach((card) => fragment.appendChild(card));
    warnCards.forEach((card) => fragment.appendChild(card));
    container.appendChild(fragment);
  }
}

function renderToolSetCatalog(toolSets) {
  const container = document.getElementById("toolSetCatalog");
  if (!container) return;

  if (!toolSets.length) {
    container.innerHTML = `
      <div class="rounded-lg border border-gray-200 bg-white p-6 text-center text-sm text-gray-500">
        ${escapeHtml(t("noToolSetsMatchFilters", "No tool sets match your filters."))}
      </div>
    `;
    return;
  }

  const cards = toolSets
    .map((set) => {
      const description = escapeHtml(set.description || t("toolSet", "Tool set"));
      const itemId = escapeHtml(set.itemId || "");
      const imageUrl = escapeHtml(set.itemImageUrl || "data/imgsource.png");
      const imageAlt = escapeHtml(`${set.description || t("toolSet", "Tool set")} ${set.itemId || ""}`.trim());

      return `
      <div class="relative flex w-full flex-col overflow-hidden border border-gray-100 bg-white" data-toolset-card="1" data-item-id="${itemId}">
        <a class="relative mx-auto mt-3 flex w-full max-w-[140px] aspect-[8/7] items-center justify-center overflow-hidden sm:max-w-[160px]" href="#" data-action="open-product-modal" data-item-type="toolset" data-item-id="${itemId}">
          <img class="h-full w-full object-contain" src="${imageUrl}" alt="${imageAlt}" loading="lazy" />
        </a>

        <div class="mt-3 px-3 pb-3">
          <a href="#">
            <h5 class="text-xs font-semibold uppercase tracking-wide text-gray-900 leading-tight">
              ${description}
            </h5>
          </a>

          <div class="flex items-center justify-between gap-3 pt-2">
            <div class="min-w-0 print:break-inside-avoid">
              <ul class="grid gap-1">
                <li class="grid gap-x-3 text-xs leading-tight">
                  <span class="text-gray-600">${itemId}</span>
                </li>
              </ul>
            </div>
            <button
              class="inline-flex h-8 w-8 items-center justify-center rounded-full border border-gray-200 bg-gray-100 text-gray-700 transition hover:bg-gray-300"
              type="button"
              aria-label="${escapeHtml(t("addToList", "Add to list"))}"
              data-action="add-toolset"
              data-item-id="${itemId}"
            >
              <svg viewBox="0 0 20 20" aria-hidden="true" class="h-4 w-4 fill-current">
                <path d="M9 4a1 1 0 0 1 2 0v5h5a1 1 0 0 1 0 2h-5v5a1 1 0 1 1-2 0v-5H4a1 1 0 1 1 0-2h5V4z"></path>
              </svg>
            </button>
          </div>
        </div>
      </div>
    `;
    })
    .join("");

  container.innerHTML = cards;
}

exports.updateToolSetCatalogFitBorders = updateToolSetCatalogFitBorders;
exports.renderToolSetCatalog = renderToolSetCatalog;
});

__define("features/catalog/toolstorage-catalog-view.js", (exports, __require) => {
const { t } = __require("shared/i18n/toolkit-i18n.js");
const { escapeHtml } = __require("shared/utils/string-utils.js");
function renderToolStorageCatalog(toolStorages) {
  const container = document.getElementById("toolStorageCatalog");
  if (!container) return;

  if (!toolStorages.length) {
    container.innerHTML = `
      <div class="rounded-lg border border-gray-200 bg-white p-6 text-center text-sm text-gray-500">
        ${escapeHtml(t("noToolStoragesMatchFilters", "No tool storages match your filters."))}
      </div>
    `;
    return;
  }

  const cards = toolStorages
    .map((storage) => {
      const description = escapeHtml(storage.description || t("toolStorage", "Tool storage"));
      const itemId = escapeHtml(storage.itemId || "");
      const productType = escapeHtml(storage.productType || t("toolStorage", "Tool storage"));
      const imageUrl = escapeHtml(storage.itemImageUrl || "data/imgsource.png");
      const imageAlt = escapeHtml(`${storage.description || t("toolStorage", "Tool storage")} ${storage.itemId || ""}`.trim());

      return `
      <div class="relative flex w-full flex-col overflow-hidden border border-gray-100 bg-white" data-toolstorage-card="1" data-item-id="${itemId}">
        <a class="relative mx-auto mt-3 flex w-full max-w-[140px] aspect-[8/7] items-center justify-center overflow-hidden sm:max-w-[160px]" href="#" data-action="open-product-modal" data-item-type="toolstorage" data-item-id="${itemId}">
          <img class="h-full w-full object-contain" src="${imageUrl}" alt="${imageAlt}" loading="lazy" />
        </a>

        <div class="mt-3 px-3 pb-3">
          <a href="#">
            <h5 class="text-xs font-semibold uppercase tracking-wide text-gray-900 leading-tight">
              ${description}
            </h5>
          </a>

          <div class="flex items-center justify-between gap-3 pt-2">
            <div class="min-w-0 print:break-inside-avoid">
              <ul class="grid gap-1">
                <li class="grid gap-x-3 text-[10px] font-semibold uppercase tracking-wide leading-tight">
                  <span class="text-gray-600">${productType}</span>
                </li>
                <li class="grid gap-x-3 text-xs leading-tight">
                  <span class="text-gray-600">${itemId}</span>
                </li>
              </ul>
            </div>
            <button
              class="inline-flex h-8 w-8 items-center justify-center rounded-full border border-gray-200 bg-gray-100 text-gray-700 transition hover:bg-gray-300"
              type="button"
              aria-label="${escapeHtml(t("selectToolStorage", "Select tool storage"))}"
              data-action="select-toolstorage"
              data-item-id="${itemId}"
            >
              <svg viewBox="0 0 20 20" aria-hidden="true" class="h-4 w-4 fill-current">
                <path d="M9 4a1 1 0 0 1 2 0v5h5a1 1 0 0 1 0 2h-5v5a1 1 0 1 1-2 0v-5H4a1 1 0 1 1 0-2h5V4z"></path>
              </svg>
            </button>
          </div>
        </div>
      </div>
    `;
    })
    .join("");

  container.innerHTML = cards;
}

exports.renderToolStorageCatalog = renderToolStorageCatalog;
});

__define("features/configurator/configurator-controller.js", (exports, __require) => {
const { byId, getTrimmedValue } = __require("shared/dom/dom-helpers.js");
const { t } = __require("shared/i18n/toolkit-i18n.js");
const { cleanString } = __require("shared/utils/string-utils.js");
const { closeExportTableModal, copyExportTable, handleLoadFromJson, handlePrintToPdf, handleSaveToJson, openExportTableModal, wireExportTableModal } = __require("features/configurator/configurator-persistence.js");
const { fitSetsIntoDrawers, fitSetsIntoExistingLayout } = __require("features/drawer-layout/drawer-fit-service.js");
const { wireDrawerHoverHighlight } = __require("features/drawer-layout/drawer-hover-highlight.js");
const { buildDrawersForStorage, buildDrawersForStorages, resolveSelectedSets } = __require("features/drawer-layout/drawer-layout-service.js");
const { wireDragAndDrop } = __require("features/drawer-layout/drawer-drag-drop.js");
const { renderConfiguration, renderEmptyState, renderSelectedToolstorage } = __require("features/drawer-layout/drawer-renderer.js");
const { buildToolStorageFilters, buildToolSetFilters, filterToolStorages, filterToolSets, updateFilterSummaryIcon } = __require("features/catalog/catalog-filters.js");
const { updateCatalogButtons, updateToolstorageCatalogButtons, wireCatalogButtons, wireToolstorageCatalogButtons } = __require("features/catalog/catalog-selection.js");
const { renderToolStorageCatalog } = __require("features/catalog/toolstorage-catalog-view.js");
const { renderToolSetCatalog, updateToolSetCatalogFitBorders } = __require("features/catalog/toolset-catalog-view.js");
const { wireFabActions } = __require("features/fab-actions/fab-actions.js");
const { wireProductModal } = __require("features/product-details/product-detail-modal.js");
const { wirePredefinedToolKitModal } = __require("features/tool-kits/predefined-tool-kit-modal.js");
const { buildToolStorageSelectionKey, parseSelectedToolStorageIds, resolveSelectedToolStorages, validateToolStorageSelection } = __require("features/toolstorage-selection/toolstorage-selection-service.js");
const { initTabsUI } = __require("features/tabs/tabs-ui.js");
const { canReconcileStoragesWithExistingLayout, reconcileDrawersWithSelectedStorages } = __require("features/configurator/configurator-layout-reconcile.js");
const { wireDismissibleHint, wireOutsideDetailsClose, wirePrintDetailsOpen } = __require("features/configurator/configurator-ui-wiring.js");
function parseMultilineIds(value) {
  return cleanString(value)
    .split(/\r?\n/)
    .map(cleanString)
    .filter(Boolean);
}

function initConfiguratorController(state, dragState) {
  wireEvents(state, dragState);

  renderEmptyState();
  buildToolStorageFilters(state.toolStorages);
  renderFilteredToolStorages(state);
  buildToolSetFilters(state.toolSets);
  renderFilteredToolSets(state);
}

function wireEvents(state, dragState) {
  initTabsUI();
  wireFabActions();
  wirePrintDetailsOpen();
  wireDismissibleHint();

  const form = byId("toolstorageForm");
  if (form) {
    form.addEventListener("submit", (event) => event.preventDefault());
  }

  byId("recommendBtn").addEventListener("click", () => handleRenderConfiguration(state));
  byId("printToPdf").addEventListener("click", handlePrintToPdf);
  byId("saveToJson").addEventListener("click", () => handleSaveToJson(state));
  byId("loadFromJson").addEventListener("click", () => handleLoadFromJson(state));
  wirePredefinedToolKitModal(state);

  const exportBtn = byId("exportTableBtn");
  if (exportBtn) {
    exportBtn.addEventListener("click", () => openExportTableModal(state));
  }

  wireProductModal(state);
  wireToolstorageCatalogButtons(state, {
    onPreviewChanged: (toolstorage) => renderSelectedToolstorage(toolstorage),
    onToolstorageCleared: () => {
      state.currentDrawers = [];
      state.currentUnplacedSets = [];
      state.currentErrors = [];
      state.currentToolstorageSelectionKey = "";
      renderEmptyState();
      updateToolSetCatalogFitBorders(state);
    },
    onToolstorageReady: () => renderIfToolstorageReady(state),
  });
  wireCatalogButtons(state, { onSelectionChanged: () => renderIfToolstorageReady(state) });

  wireDragAndDrop(state, dragState, {
    onSelectionChanged: () => {
      updateCatalogButtons(state);
      renderIfToolstorageReady(state);
    },
  });
  wireDrawerHoverHighlight();

  wireOutsideDetailsClose();

  const toolsetInput = byId("toolsetsInput");
  if (toolsetInput) {
    toolsetInput.addEventListener("input", () => updateCatalogButtons(state));
  }

  const toolStorageSearch = byId("toolStorageSearch");
  if (toolStorageSearch) {
    toolStorageSearch.addEventListener("input", () => renderFilteredToolStorages(state));
  }

  const toolStorageTypeFilters = byId("toolStorageTypeFilters");
  if (toolStorageTypeFilters) {
    toolStorageTypeFilters.addEventListener("change", () => {
      renderFilteredToolStorages(state);
      updateFilterSummaryIcon("toolStorageTypeFilters");
    });
  }

  const toolStorageClearFilters = byId("toolStorageClearFilters");
  if (toolStorageClearFilters) {
    toolStorageClearFilters.addEventListener("click", () => {
      if (toolStorageSearch) toolStorageSearch.value = "";
      if (toolStorageTypeFilters) {
        toolStorageTypeFilters.querySelectorAll("input[type=\"checkbox\"]").forEach((input) => {
          input.checked = false;
        });
      }
      renderFilteredToolStorages(state);
      updateFilterSummaryIcon("toolStorageTypeFilters");
    });
  }

  const toolSetSearch = byId("toolSetSearch");
  if (toolSetSearch) {
    toolSetSearch.addEventListener("input", () => renderFilteredToolSets(state));
  }

  const toolSetTypeFilters = byId("toolSetTypeFilters");
  if (toolSetTypeFilters) {
    toolSetTypeFilters.addEventListener("change", () => {
      renderFilteredToolSets(state);
      updateFilterSummaryIcon("toolSetTypeFilters");
    });
  }

  const clearFilters = byId("toolSetClearFilters");
  if (clearFilters) {
    clearFilters.addEventListener("click", () => {
      if (toolSetSearch) toolSetSearch.value = "";
      if (toolSetTypeFilters) {
        toolSetTypeFilters.querySelectorAll("input[type=\"checkbox\"]").forEach((input) => {
          input.checked = false;
        });
      }
      renderFilteredToolSets(state);
      updateFilterSummaryIcon("toolSetTypeFilters");
    });
  }

  const exportClose = byId("exportTableClose");
  if (exportClose) {
    exportClose.addEventListener("click", closeExportTableModal);
  }

  const exportCopy = byId("exportTableCopy");
  if (exportCopy) {
    exportCopy.addEventListener("click", copyExportTable);
  }

  wireExportTableModal();
}

function handleRenderConfiguration(state) {
  const toolstorageIds = parseSelectedToolStorageIds(getTrimmedValue("toolstorageInput"));
  const toolstorages = resolveSelectedToolStorages(toolstorageIds, state.toolStorageMap);

  if (!toolstorages.length) {
    alert(t("pleaseEnterValidToolStorageId", "Please enter a valid tool storage ID."));
    return;
  }

  const selectionValidation = validateToolStorageSelection(toolstorages);
  if (!selectionValidation.valid) {
    alert(selectionValidation.message || t("invalidToolStorageSelection", "This storage selection is not allowed."));
    updateToolstorageCatalogButtons(state);
    return;
  }

  renderSelectedToolstorage(toolstorages);

  const manualSetIds = parseMultilineIds(byId("toolsetsInput")?.value);
  const selectedSets = resolveSelectedSets(manualSetIds, state.toolSets);
  const drawers = buildDrawersForStorages(toolstorages);
  const selectionKey = buildToolStorageSelectionKey(toolstorages);

  if (!drawers.length) {
    state.currentDrawers = [];
    state.currentUnplacedSets = selectedSets;
    state.currentErrors = [];
    state.currentToolstorageSelectionKey = selectionKey;
    renderConfiguration(state.currentDrawers, state.currentUnplacedSets, state.currentErrors);
    updateToolSetCatalogFitBorders(state);
    return;
  }

  const canPreserveOrder = state.currentToolstorageSelectionKey === selectionKey && state.currentDrawers.length;
  const canReconcileExistingLayout = !canPreserveOrder && canReconcileStoragesWithExistingLayout(state.currentDrawers, toolstorages);

  if (!canPreserveOrder) {
    if (canReconcileExistingLayout) {
      const reconciledDrawers = reconcileDrawersWithSelectedStorages(state.currentDrawers, toolstorages);
      const reconciledResult = fitSetsIntoExistingLayout(reconciledDrawers, selectedSets);
      state.currentDrawers = reconciledResult.drawers;
      state.currentUnplacedSets = reconciledResult.unplacedSets;
      state.currentErrors = reconciledResult.errors;
      state.currentToolstorageSelectionKey = selectionKey;
      renderConfiguration(state.currentDrawers, state.currentUnplacedSets, state.currentErrors);
      updateToolSetCatalogFitBorders(state);
      return;
    }

    const result = fitSetsIntoDrawers(drawers, selectedSets);
    state.currentDrawers = result.drawers;
    state.currentUnplacedSets = result.unplacedSets;
    state.currentErrors = result.errors;
    state.currentToolstorageSelectionKey = selectionKey;
    renderConfiguration(state.currentDrawers, state.currentUnplacedSets, state.currentErrors);
    updateToolSetCatalogFitBorders(state);
    return;
  }

  const preservedResult = fitSetsIntoExistingLayout(state.currentDrawers, selectedSets);
  state.currentDrawers = preservedResult.drawers;
  state.currentUnplacedSets = preservedResult.unplacedSets;
  state.currentErrors = preservedResult.errors;
  state.currentToolstorageSelectionKey = selectionKey;
  renderConfiguration(state.currentDrawers, state.currentUnplacedSets, state.currentErrors);
  updateToolSetCatalogFitBorders(state);
}

function renderIfToolstorageReady(state) {
  const toolstorageIds = parseSelectedToolStorageIds(getTrimmedValue("toolstorageInput"));
  if (!toolstorageIds.length) return;
  const toolstorages = resolveSelectedToolStorages(toolstorageIds, state.toolStorageMap);
  if (!toolstorages.length) return;
  handleRenderConfiguration(state);
}

function renderFilteredToolStorages(state) {
  const filtered = filterToolStorages(state.toolStorages);
  renderToolStorageCatalog(filtered);
  updateToolstorageCatalogButtons(state);
}

function renderFilteredToolSets(state) {
  const filtered = filterToolSets(state.toolSets);
  renderToolSetCatalog(filtered);
  updateCatalogButtons(state);
  updateToolSetCatalogFitBorders(state);
}

exports.initConfiguratorController = initConfiguratorController;
});

__define("features/configurator/configurator-download-modal.js", (exports, __require) => {
const { t } = __require("shared/i18n/toolkit-i18n.js");
let downloadModalWired = false;
let activeDownload = null;
let activeDownloadCleanupTimer = null;

function tryCopyToClipboard(text) {
  if (!navigator.clipboard?.writeText) return false;
  navigator.clipboard.writeText(text).catch(() => {});
  return true;
}

function scheduleUrlRevoke(url, delayMs = 60_000) {
  if (!url) return;
  setTimeout(() => {
    try {
      URL.revokeObjectURL(url);
    } catch {
      // ignore
    }
  }, delayMs);
}

function closeDownloadConfigModal({ revokeUrl = true } = {}) {
  const modal = document.getElementById("downloadConfigModal");
  if (!modal) return;
  modal.classList.add("hidden");
  modal.classList.remove("flex");

  const status = document.getElementById("downloadConfigStatus");
  if (status) status.textContent = "";

  if (activeDownloadCleanupTimer) {
    clearTimeout(activeDownloadCleanupTimer);
    activeDownloadCleanupTimer = null;
  }

  if (!activeDownload) return;
  const url = activeDownload.url;
  activeDownload = null;

  if (!revokeUrl || !url) return;
  scheduleUrlRevoke(url, 1_000);
}

function openDownloadConfigModal({ url, fileName, json }) {
  const modal = document.getElementById("downloadConfigModal");
  if (!modal) return;

  if (!downloadModalWired) {
    downloadModalWired = true;

    const closeBtn = document.getElementById("downloadConfigClose");
    if (closeBtn) closeBtn.addEventListener("click", () => closeDownloadConfigModal());

    modal.addEventListener("click", (event) => {
      if (event.target === modal) closeDownloadConfigModal();
    });

    const copyBtn = document.getElementById("downloadConfigCopy");
    if (copyBtn) {
      copyBtn.addEventListener("click", async () => {
        const status = document.getElementById("downloadConfigStatus");
        const text = activeDownload?.json || "";
        if (!text) return;

        try {
          if (navigator.clipboard?.writeText) {
            await navigator.clipboard.writeText(text);
            if (status) status.textContent = t("copied", "Copied.");
          } else {
            if (status) status.textContent = t("clipboardUnavailable", "Clipboard unavailable in this browser.");
          }
        } catch {
          if (status) status.textContent = t("copyFailed", "Copy failed.");
        }
      });
    }
  }

  if (activeDownload?.url && activeDownload.url !== url) {
    try {
      URL.revokeObjectURL(activeDownload.url);
    } catch {
      // ignore
    }
  }

  activeDownload = { url, fileName, json };

  const link = document.getElementById("downloadConfigLink");
  if (link) {
    link.href = url;
    link.setAttribute("download", fileName || "configuration.txt");
  }

  const nameEl = document.getElementById("downloadConfigFileName");
  if (nameEl) nameEl.textContent = fileName || "";

  modal.classList.remove("hidden");
  modal.classList.add("flex");

  if (activeDownloadCleanupTimer) clearTimeout(activeDownloadCleanupTimer);
  activeDownloadCleanupTimer = setTimeout(() => closeDownloadConfigModal({ revokeUrl: true }), 10 * 60_000);
}

function openReadableExportFallback({ fileName, json }) {
  const html = `<!doctype html>
<meta charset="utf-8">
<meta name="viewport" content="width=device-width,initial-scale=1">
<title>${fileName.replace(/</g, "&lt;")}</title>
<style>
  body{margin:0;font:14px/1.4 ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace}
  header{padding:12px 14px;border-bottom:1px solid #e5e7eb}
  pre{margin:0;padding:14px;white-space:pre-wrap;word-break:break-word}
  .hint{color:#6b7280;font:12px/1.4 system-ui,-apple-system,Segoe UI,Roboto,Ubuntu,Cantarell,Noto Sans,sans-serif}
  code{font:inherit}
</style>
<header>
  <div><strong>${t("exportGenerated", "Export generated")}</strong></div>
  <div class="hint">${t("downloadMobileHint", "If downloading fails on mobile, use browser Share/Save from this page, or copy the JSON below.")}</div>
</header>
<pre><code>${json.replace(/</g, "&lt;")}</code></pre>`;
  const blob = new Blob([html], { type: "text/html;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  window.open(url, "_blank", "noopener,noreferrer");
  scheduleUrlRevoke(url);
  tryCopyToClipboard(json);
}

function openManualDownloadModal({ blob, fileName, json }) {
  const url = URL.createObjectURL(blob);
  openDownloadConfigModal({ url, fileName, json });
}

function triggerProgrammaticDownload({ blob, fileName }) {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");

  link.href = url;
  link.download = fileName;
  link.rel = "noopener";
  document.body.appendChild(link);
  link.click();

  setTimeout(() => link.remove(), 2_000);
  scheduleUrlRevoke(url);
}

exports.closeDownloadConfigModal = closeDownloadConfigModal;
exports.openDownloadConfigModal = openDownloadConfigModal;
exports.openReadableExportFallback = openReadableExportFallback;
exports.openManualDownloadModal = openManualDownloadModal;
exports.triggerProgrammaticDownload = triggerProgrammaticDownload;
});

__define("features/configurator/configurator-export-debug.js", (exports, __require) => {
function isDebugExportEnabled() {
  try {
    return (
      new URLSearchParams(window.location.search).has("debugExport") ||
      window.localStorage?.getItem("debugExport") === "1"
    );
  } catch {
    return false;
  }
}

function logExportDebug(...args) {
  if (!isDebugExportEnabled()) return;
  console.info("[configurator:export]", ...args);
}

function logImportDebug(...args) {
  if (!isDebugExportEnabled()) return;
  console.info("[configurator:import]", ...args);
}

exports.isDebugExportEnabled = isDebugExportEnabled;
exports.logExportDebug = logExportDebug;
exports.logImportDebug = logImportDebug;
});

__define("features/configurator/configurator-export-service.js", (exports, __require) => {
const { t } = __require("shared/i18n/toolkit-i18n.js");
const { getTrimmedValue } = __require("shared/dom/dom-helpers.js");
const { serializeSelectedToolStorageIds, parseSelectedToolStorageIds } = __require("features/toolstorage-selection/toolstorage-selection-service.js");
const { logExportDebug } = __require("features/configurator/configurator-export-debug.js");
const { openManualDownloadModal, openReadableExportFallback, triggerProgrammaticDownload } = __require("features/configurator/configurator-download-modal.js");
const EXPORT_STRATEGY = Object.freeze({
  FILE_PICKER: "file-picker",
  PROGRAMMATIC_DOWNLOAD: "programmatic-download",
  MANUAL_DOWNLOAD_MODAL: "manual-download-modal",
  READABLE_PAGE_FALLBACK: "readable-page-fallback",
});

function supportsDownloadAttribute() {
  try {
    return typeof HTMLAnchorElement !== "undefined" && "download" in HTMLAnchorElement.prototype;
  } catch {
    return false;
  }
}

function isProbablyIOS() {
  try {
    const ua = navigator.userAgent || "";
    return /iPad|iPhone|iPod/i.test(ua);
  } catch {
    return false;
  }
}

function isProbablyAndroid() {
  try {
    const ua = navigator.userAgent || "";
    return /Android/i.test(ua);
  } catch {
    return false;
  }
}

function isLikelyMobile() {
  if (isProbablyIOS() || isProbablyAndroid()) return true;
  try {
    if (window.matchMedia?.("(pointer: coarse)").matches) return true;
  } catch {
    // ignore
  }
  return false;
}

function buildExportArtifacts(state) {
  const payload = buildConfigPayload(state);
  const json = JSON.stringify(payload, null, 2);
  const fileName = `tengtools-tool-storage-configuration-${getTimestampForFilename()}.txt`;
  const blob = new Blob([json], { type: "text/plain;charset=utf-8" });

  return { blob, fileName, json };
}

function getExportEnvironment() {
  const isIOS = isProbablyIOS();
  const supportsDownload = supportsDownloadAttribute();

  return {
    isIOS,
    isLikelyMobile: isLikelyMobile(),
    showSaveFilePicker: "showSaveFilePicker" in window,
    supportsDownloadAttribute: supportsDownload,
    userActivation:
      typeof navigator !== "undefined" && navigator.userActivation
        ? { isActive: navigator.userActivation.isActive, hasBeenActive: navigator.userActivation.hasBeenActive }
        : "n/a",
  };
}

function chooseExportStrategy(environment) {
  if (environment.showSaveFilePicker) return EXPORT_STRATEGY.FILE_PICKER;
  if (environment.isIOS || !environment.supportsDownloadAttribute) {
    return EXPORT_STRATEGY.READABLE_PAGE_FALLBACK;
  }
  if (environment.isLikelyMobile) return EXPORT_STRATEGY.MANUAL_DOWNLOAD_MODAL;
  return EXPORT_STRATEGY.PROGRAMMATIC_DOWNLOAD;
}

async function saveWithFilePicker({ blob, fileName }) {
  try {
    const handle = await window.showSaveFilePicker({
      suggestedName: fileName,
      excludeAcceptAllOption: true,
      types: [
        {
          description: t("configurationExportTxt", "Configuration export (.txt)"),
          accept: {
            "text/plain": [".txt"],
          },
        },
      ],
    });

    const writable = await handle.createWritable();
    await writable.write(blob);
    await writable.close();

    if (typeof handle.getFile === "function") {
      try {
        const saved = await handle.getFile();
        logExportDebug("saved.size", saved?.size);
      } catch (err) {
        logExportDebug("handle.getFile failed", err);
      }
    }

    return true;
  } catch (err) {
    if (err.name !== "AbortError") {
      console.error(t("failedToSaveFile", "Failed to save file:"), err);
    }
    return true;
  }
}

function buildConfigPayload(state) {
  const selectedToolStorageIds = parseSelectedToolStorageIds(getTrimmedValue("toolstorageInput"));
  const serializedToolStorageIds = serializeSelectedToolStorageIds(selectedToolStorageIds);

  const drawers = (state.currentDrawers || []).map((drawer) => {
    const orderedPlacements = (drawer.placements || [])
      .slice()
      .sort((a, b) => (a.y - b.y) || (a.x - b.x));

    return {
      drawerIndex: drawer.drawerIndex,
      locked: Boolean(drawer.locked),
      sets: orderedPlacements.map((placement) => ({
        itemId: placement.set?.itemId || "",
        x: placement.x,
        y: placement.y,
        width: placement.width,
        depth: placement.depth,
      })),
    };
  });

  return {
    toolstorageIds: serializedToolStorageIds,
    toolstorageId: selectedToolStorageIds[0] || "",
    toolsetIds: document.getElementById("toolsetsInput").value,
    version: 3,
    savedAt: new Date().toISOString(),
    drawers,
  };
}

function getTimestampForFilename() {
  const pad = (value) => String(value).padStart(2, "0");
  const now = new Date();
  const yyyy = now.getFullYear();
  const mm = pad(now.getMonth() + 1);
  const dd = pad(now.getDate());
  const hh = pad(now.getHours());
  const min = pad(now.getMinutes());
  const ss = pad(now.getSeconds());
  return `${yyyy}${mm}${dd}-${hh}${min}${ss}`;
}

function handlePrintToPdf() {
  window.print();
}

async function handleSaveToJson(state) {
  const exportArtifacts = buildExportArtifacts(state);
  const environment = getExportEnvironment();
  const strategy = chooseExportStrategy(environment);

  logExportDebug(
    "strategy",
    strategy,
    "json.length",
    exportArtifacts.json.length,
    "blob.size",
    exportArtifacts.blob.size,
    "fileName",
    exportArtifacts.fileName,
  );
  logExportDebug(
    "downloadAttr",
    environment.supportsDownloadAttribute,
    "isIOS",
    environment.isIOS,
    "userActivation",
    environment.userActivation,
  );

  switch (strategy) {
    case EXPORT_STRATEGY.FILE_PICKER:
      await saveWithFilePicker(exportArtifacts);
      return;
    case EXPORT_STRATEGY.MANUAL_DOWNLOAD_MODAL:
      openManualDownloadModal(exportArtifacts);
      return;
    case EXPORT_STRATEGY.READABLE_PAGE_FALLBACK:
      openReadableExportFallback(exportArtifacts);
      return;
    case EXPORT_STRATEGY.PROGRAMMATIC_DOWNLOAD:
      triggerProgrammaticDownload(exportArtifacts);
      return;
    default:
      openReadableExportFallback(exportArtifacts);
  }
}

exports.handleSaveToJson = handleSaveToJson;
exports.handlePrintToPdf = handlePrintToPdf;
});

__define("features/configurator/configurator-export-table-modal.js", (exports, __require) => {
const { getTrimmedValue } = __require("shared/dom/dom-helpers.js");
const { t } = __require("shared/i18n/toolkit-i18n.js");
const { cleanString, uniquePreserveOrder } = __require("shared/utils/string-utils.js");
const { parseSelectedToolStorageIds, resolveSelectedToolStorages } = __require("features/toolstorage-selection/toolstorage-selection-service.js");
function parseMultilineIds(value) {
  return cleanString(value)
    .split(/\r?\n/)
    .map(cleanString)
    .filter(Boolean);
}

function openExportTableModal(state) {
  const modal = document.getElementById("exportTableModal");
  const textarea = document.getElementById("exportTableText");
  const status = document.getElementById("exportTableStatus");
  if (!modal || !textarea) return;

  textarea.value = buildExportTableText(state);
  if (status) status.textContent = "";

  modal.classList.remove("hidden");
  modal.classList.add("flex");
  textarea.focus();
  textarea.select();
}

function closeExportTableModal() {
  const modal = document.getElementById("exportTableModal");
  if (!modal) return;
  modal.classList.add("hidden");
  modal.classList.remove("flex");
}

function wireExportTableModal() {
  const modal = document.getElementById("exportTableModal");
  if (!modal) return;

  modal.addEventListener("click", (event) => {
    if (event.target === modal) closeExportTableModal();
  });
}

async function copyExportTable() {
  const textarea = document.getElementById("exportTableText");
  const status = document.getElementById("exportTableStatus");
  if (!textarea) return;

  const text = textarea.value;
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
    } else {
      textarea.focus();
      textarea.select();
      document.execCommand("copy");
    }
    if (status) status.textContent = t("copied", "Copied.");
  } catch {
    if (status) status.textContent = t("copyFailedSelectManually", "Copy failed. Select and copy manually.");
  }
}

function buildExportTableText(state) {
  const rows = [[
    t("exportHeadingItemId", "ItemId"),
    t("exportHeadingDescription", "Description"),
    t("exportHeadingDrawerIndex", "DrawerIndex"),
    t("exportHeadingCount", "Count"),
  ]];

  const drawerIndicesByItemId = new Map();
  (state.currentDrawers || []).forEach((drawer) => {
    (drawer.placements || []).forEach((placement) => {
      const itemId = placement && placement.set ? placement.set.itemId : "";
      if (!itemId) return;

      const indices = drawerIndicesByItemId.get(itemId);
      if (indices) {
        if (!indices.includes(drawer.drawerIndex)) indices.push(drawer.drawerIndex);
      } else {
        drawerIndicesByItemId.set(itemId, [drawer.drawerIndex]);
      }
    });
  });

  const selectedToolStorages = resolveSelectedToolStorages(
    parseSelectedToolStorageIds(getTrimmedValue("toolstorageInput")),
    state.toolStorageMap,
  );
  selectedToolStorages.forEach((toolstorage) => {
    rows.push([toolstorage.itemId, toolstorage.description || "", "", 1]);
  });

  const textarea = document.getElementById("toolsetsInput");
  const rawSetIds = parseMultilineIds(textarea ? textarea.value : "");
  const countsById = rawSetIds.reduce((map, id) => {
    map.set(id, (map.get(id) || 0) + 1);
    return map;
  }, new Map());

  const uniqueSetIds = uniquePreserveOrder(rawSetIds);
  uniqueSetIds.forEach((setId) => {
    const set = state.toolSetMap.get(setId);
    const count = countsById.get(setId) || 0;
    if (set) {
      const drawerIndices = (drawerIndicesByItemId.get(set.itemId) || []).slice().sort((a, b) => a - b);
      const drawerText = drawerIndices.length ? drawerIndices.join(",") : t("unplaced", "Unplaced");
      rows.push([set.itemId, set.description || "", drawerText, count]);
    } else {
      rows.push([setId, t("notFound", "Not found"), "", count]);
    }
  });

  return rows.map((row) => row.map(sanitizeSpreadsheetCell).join("\t")).join("\n");
}

function sanitizeSpreadsheetCell(value) {
  return String(value ?? "").replace(/[\t\r\n]+/g, " ").trim();
}

exports.copyExportTable = copyExportTable;
exports.openExportTableModal = openExportTableModal;
exports.closeExportTableModal = closeExportTableModal;
exports.wireExportTableModal = wireExportTableModal;
});

__define("features/configurator/configurator-import-service.js", (exports, __require) => {
const { cleanString } = __require("shared/utils/string-utils.js");
const { t } = __require("shared/i18n/toolkit-i18n.js");
const { updateCatalogButtons, updateToolstoragePreviewFromInput } = __require("features/catalog/catalog-selection.js");
const { updateToolSetCatalogFitBorders } = __require("features/catalog/toolset-catalog-view.js");
const { fitSetsIntoDrawers } = __require("features/drawer-layout/drawer-fit-service.js");
const { buildDrawersForStorages, resolveSelectedSets } = __require("features/drawer-layout/drawer-layout-service.js");
const { renderConfiguration, renderSelectedToolstorage } = __require("features/drawer-layout/drawer-renderer.js");
const { buildToolStorageSelectionKey, parseSelectedToolStorageIds, resolveSelectedToolStorages, validateToolStorageSelection } = __require("features/toolstorage-selection/toolstorage-selection-service.js");
const { logImportDebug } = __require("features/configurator/configurator-export-debug.js");
const { restoreSavedLayout } = __require("features/configurator/configurator-saved-layout-restore-service.js");
function parseMultilineIds(value) {
  return cleanString(value)
    .split(/\r?\n/)
    .map(cleanString)
    .filter(Boolean);
}

function handleLoadFromJson(state) {
  const input = getJsonFileInput(state);
  if (!input) return;
  input.value = "";
  input.click();
}

function applyImportedConfiguration(state, parsed) {
  const validationError = validateImportedConfiguration(parsed);
  if (validationError) {
    alert(validationError);
    return false;
  }

  const toolstorageIds = typeof parsed.toolstorageIds === "string"
    ? parsed.toolstorageIds
    : typeof parsed.toolstorageId === "string"
      ? parsed.toolstorageId
      : "";
  const toolsetIds = typeof parsed.toolsetIds === "string" ? parsed.toolsetIds : "";

  const toolstorageInput = document.getElementById("toolstorageInput");
  const toolsetsInput = document.getElementById("toolsetsInput");
  if (toolstorageInput) {
    toolstorageInput.value = toolstorageIds;
    toolstorageInput.setAttribute("value", toolstorageIds);
  }
  if (toolsetsInput) toolsetsInput.value = toolsetIds;

  updateToolstoragePreviewFromInput(state, toolstorageIds, { onPreviewChanged: renderSelectedToolstorage });
  updateCatalogButtons();

  const selectedStorages = resolveSelectedToolStorages(
    parseSelectedToolStorageIds(toolstorageIds),
    state.toolStorageMap,
  );
  const selectionValidation = validateToolStorageSelection(selectedStorages);
  if (!selectionValidation.valid) {
    alert(selectionValidation.message || t("invalidToolStorageSelection", "This storage selection is not allowed."));
    return false;
  }

  let restored = false;
  if (Array.isArray(parsed.drawers) && parsed.drawers.length) {
    restored = restoreSavedLayout(state, parsed, toolstorageIds, toolsetIds, selectedStorages);
    if (restored) {
      renderConfiguration(state.currentDrawers, state.currentUnplacedSets, state.currentErrors);
      updateToolSetCatalogFitBorders(state);
    }
  }

  if (!restored) {
    if (!selectedStorages.length) return false;

    const manualSetIds = parseMultilineIds(toolsetIds);
    const selectedSets = resolveSelectedSets(manualSetIds, state.toolSets);
    const drawers = buildDrawersForStorages(selectedStorages);
    const selectionKey = buildToolStorageSelectionKey(selectedStorages);

    if (!drawers.length) {
      state.currentDrawers = [];
      state.currentUnplacedSets = selectedSets;
      state.currentErrors = [];
      state.currentToolstorageSelectionKey = selectionKey;
      renderConfiguration(state.currentDrawers, state.currentUnplacedSets, state.currentErrors);
      updateToolSetCatalogFitBorders(state);
      return true;
    }

    const result = fitSetsIntoDrawers(drawers, selectedSets);
    state.currentDrawers = result.drawers;
    state.currentUnplacedSets = result.unplacedSets;
    state.currentErrors = result.errors;
    state.currentToolstorageSelectionKey = selectionKey;
    renderConfiguration(state.currentDrawers, state.currentUnplacedSets, state.currentErrors);
    updateToolSetCatalogFitBorders(state);
  }

  return true;
}

function getJsonFileInput(state) {
  let input = document.getElementById("configJsonFileInput");
  if (input) return input;

  input = document.createElement("input");
  input.type = "file";
  input.id = "configJsonFileInput";
  input.accept = ".txt,text/plain,.json,application/json";
  input.style.display = "none";

  input.addEventListener("change", () => {
    const file = input.files && input.files[0];
    if (!file) return;

    logImportDebug("selected file", { name: file.name, type: file.type, size: file.size });

    const reader = new FileReader();
    reader.onload = () => {
      try {
        const raw = String(reader.result || "");
        logImportDebug("reader.result.length", raw.length);
        const parsed = JSON.parse(raw);
        applyImportedConfiguration(state, parsed);
      } catch (err) {
        console.error(err);
        const detailPrefix = t("detailsPrefix", " Details:");
        const detail = err instanceof Error && err.message ? `${detailPrefix} ${err.message}` : "";
        alert(
          `${t("invalidConfigurationExportSelectTxt", "Invalid configuration export. Please select a .txt file containing JSON exported from this configurator.")}${detail}`,
        );
      }
    };
    reader.onerror = () => {
      alert(t("failedToReadSelectedFile", "Failed to read the selected file."));
    };
    reader.readAsText(file);
  });

  document.body.appendChild(input);
  return input;
}

function validateImportedConfiguration(parsed) {
  if (!parsed || typeof parsed !== "object" || Array.isArray(parsed)) {
    return t("invalidExportExpectedJsonObject", "Invalid configuration export: expected a JSON object.");
  }

  const hasToolstorageIds = typeof parsed.toolstorageIds === "string";
  const hasLegacyToolstorageId = typeof parsed.toolstorageId === "string";

  if (!hasToolstorageIds && !hasLegacyToolstorageId) {
    return t("invalidExportToolstorageIds", "Invalid configuration export: missing or invalid 'toolstorageIds' (expected a string).");
  }

  if (typeof parsed.toolsetIds !== "string") {
    return t("invalidExportToolsetIds", "Invalid configuration export: missing or invalid 'toolsetIds' (expected a string).");
  }

  if ("version" in parsed && typeof parsed.version !== "number") {
    return t("invalidExportVersion", "Invalid configuration export: invalid 'version' (expected a number).");
  }

  if ("savedAt" in parsed && typeof parsed.savedAt !== "string") {
    return t("invalidExportSavedAt", "Invalid configuration export: invalid 'savedAt' (expected an ISO timestamp string).");
  }

  if ("drawers" in parsed && !Array.isArray(parsed.drawers)) {
    return t("invalidExportDrawers", "Invalid configuration export: invalid 'drawers' (expected an array).");
  }

  if (Array.isArray(parsed.drawers)) {
    for (const drawer of parsed.drawers) {
      if (!drawer || typeof drawer !== "object" || Array.isArray(drawer)) {
        return t("invalidExportDrawerObject", "Invalid configuration export: each drawer must be an object.");
      }

      if (!("drawerIndex" in drawer)) {
        return t("invalidExportDrawerIndex", "Invalid configuration export: a drawer is missing 'drawerIndex'.");
      }

      if ("locked" in drawer && typeof drawer.locked !== "boolean") {
        return t("invalidExportDrawerLocked", "Invalid configuration export: a drawer has invalid 'locked' (expected a boolean).");
      }

      if ("sets" in drawer && !Array.isArray(drawer.sets)) {
        return t("invalidExportDrawerSets", "Invalid configuration export: a drawer has invalid 'sets' (expected an array).");
      }
    }
  }

  return null;
}

exports.handleLoadFromJson = handleLoadFromJson;
exports.applyImportedConfiguration = applyImportedConfiguration;
});

__define("features/configurator/configurator-layout-reconcile.js", (exports, __require) => {
const { cleanString } = __require("shared/utils/string-utils.js");
const { buildDrawersForStorage } = __require("features/drawer-layout/drawer-layout-service.js");
function getSelectedStorageIdsFromDrawers(drawers) {
  const seen = new Set();
  const ids = [];

  (drawers || []).forEach((drawer) => {
    const itemId = cleanString(drawer?.storageItemId);
    if (!itemId || seen.has(itemId)) return;
    seen.add(itemId);
    ids.push(itemId);
  });

  return ids;
}

function canReconcileStoragesWithExistingLayout(currentDrawers, nextStorages) {
  if (!Array.isArray(currentDrawers) || !currentDrawers.length) return false;

  const currentStorageIds = getSelectedStorageIdsFromDrawers(currentDrawers);
  const nextStorageIds = nextStorages.map((storage) => storage.itemId);

  if (currentStorageIds.length >= nextStorageIds.length) return false;

  return currentStorageIds.every((itemId) => nextStorageIds.includes(itemId));
}

function reconcileDrawersWithSelectedStorages(currentDrawers, nextStorages) {
  const totalSelectionCount = nextStorages.length;
  const existingDrawersByKey = new Map(
    (currentDrawers || []).map((drawer) => [
      `${cleanString(drawer.storageItemId)}::${Number(drawer.storageLocalDrawerIndex) || 0}`,
      drawer,
    ]),
  );

  let nextDrawerIndex = 1;

  return nextStorages.flatMap((storage) =>
    buildDrawersForStorage(storage).map((baseDrawer, localIndex) => {
      const storageLocalDrawerIndex = localIndex + 1;
      const existingDrawer = existingDrawersByKey.get(
        `${cleanString(storage.itemId)}::${storageLocalDrawerIndex}`,
      );

      if (existingDrawer) {
        return {
          ...existingDrawer,
          drawerIndex: nextDrawerIndex++,
          storageItemId: storage.itemId,
          storageDescription: storage.description || "",
          storageProductType: storage.productType || "",
          storageLocalDrawerIndex,
          storageSelectionCount: totalSelectionCount,
        };
      }

      return {
        ...baseDrawer,
        drawerIndex: nextDrawerIndex++,
        storageItemId: storage.itemId,
        storageDescription: storage.description || "",
        storageProductType: storage.productType || "",
        storageLocalDrawerIndex,
        storageSelectionCount: totalSelectionCount,
      };
    }),
  );
}

exports.canReconcileStoragesWithExistingLayout = canReconcileStoragesWithExistingLayout;
exports.reconcileDrawersWithSelectedStorages = reconcileDrawersWithSelectedStorages;
});

__define("features/configurator/configurator-persistence.js", (exports, __require) => {
const __reexported_module_0 = __require("features/configurator/configurator-export-service.js");
exports.handlePrintToPdf = __reexported_module_0.handlePrintToPdf;
exports.handleSaveToJson = __reexported_module_0.handleSaveToJson;
const __reexported_module_1 = __require("features/configurator/configurator-import-service.js");
exports.handleLoadFromJson = __reexported_module_1.handleLoadFromJson;
exports.applyImportedConfiguration = __reexported_module_1.applyImportedConfiguration;
const __reexported_module_2 = __require("features/configurator/configurator-export-table-modal.js");
exports.openExportTableModal = __reexported_module_2.openExportTableModal;
exports.closeExportTableModal = __reexported_module_2.closeExportTableModal;
exports.wireExportTableModal = __reexported_module_2.wireExportTableModal;
exports.copyExportTable = __reexported_module_2.copyExportTable;
});

__define("features/configurator/configurator-saved-layout-restore-service.js", (exports, __require) => {
const { toInt, toNumber } = __require("shared/utils/number-utils.js");
const { cleanString } = __require("shared/utils/string-utils.js");
const { buildToolStorageSelectionKey } = __require("features/toolstorage-selection/toolstorage-selection-service.js");
const { buildDrawersForStorages, resolveSelectedSets } = __require("features/drawer-layout/drawer-layout-service.js");
function parseMultilineIds(value) {
  return cleanString(value)
    .split(/\r?\n/)
    .map(cleanString)
    .filter(Boolean);
}

function restoreSavedLayout(state, parsed, toolstorageIds, toolsetIds, selectedStorages) {
  if (!selectedStorages.length) return false;

  const drawers = buildDrawersForStorages(selectedStorages);
  const setMap = state.toolSetMap;
  const placedCounts = new Map();

  parsed.drawers.forEach((savedDrawer) => {
    const drawerIndex = toInt(savedDrawer.drawerIndex);
    const drawer = drawers.find((d) => d.drawerIndex === drawerIndex);
    if (!drawer) return;
    drawer.locked = Boolean(savedDrawer.locked);

    const savedSets = Array.isArray(savedDrawer.sets) ? savedDrawer.sets : [];
    savedSets.forEach((entry) => {
      const setId = cleanString(entry.itemId);
      const set = setMap.get(setId);
      if (!set) return;

      drawer.sets.push(set);
      drawer.placements.push({
        set,
        x: toNumber(entry.x),
        y: toNumber(entry.y),
        width: toNumber(entry.width) || set.setWidth || 0,
        depth: toNumber(entry.depth) || set.setDepth || 0,
      });
      placedCounts.set(setId, (placedCounts.get(setId) || 0) + 1);
    });
  });

  const selectedIds = parseMultilineIds(toolsetIds);
  const selectedSets = resolveSelectedSets(selectedIds, state.toolSets);
  const desiredCounts = selectedSets.reduce((map, set) => {
    const itemId = set?.itemId || "";
    if (!itemId) return map;
    map.set(itemId, (map.get(itemId) || 0) + 1);
    return map;
  }, new Map());

  const remainingCounts = new Map(desiredCounts);
  placedCounts.forEach((placed, itemId) => {
    const want = remainingCounts.get(itemId) || 0;
    remainingCounts.set(itemId, Math.max(0, want - placed));
  });

  const unplacedSets = [];
  selectedSets.forEach((set) => {
    const itemId = set?.itemId || "";
    const remaining = remainingCounts.get(itemId) || 0;
    if (remaining <= 0) return;
    unplacedSets.push(set);
    remainingCounts.set(itemId, remaining - 1);
  });

  state.currentDrawers = drawers;
  state.currentUnplacedSets = unplacedSets;
  state.currentErrors = [];
  state.currentToolstorageSelectionKey = buildToolStorageSelectionKey(selectedStorages);

  return true;
}

exports.restoreSavedLayout = restoreSavedLayout;
});

__define("features/configurator/configurator-state.js", (exports, __require) => {
function createConfiguratorState() {
  return {
    toolStorages: [],
    toolSets: [],
    toolStorageMap: new Map(),
    toolSetMap: new Map(),
    currentDrawers: [],
    currentUnplacedSets: [],
    currentErrors: [],
    currentToolstorageSelectionKey: "",
  };
}

function createDragState() {
  return {
    active: false,
    setId: "",
    sourceDrawerIndex: null,
    sourceRect: null,
    offsetX: 0,
    offsetY: 0,
    pointerId: null,
  };
}

exports.createConfiguratorState = createConfiguratorState;
exports.createDragState = createDragState;
});

__define("features/configurator/configurator-ui-wiring.js", (exports, __require) => {
function wirePrintDetailsOpen() {
  let previouslyClosed = null;

  const openAll = () => {
    if (previouslyClosed) return;

    previouslyClosed = [];
    document.querySelectorAll("details").forEach((detail) => {
      if (detail.hasAttribute("open")) return;
      previouslyClosed.push(detail);
      detail.setAttribute("open", "");
    });
  };

  const restore = () => {
    if (!previouslyClosed) return;

    previouslyClosed.forEach((detail) => {
      if (!document.contains(detail)) return;
      detail.removeAttribute("open");
    });
    previouslyClosed = null;
  };

  window.addEventListener("beforeprint", openAll);
  window.addEventListener("afterprint", restore);

  if (window.matchMedia) {
    const media = window.matchMedia("print");
    const handler = (event) => {
      if (event.matches) openAll();
      else restore();
    };

    if (typeof media.addEventListener === "function") {
      media.addEventListener("change", handler);
    } else if (typeof media.addListener === "function") {
      media.addListener(handler);
    }
  }
}

function wireOutsideDetailsClose() {
  document.addEventListener("click", (event) => {
    const productModal = document.getElementById("productDetailModal");
    if (productModal && productModal.contains(event.target)) return;
    if (event.target.closest("details")) return;
    document.querySelectorAll("details.z-10[open]").forEach((detail) => {
      detail.removeAttribute("open");
    });
  });
}

function wireDismissibleHint() {
  document.addEventListener("click", (event) => {
    const dismissButton = event.target.closest("[data-action=\"dismiss-configurator-hint\"]");
    if (!dismissButton) return;

    const container = dismissButton.closest("[data-dismissible=\"configurator-hint\"]");
    container?.remove();
  });
}

exports.wirePrintDetailsOpen = wirePrintDetailsOpen;
exports.wireOutsideDetailsClose = wireOutsideDetailsClose;
exports.wireDismissibleHint = wireDismissibleHint;
});

__define("features/drawer-layout/drawer-drag-drop-mutations.js", (exports, __require) => {
const { toInt } = __require("shared/utils/number-utils.js");
const { cleanString } = __require("shared/utils/string-utils.js");
function parseMultilineIds(value) {
  return cleanString(value)
    .split(/\r?\n/)
    .map(cleanString)
    .filter(Boolean);
}

function startDragFromTile(state, dragState, tile, clientX, clientY) {
  const setId = cleanString(tile.dataset.setId);
  const drawerIndex = toInt(tile.dataset.drawerIndex);
  if (!setId || !drawerIndex) return false;

  const drawer = findDrawerByIndex(state, drawerIndex);
  if (drawer?.locked) return false;
  const placement = drawer ? findPlacement(drawer, setId, tile) : null;
  if (!placement) return false;

  dragState.active = true;
  dragState.setId = setId;
  dragState.sourceDrawerIndex = drawerIndex;
  dragState.sourceRect = {
    x: placement.x,
    y: placement.y,
    width: placement.width,
    height: placement.depth,
  };

  const rect = tile.getBoundingClientRect();
  dragState.offsetX = clientX - rect.left;
  dragState.offsetY = clientY - rect.top;
  return true;
}

function resetDragState(dragState) {
  dragState.active = false;
  dragState.setId = "";
  dragState.sourceDrawerIndex = null;
  dragState.sourceRect = null;
  dragState.offsetX = 0;
  dragState.offsetY = 0;
  dragState.pointerId = null;
}

function findDrawerByIndex(state, drawerIndex) {
  return state.currentDrawers.find((drawer) => drawer.drawerIndex === drawerIndex) || null;
}

function getSetById(state, setId) {
  return state.toolSetMap.get(setId) || null;
}

function getPointerInDrawer(event, dropzone, drawer) {
  const rect = dropzone.getBoundingClientRect();
  const usableWidth = drawer.drawerUsableWidth || 0;
  const usableDepth = drawer.drawerUsableDepth || 0;
  const rawX = rect.width > 0 ? (event.clientX - rect.left) / rect.width : 0;
  const rawY = rect.height > 0 ? (event.clientY - rect.top) / rect.height : 0;

  return {
    x: clamp(rawX * usableWidth, 0, usableWidth),
    y: clamp(rawY * usableDepth, 0, usableDepth),
  };
}

function placeSetAtRect(state, dragState, set, targetDrawerIndex, freeRect) {
  const targetDrawer = findDrawerByIndex(state, targetDrawerIndex);
  if (!targetDrawer) return;

  const placement = {
    set,
    x: freeRect.x,
    y: freeRect.y,
    width: set.setWidth || 0,
    depth: set.setDepth || 0,
  };

  const sourceDrawer = dragState.sourceDrawerIndex ? findDrawerByIndex(state, dragState.sourceDrawerIndex) : null;

  if (sourceDrawer) {
    removeOnePlacement(sourceDrawer, set.itemId, dragState.sourceRect);
    removeOneSetInstance(sourceDrawer, set.itemId);
  }

  targetDrawer.sets = (targetDrawer.sets || []).concat(set);
  targetDrawer.placements = (targetDrawer.placements || []).concat(placement);
}

function removeTileFromLayout(state, tile) {
  if (!tile) return;

  const setId = cleanString(tile.getAttribute("data-set-id"));
  const drawerIndex = toInt(tile.getAttribute("data-drawer-index") || tile.dataset.drawerIndex);
  if (!setId || !drawerIndex) return;

  const drawer = findDrawerByIndex(state, drawerIndex);
  if (!drawer) return;

  const sourceRect = getTileRect(tile);
  removeOnePlacement(drawer, setId, sourceRect);
  removeOneSetInstance(drawer, setId);
}

function removeSetFromSelectionInput(setId) {
  const textarea = document.getElementById("toolsetsInput");
  if (!textarea) return;

  const ids = parseMultilineIds(textarea.value);
  const index = ids.indexOf(setId);
  if (index === -1) return;

  ids.splice(index, 1);
  textarea.value = ids.join("\n");
}

function toggleDrawerLock(state, drawerIndex) {
  const drawer = findDrawerByIndex(state, drawerIndex);
  if (!drawer) return false;
  drawer.locked = !drawer.locked;
  return true;
}

function findPlacement(drawer, setId, tile) {
  const placements = (drawer.placements || []).filter((placement) => placement.set && placement.set.itemId === setId);
  if (!placements.length) return null;

  const rect = getTileRect(tile);
  if (!rect) return placements[0];

  return placements.find((placement) => rectMatchesPlacement(placement, rect)) || placements[0];
}

function getTileRect(tile) {
  if (!tile) return null;
  const x = Number(tile.getAttribute("data-x") || tile.dataset.x);
  const y = Number(tile.getAttribute("data-y") || tile.dataset.y);
  const width = Number(tile.getAttribute("data-width") || tile.dataset.width);
  const height = Number(tile.getAttribute("data-depth") || tile.dataset.depth);
  if (!Number.isFinite(x) || !Number.isFinite(y) || !Number.isFinite(width) || !Number.isFinite(height)) return null;
  return { x, y, width, height };
}

function nearlyEqual(a, b, epsilon = 0.001) {
  return Math.abs((a || 0) - (b || 0)) <= epsilon;
}

function rectMatchesPlacement(placement, rect) {
  return (
    nearlyEqual(placement.x, rect.x) &&
    nearlyEqual(placement.y, rect.y) &&
    nearlyEqual(placement.width, rect.width) &&
    nearlyEqual(placement.depth, rect.height)
  );
}

function removeOnePlacement(drawer, setId, rect) {
  const placements = (drawer.placements || []).slice();
  let index = -1;

  if (rect) {
    index = placements.findIndex((placement) => placement?.set?.itemId === setId && rectMatchesPlacement(placement, rect));
  }
  if (index === -1) {
    index = placements.findIndex((placement) => placement?.set?.itemId === setId);
  }
  if (index === -1) return;

  placements.splice(index, 1);
  drawer.placements = placements;
}

function removeOneSetInstance(drawer, setId) {
  const sets = (drawer.sets || []).slice();
  const index = sets.findIndex((set) => set && set.itemId === setId);
  if (index === -1) return;

  sets.splice(index, 1);
  drawer.sets = sets;
}

function clamp(value, min, max) {
  return Math.min(max, Math.max(min, value));
}

exports.startDragFromTile = startDragFromTile;
exports.resetDragState = resetDragState;
exports.findDrawerByIndex = findDrawerByIndex;
exports.getSetById = getSetById;
exports.getPointerInDrawer = getPointerInDrawer;
exports.placeSetAtRect = placeSetAtRect;
exports.removeTileFromLayout = removeTileFromLayout;
exports.removeSetFromSelectionInput = removeSetFromSelectionInput;
exports.toggleDrawerLock = toggleDrawerLock;
});

__define("features/drawer-layout/drawer-drag-drop.js", (exports, __require) => {
const { toInt } = __require("shared/utils/number-utils.js");
const { getValidFreeRectangles, pickTargetRect } = __require("features/drawer-layout/maxrects-service.js");
const { renderConfiguration } = __require("features/drawer-layout/drawer-renderer.js");
const { updateToolSetCatalogFitBorders } = __require("features/catalog/toolset-catalog-view.js");
const { canDrawerAcceptSetWeight } = __require("features/drawer-layout/drawer-weight-service.js");
const { findDrawerByIndex, getPointerInDrawer, getSetById, placeSetAtRect, removeSetFromSelectionInput, removeTileFromLayout, resetDragState, startDragFromTile, toggleDrawerLock } = __require("features/drawer-layout/drawer-drag-drop-mutations.js");
const { clearAllDropOverlays, clearDropOverlay, renderDropOverlays, renderHeightMismatchOverlay } = __require("features/drawer-layout/drawer-drop-overlay-renderer.js");
function wireDragAndDrop(state, dragState, { onSelectionChanged } = {}) {
  const container = document.getElementById("recommendationsGrid");
  if (!container) return;

  container.addEventListener("click", (event) => {
    if (handleToggleDrawerLock(event, state)) return;
    handleRemoveFromTile(event, state, onSelectionChanged);
  });
  container.addEventListener("dragstart", (event) => handleDragStart(event, state, dragState));
  container.addEventListener("dragend", () => handleDragEnd(dragState));
  container.addEventListener("dragover", (event) => handleDragOver(event, state, dragState));
  container.addEventListener("dragleave", handleDragLeave);
  container.addEventListener("drop", (event) => handleDrop(event, state, dragState));
  container.addEventListener("pointerdown", (event) => handlePointerDown(event, state, dragState));
}

function handleDragStart(event, state, dragState) {
  if (event.target.closest("[data-action=\"remove-set\"]")) return;
  const tile = event.target.closest("[data-set-id][draggable=\"true\"]");
  if (!tile) return;

  if (!startDragFromTile(state, dragState, tile, event.clientX, event.clientY)) return;

  if (event.dataTransfer) {
    event.dataTransfer.effectAllowed = "move";
    event.dataTransfer.setData("text/plain", dragState.setId);
  }
}

function handleDragEnd(dragState) {
  clearAllDropOverlays();
  resetDragState(dragState);
}

function handleDragOver(event, state, dragState) {
  if (!dragState.active) return;

  const dropzone = event.target.closest("[data-dropzone=\"true\"]");
  if (!dropzone) {
    clearAllDropOverlays();
    return;
  }

  event.preventDefault();
  handleDragOverAt(state, dragState, dropzone, event.clientX, event.clientY);
}

function handleDragLeave(event) {
  const dropzone = event.target.closest("[data-dropzone=\"true\"]");
  if (!dropzone) return;
  if (event.relatedTarget && dropzone.contains(event.relatedTarget)) return;
  clearDropOverlay(dropzone);
}

function handleDrop(event, state, dragState) {
  if (!dragState.active) return;

  const dropzone = event.target.closest("[data-dropzone=\"true\"]");
  if (!dropzone) return;

  event.preventDefault();
  handleDropAt(state, dragState, dropzone, event.clientX, event.clientY);
}

function handlePointerDown(event, state, dragState) {
  if (event.pointerType === "mouse") return;
  if (event.target.closest("[data-action=\"remove-set\"]")) return;
  const tile = event.target.closest("[data-set-id][draggable=\"true\"]");
  if (!tile) return;

  event.preventDefault();

  if (!startDragFromTile(state, dragState, tile, event.clientX, event.clientY)) return;
  dragState.pointerId = event.pointerId;

  tile.setPointerCapture?.(event.pointerId);
  const onPointerMove = (moveEvent) => {
    if (!dragState.active) return;
    if (dragState.pointerId !== null && moveEvent.pointerId !== dragState.pointerId) return;

    moveEvent.preventDefault();

    const target = document.elementFromPoint(moveEvent.clientX, moveEvent.clientY);
    const dropzone = target ? target.closest("[data-dropzone=\"true\"]") : null;
    if (!dropzone) {
      clearAllDropOverlays();
      return;
    }

    handleDragOverAt(state, dragState, dropzone, moveEvent.clientX, moveEvent.clientY);
  };

  const onPointerUp = (upEvent) => {
    if (!dragState.active) return;
    if (dragState.pointerId !== null && upEvent.pointerId !== dragState.pointerId) return;

    const target = document.elementFromPoint(upEvent.clientX, upEvent.clientY);
    const dropzone = target ? target.closest("[data-dropzone=\"true\"]") : null;

    if (dropzone) {
      handleDropAt(state, dragState, dropzone, upEvent.clientX, upEvent.clientY);
    } else {
      clearAllDropOverlays();
      resetDragState(dragState);
    }

    window.removeEventListener("pointermove", onPointerMove);
    window.removeEventListener("pointerup", onPointerUp);
    window.removeEventListener("pointercancel", onPointerUp);
  };

  window.addEventListener("pointermove", onPointerMove, { passive: false });
  window.addEventListener("pointerup", onPointerUp);
  window.addEventListener("pointercancel", onPointerUp);

  onPointerMove(event);
}

function handleRemoveFromTile(event, state, onSelectionChanged) {
  const button = event.target.closest("[data-action=\"remove-set\"]");
  if (!button) return;

  event.preventDefault();
  event.stopPropagation();

  const tile = button.closest("[data-set-id]");
  const setId = tile ? tile.getAttribute("data-set-id") : "";
  if (!setId) return;

  const drawerIndex = toInt(tile?.getAttribute("data-drawer-index") || tile?.dataset.drawerIndex);
  const drawer = findDrawerByIndex(state, drawerIndex);
  if (drawer?.locked) return;

  removeTileFromLayout(state, tile);
  removeSetFromSelectionInput(setId);
  onSelectionChanged?.();
}

function handleToggleDrawerLock(event, state) {
  const button = event.target.closest("[data-action=\"locked-drawer\"], [data-action=\"unlocked-drawer\"]");
  if (!button) return false;

  event.preventDefault();
  event.stopPropagation();

  const drawerIndex = toInt(button.getAttribute("data-drawer-index") || button.dataset.drawerIndex);
  if (!toggleDrawerLock(state, drawerIndex)) return true;

  clearAllDropOverlays();
  renderConfiguration(state.currentDrawers, state.currentUnplacedSets, state.currentErrors);
  updateToolSetCatalogFitBorders(state);
  return true;
}

function handleDragOverAt(state, dragState, dropzone, clientX, clientY) {
  const drawerIndex = toInt(dropzone.dataset.drawerIndex);
  const drawer = findDrawerByIndex(state, drawerIndex);
  const set = getSetById(state, dragState.setId);

  if (!drawer || !set) {
    clearDropOverlay(dropzone);
    return;
  }

  if (drawer.locked) {
    clearDropOverlay(dropzone);
    return;
  }

  if ((set.setHeight || 0) > (drawer.drawerHeight || 0)) {
    renderHeightMismatchOverlay(dropzone, drawer, set);
    return;
  }

  const excludePlacement = drawerIndex === dragState.sourceDrawerIndex
    ? { ...dragState.sourceRect, itemId: dragState.setId }
    : null;
  if (!canDrawerAcceptSetWeight(drawer, set, { excludePlacement })) {
    clearDropOverlay(dropzone);
    return;
  }

  const validRects = getValidFreeRectangles(drawer, set, excludePlacement);
  const pointer = getPointerInDrawer({ clientX, clientY }, dropzone, drawer);
  const activeRect = pickTargetRect(validRects, pointer.x, pointer.y);

  renderDropOverlays(dropzone, drawer, set, validRects, activeRect);
}

function handleDropAt(state, dragState, dropzone, clientX, clientY) {
  const drawerIndex = toInt(dropzone.dataset.drawerIndex);
  const drawer = findDrawerByIndex(state, drawerIndex);
  const set = getSetById(state, dragState.setId);

  if (!drawer || !set) {
    clearDropOverlay(dropzone);
    resetDragState(dragState);
    return;
  }

  if (drawer.locked) {
    clearDropOverlay(dropzone);
    resetDragState(dragState);
    return;
  }

  if ((set.setHeight || 0) > (drawer.drawerHeight || 0)) {
    renderHeightMismatchOverlay(dropzone, drawer, set);
    resetDragState(dragState);
    return;
  }

  const excludePlacement = drawerIndex === dragState.sourceDrawerIndex
    ? { ...dragState.sourceRect, itemId: dragState.setId }
    : null;
  if (!canDrawerAcceptSetWeight(drawer, set, { excludePlacement })) {
    clearDropOverlay(dropzone);
    resetDragState(dragState);
    return;
  }
  const validRects = getValidFreeRectangles(drawer, set, excludePlacement);
  const pointer = getPointerInDrawer({ clientX, clientY }, dropzone, drawer);
  const targetRect = pickTargetRect(validRects, pointer.x, pointer.y);

  if (!targetRect) {
    clearDropOverlay(dropzone);
    resetDragState(dragState);
    return;
  }

  placeSetAtRect(state, dragState, set, drawerIndex, targetRect);
  clearAllDropOverlays();
  resetDragState(dragState);
  renderConfiguration(state.currentDrawers, state.currentUnplacedSets, state.currentErrors);
  updateToolSetCatalogFitBorders(state);
}

exports.wireDragAndDrop = wireDragAndDrop;
});

__define("features/drawer-layout/drawer-drop-overlay-renderer.js", (exports, __require) => {
const { t } = __require("shared/i18n/toolkit-i18n.js");
const { escapeHtml } = __require("shared/utils/string-utils.js");
function renderDropOverlays(dropzone, drawer, set, validRects, activeRect) {
  const overlay = ensureDropOverlay(dropzone);
  if (!validRects.length) {
    overlay.innerHTML = "";
    return;
  }

  const usableWidth = drawer.drawerUsableWidth || 0;
  const usableDepth = drawer.drawerUsableDepth || 0;
  const setWidth = set.setWidth || 0;
  const setHeight = set.setDepth || 0;

  overlay.innerHTML = validRects
    .map((rect) => {
      const leftPct = toPercent(rect.x, usableWidth);
      const topPct = toPercent(rect.y, usableDepth);
      const widthPct = toPercent(setWidth, usableWidth);
      const heightPct = toPercent(setHeight, usableDepth);
      const isActive = activeRect && rect === activeRect;
      const classes = isActive
        ? "absolute border-2 border-emerald-500/80 bg-emerald-500/20 shadow-[0_0_0_1px_rgba(16,185,129,0.4)]"
        : "absolute border border-amber-400/70 bg-amber-500/20";

      return `
      <div class="${classes}" style="left:${leftPct}%; top:${topPct}%; width:${widthPct}%; height:${heightPct}%; box-sizing:border-box;"></div>
    `;
    })
    .join("");
}

function renderHeightMismatchOverlay(dropzone, drawer, set) {
  const overlay = ensureDropOverlay(dropzone);
  const message = escapeHtml(
    t("setHeightGreaterThanDrawerHeight", "Set height is greater than drawer height."),
  );

  void drawer;
  void set;

  overlay.innerHTML = `
    <div class="absolute inset-0 grid place-items-center border-2 border-red-100 bg-red-600-50 px-3 text-center text-xs font-semibold leading-tight text-white" style="box-sizing:border-box;">
      <div class="grid gap-1">
        <span>${message}</span>
      </div>
    </div>
  `;
}

function clearDropOverlay(dropzone) {
  const overlay = dropzone.querySelector("[data-drop-overlay=\"true\"]");
  if (overlay) overlay.innerHTML = "";
}

function clearAllDropOverlays() {
  document.querySelectorAll("[data-drop-overlay=\"true\"]").forEach((overlay) => {
    overlay.innerHTML = "";
  });
}

function ensureDropOverlay(dropzone) {
  let overlay = dropzone.querySelector("[data-drop-overlay=\"true\"]");
  if (overlay) return overlay;

  overlay = document.createElement("div");
  overlay.dataset.dropOverlay = "true";
  overlay.className = "absolute inset-0 pointer-events-none";
  dropzone.appendChild(overlay);
  return overlay;
}

function toPercent(value, total) {
  if (total <= 0) return 0;
  return Math.max(0, Math.min(100, (value / total) * 100));
}

exports.renderDropOverlays = renderDropOverlays;
exports.renderHeightMismatchOverlay = renderHeightMismatchOverlay;
exports.clearDropOverlay = clearDropOverlay;
exports.clearAllDropOverlays = clearAllDropOverlays;
});

__define("features/drawer-layout/drawer-fit-service.js", (exports, __require) => {
const { findBestMaxRectsPlacementForPacking, maxRectsPruneFreeList, maxRectsSplitFreeRectangles } = __require("features/drawer-layout/maxrects-service.js");
const { sortSetsForPacking } = __require("features/drawer-layout/drawer-layout-service.js");
const { canDrawerAcceptSetWeight, getDrawerCapacityGrams, getSetWeightGrams } = __require("features/drawer-layout/drawer-weight-service.js");
function packSetsWithMaxRects(drawer, sets) {
  const usableWidth = drawer.drawerUsableWidth || 0;
  const usableDepth = drawer.drawerUsableDepth || 0;
  const drawerHeight = drawer.drawerHeight || 0;

  if (drawer.locked) {
    return {
      placements: (drawer.placements || []).slice(),
      unplaced: (sets || []).slice(),
    };
  }

  if (usableWidth <= 0 || usableDepth <= 0) {
    return {
      placements: [],
      unplaced: (sets || []).slice(),
    };
  }

  const eligible = [];
  const unplaced = [];
  const drawerCapacityGrams = getDrawerCapacityGrams(drawer);
  let accumulatedWeightGrams = 0;

  (sets || []).forEach((set) => {
    if ((set.setHeight || 0) > drawerHeight) {
      unplaced.push(set);
    } else {
      eligible.push(set);
    }
  });

  const ordered = sortSetsForPacking(eligible);
  let freeRects = [
    {
      x: 0,
      y: 0,
      width: usableWidth,
      height: usableDepth,
    },
  ];
  const placements = [];

  ordered.forEach((set) => {
    const setWeightGrams = getSetWeightGrams(set);
    if (drawerCapacityGrams > 0 && accumulatedWeightGrams + setWeightGrams > drawerCapacityGrams) {
      unplaced.push(set);
      return;
    }

    const bestPlacement = findBestMaxRectsPlacementForPacking(freeRects, set, usableDepth);
    if (!bestPlacement) {
      unplaced.push(set);
      return;
    }

    const placement = {
      set,
      x: bestPlacement.x,
      y: bestPlacement.y,
      width: bestPlacement.width,
      depth: bestPlacement.height,
    };

    placements.push(placement);
    accumulatedWeightGrams += setWeightGrams;

    freeRects = maxRectsSplitFreeRectangles(freeRects, {
      x: placement.x,
      y: placement.y,
      width: placement.width,
      height: placement.depth,
    });
    freeRects = maxRectsPruneFreeList(freeRects);
  });

  return { placements, unplaced };
}

function applyPlacementsToDrawer(drawer) {
  const result = packSetsWithMaxRects(drawer, drawer.sets || []);
  drawer.placements = result.placements;
  return result;
}

function fitSetsIntoDrawers(drawers, selectedSets) {
  const errors = [];
  const unplacedSets = [];

  const candidateSets = selectedSets.filter((set) => {
    const fitsAnyDrawerHeight = drawers.some((drawer) => set.setHeight <= drawer.drawerHeight);
    const fitsAnyDrawerWeight = drawers.some((drawer) => canDrawerAcceptSetWeight(drawer, set));

    if (!fitsAnyDrawerHeight) {
      errors.push(
        `${set.itemId} was not inserted. The set height is greater than the height of any drawer.`,
      );
      return false;
    }

    if (!fitsAnyDrawerWeight) {
      errors.push(
        `${set.itemId} was not inserted. The set weight is greater than the capacity of any drawer.`,
      );
      return false;
    }

    return true;
  });

  const orderedCandidates = sortSetsForPacking(candidateSets);

  // Place sets in size order so larger trays claim space first.
  for (const set of orderedCandidates) {
    let placed = false;

    for (const drawer of drawers) {
      if (drawer.locked) continue;
      if (set.setHeight > drawer.drawerHeight) continue;
      if (!canDrawerAcceptSetWeight(drawer, set)) continue;
      const nextSets = drawer.sets.concat(set);
      const packResult = packSetsWithMaxRects(drawer, nextSets);
      if (packResult.unplaced.length) continue;

      drawer.sets = nextSets;
      drawer.placements = packResult.placements;
      placed = true;

      if (placed) break;
    }

    if (!placed) {
      unplacedSets.push(set);
    }
  }

  drawers.forEach(applyPlacementsToDrawer);

  return {
    drawers,
    unplacedSets,
    errors,
  };
}

function fitSetsIntoExistingLayout(existingDrawers, selectedSets) {
  const desiredCounts = countSetsById(selectedSets);
  const keptCounts = new Map();

  const drawers = existingDrawers.map((drawer) => {
    const keptPlacements = [];

    (drawer.placements || []).forEach((placement) => {
      const itemId = placement?.set?.itemId || "";
      if (!itemId) return;

      const want = desiredCounts.get(itemId) || 0;
      const have = keptCounts.get(itemId) || 0;
      if (have >= want) return;

      keptPlacements.push(placement);
      keptCounts.set(itemId, have + 1);
    });

    return {
      ...drawer,
      sets: keptPlacements.map((placement) => placement.set),
      placements: keptPlacements,
    };
  });

  // Add exactly as many new instances as are still needed after keeping existing placements.
  const remainingCounts = new Map();
  desiredCounts.forEach((want, itemId) => {
    const have = keptCounts.get(itemId) || 0;
    const remaining = want - have;
    if (remaining > 0) remainingCounts.set(itemId, remaining);
  });

  const newSets = [];
  (selectedSets || []).forEach((set) => {
    const itemId = set?.itemId || "";
    if (!itemId) return;

    const remaining = remainingCounts.get(itemId) || 0;
    if (remaining <= 0) return;

    newSets.push(set);
    if (remaining === 1) remainingCounts.delete(itemId);
    else remainingCounts.set(itemId, remaining - 1);
  });

  const result = placeSetsWithoutRepacking(drawers, newSets);

  return {
    drawers,
    unplacedSets: result.unplacedSets,
    errors: result.errors,
  };
}

function countSetsById(sets) {
  const counts = new Map();
  (sets || []).forEach((set) => {
    const itemId = set?.itemId || "";
    if (!itemId) return;
    counts.set(itemId, (counts.get(itemId) || 0) + 1);
  });
  return counts;
}

function placeSetsWithoutRepacking(drawers, sets) {
  const errors = [];
  const unplacedSets = [];

  const candidateSets = sets.filter((set) => {
    const fitsAnyDrawerHeight = drawers.some((drawer) => set.setHeight <= drawer.drawerHeight);
    const fitsAnyDrawerWeight = drawers.some((drawer) => canDrawerAcceptSetWeight(drawer, set));

    if (!fitsAnyDrawerHeight) {
      errors.push(
        `${set.itemId} was not inserted. The set height is greater than the height of any drawer.`,
      );
      return false;
    }

    if (!fitsAnyDrawerWeight) {
      errors.push(
        `${set.itemId} was not inserted. The set weight is greater than the capacity of any drawer.`,
      );
      return false;
    }

    return true;
  });

  const orderedCandidates = sortSetsForPacking(candidateSets);

  for (const set of orderedCandidates) {
    let placed = false;

    for (const drawer of drawers) {
      if (drawer.locked) continue;
      if (set.setHeight > drawer.drawerHeight) continue;
      if (tryPlaceSetWithoutRepacking(drawer, set)) {
        placed = true;
        break;
      }
    }

    if (!placed) {
      unplacedSets.push(set);
    }
  }

  return { unplacedSets, errors };
}

function tryPlaceSetWithoutRepacking(drawer, set) {
  if (drawer.locked) return false;
  if (!canDrawerAcceptSetWeight(drawer, set)) return false;

  const usableWidth = drawer.drawerUsableWidth || 0;
  const usableDepth = drawer.drawerUsableDepth || 0;
  if (usableWidth <= 0 || usableDepth <= 0) return false;

  let freeRects = [
    {
      x: 0,
      y: 0,
      width: usableWidth,
      height: usableDepth,
    },
  ];

  (drawer.placements || []).forEach((placement) => {
    freeRects = maxRectsSplitFreeRectangles(freeRects, {
      x: placement.x,
      y: placement.y,
      width: placement.width,
      height: placement.depth,
    });
    freeRects = maxRectsPruneFreeList(freeRects);
  });

  const bestPlacement = findBestMaxRectsPlacementForPacking(freeRects, set, usableDepth);
  if (!bestPlacement) return false;

  const placement = {
    set,
    x: bestPlacement.x,
    y: bestPlacement.y,
    width: bestPlacement.width,
    depth: bestPlacement.height,
  };

  drawer.placements = (drawer.placements || []).concat(placement);
  drawer.sets = (drawer.sets || []).concat(set);
  return true;
}

exports.fitSetsIntoDrawers = fitSetsIntoDrawers;
exports.fitSetsIntoExistingLayout = fitSetsIntoExistingLayout;
});

__define("features/drawer-layout/drawer-hover-highlight.js", (exports, __require) => {
const { cleanString } = __require("shared/utils/string-utils.js");
function getHighlightKey(setId, drawerIndex) {
  return `${cleanString(setId)}::${cleanString(drawerIndex)}`;
}

function findListTrigger(target) {
  return target.closest("[data-drawer-set-list-item=\"true\"]");
}

function findTileTrigger(target) {
  return target.closest("[data-placed-set-tile=\"true\"]");
}

function getTileTargets(container, setId, drawerIndex) {
  return container.querySelectorAll(
    `[data-placed-set-tile="true"][data-set-id="${CSS.escape(cleanString(setId))}"][data-drawer-index="${CSS.escape(cleanString(drawerIndex))}"]`,
  );
}

function getListTargets(container, setId, drawerIndex) {
  return container.querySelectorAll(
    `[data-drawer-set-list-item="true"][data-set-id="${CSS.escape(cleanString(setId))}"][data-drawer-index="${CSS.escape(cleanString(drawerIndex))}"]`,
  );
}

function clearHighlights(container) {
  container.querySelectorAll(".drawer-set-hover-highlight").forEach((element) => {
    element.classList.remove("drawer-set-hover-highlight");
  });
  container.querySelectorAll(".drawer-set-list-hover-highlight").forEach((element) => {
    element.classList.remove("drawer-set-list-hover-highlight");
  });
}

function applyHighlight(container, setId, drawerIndex) {
  clearHighlights(container);

  getTileTargets(container, setId, drawerIndex).forEach((tile) => {
    tile.classList.add("drawer-set-hover-highlight");
  });

  getListTargets(container, setId, drawerIndex).forEach((listItem) => {
    listItem.classList.add("drawer-set-list-hover-highlight");
  });
}

function getTriggerData(trigger) {
  if (!trigger) return null;

  const setId = trigger.getAttribute("data-set-id");
  const drawerIndex = trigger.getAttribute("data-drawer-index");
  if (!setId || !drawerIndex) return null;

  return { setId, drawerIndex };
}

function wireDrawerHoverHighlight() {
  const container = document.getElementById("recommendationsGrid");
  if (!container) return;

  let activeKey = "";

  container.addEventListener("mouseover", (event) => {
    const trigger = findListTrigger(event.target) || findTileTrigger(event.target);
    if (!trigger) return;
    if (trigger.contains(event.relatedTarget)) return;

    const data = getTriggerData(trigger);
    if (!data) return;

    const nextKey = getHighlightKey(data.setId, data.drawerIndex);
    if (nextKey === activeKey) return;

    activeKey = nextKey;
    applyHighlight(container, data.setId, data.drawerIndex);
  });

  container.addEventListener("mouseout", (event) => {
    const trigger = findListTrigger(event.target) || findTileTrigger(event.target);
    if (!trigger) return;
    if (trigger.contains(event.relatedTarget)) return;

    activeKey = "";
    clearHighlights(container);
  });

  container.addEventListener("mouseleave", () => {
    activeKey = "";
    clearHighlights(container);
  });
}

exports.wireDrawerHoverHighlight = wireDrawerHoverHighlight;
});

__define("features/drawer-layout/drawer-layout-service.js", (exports, __require) => {
function buildDrawersForStorage(toolstorage) {
  const capacities = toolstorage.storagePerDrawerCapacity || [];
  const widths = toolstorage.storagePerDrawerWidth || [];
  const heights = toolstorage.storagePerDrawerHeight || [];
  const depths = toolstorage.storagePerDrawerDepth || [];

  return heights.map((height, index) => {
    const width = widths[index] ?? 0;
    const depth = depths[index] ?? 0;
    const drawerWidth = width || 0;
    const drawerDepth = depth || 0;
    const drawerUsableWidth = width || 0;
    const drawerUsableDepth = depth || 0;

    return {
      drawerIndex: index + 1,
      drawerCapacity: capacities[index] ?? 0,
      drawerWidth,
      drawerHeight: height ?? 0,
      drawerDepth,
      drawerUsableWidth,
      drawerUsableDepth,
      colour: toolstorage.storageColour || "",
      locked: false,

      sets: [],
      placements: [],
    };
  });
}

function buildDrawersForStorages(toolstorages) {
  const storageSelectionCount = (toolstorages || []).length;
  let nextDrawerIndex = 1;

  return (toolstorages || []).flatMap((toolstorage) =>
    buildDrawersForStorage(toolstorage).map((drawer, localIndex) => ({
      ...drawer,
      drawerIndex: nextDrawerIndex++,
      storageItemId: toolstorage.itemId,
      storageDescription: toolstorage.description || "",
      storageProductType: toolstorage.productType || "",
      storageLocalDrawerIndex: localIndex + 1,
      storageSelectionCount,
    })),
  );
}

function resolveSelectedSets(selectedIds, allSets) {
  const setMap = new Map(allSets.map((set) => [set.itemId, set]));
  const resolved = [];

  // Preserve duplicates: each occurrence in the input represents one set instance.
  for (const id of selectedIds || []) {
    const set = setMap.get(id);
    if (set) {
      resolved.push(set);
    }
  }

  return resolved;
}

function compareSetsForPacking(a, b) {
  const areaA = (a.setWidth || 0) * (a.setDepth || 0);
  const areaB = (b.setWidth || 0) * (b.setDepth || 0);
  if (areaA !== areaB) return areaB - areaA;

  const depthA = a.setDepth || 0;
  const depthB = b.setDepth || 0;
  if (depthA !== depthB) return depthB - depthA;

  const widthA = a.setWidth || 0;
  const widthB = b.setWidth || 0;
  if (widthA !== widthB) return widthB - widthA;

  return String(a.itemId || "").localeCompare(String(b.itemId || ""));
}

function sortSetsForPacking(sets) {
  return (sets || []).slice().sort(compareSetsForPacking);
}

exports.buildDrawersForStorage = buildDrawersForStorage;
exports.buildDrawersForStorages = buildDrawersForStorages;
exports.resolveSelectedSets = resolveSelectedSets;
exports.compareSetsForPacking = compareSetsForPacking;
exports.sortSetsForPacking = sortSetsForPacking;
});

__define("features/drawer-layout/drawer-renderer.js", (exports, __require) => {
const { t } = __require("shared/i18n/toolkit-i18n.js");
const { escapeHtml } = __require("shared/utils/string-utils.js");
const { getDrawerWeightUsage } = __require("features/drawer-layout/drawer-weight-service.js");
function renderEmptyState() {
  const container = document.getElementById("recommendationsGrid");
  if (!container) return;

  container.innerHTML = `
    <div class="border-t border-gray-200 bg-white p-10 text-center">
      <div class="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-gray-100 text-gray-400">
        <svg viewBox="0 0 24 24" aria-hidden="true" class="h-6 w-6 stroke-current" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M3 6h18"></path>
          <path d="M7 12h10"></path>
          <path d="M10 18h4"></path>
        </svg>
      </div>
      <h3 class="mt-4 text-base font-semibold text-gray-900">${escapeHtml(t("noConfigurationRendered", "No configuration rendered"))}</h3>
      <p class="mx-auto mt-2 max-w-md text-sm leading-6 text-gray-500">${escapeHtml(t("selectToolStorageAndConfigure", "Select a tool storage and configure its contents."))}</p>
    </div>
  `;
}

function renderSelectedToolstorage(toolstorage) {
  const container = document.getElementById("selectedToolstorageCard");
  if (!container) return;

  const selectedStorages = Array.isArray(toolstorage)
    ? toolstorage.filter(Boolean)
    : toolstorage
      ? [toolstorage]
      : [];

  if (!selectedStorages.length) {
    container.innerHTML = `
      <div class="text-center text-sm text-gray-500">
        <div class="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-gray-100 text-gray-400">
          <svg viewBox="0 0 24 24" aria-hidden="true" class="h-6 w-6 stroke-current" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <rect x="3" y="7" width="18" height="13" rx="2"></rect>
            <path d="M8 7V5a4 4 0 0 1 8 0v2"></path>
          </svg>
        </div>
        <h3 class="mt-4 text-base font-semibold text-gray-900">${escapeHtml(t("selectedToolStorage", "Selected tool storage"))}</h3>
        <p class="mx-auto mt-2 max-w-md text-sm leading-6 text-gray-500">${escapeHtml(t("noToolStorageSelected", "No tool storage selected."))}</p>
      </div>
    `;
    return;
  }

  const cardsHtml = selectedStorages
    .map((storage) => {
      const description = escapeHtml(storage.description || t("toolStorage", "Tool storage"));
      const itemId = escapeHtml(storage.itemId || "");
      const productType = escapeHtml(storage.productType || t("toolStorage", "Tool storage"));
      const imageUrl = escapeHtml(storage.itemImageUrl || "data/imgsource.png");
      const imageAlt = escapeHtml(`${storage.description || t("toolStorage", "Tool storage")} ${storage.itemId || ""}`.trim());

      return `
        <div class="flex w-full max-w-[260px] flex-col items-center gap-4 print:max-w-[42mm] print:gap-2">
          <a class="relative flex h-[220px] w-[220px] max-w-[160px] shrink-0 items-center justify-center overflow-hidden rounded-xl bg-white print:h-[160px] print:w-[160px]" href="#" data-action="open-product-modal" data-item-type="toolstorage" data-item-id="${itemId}">
            <img class="h-full w-full object-contain" src="${imageUrl}" alt="${imageAlt}" loading="lazy">
          </a>
          <div class="min-w-0 text-center">
            <div class="flex items-start justify-center gap-4">
              <div>
                <span class="py-0.5 text-[10px] font-semibold uppercase tracking-wide text-gray-600">${productType}</span>
                <h5 class="text-sm font-semibold uppercase tracking-wide text-gray-900">${description}</h5>
                <p class="text-xs text-gray-500">${itemId}</p>
              </div>
            </div>
          </div>
        </div>
      `;
    })
    .join("");

  container.innerHTML = `
  <h5 class="pb-4 text-lg font-semibold uppercase tracking-wide text-gray-900">${escapeHtml(t("selectedToolStorageColon", "Selected tool storage:"))}</h5>
  <div class="flex flex-wrap gap-6 print:items-start">
      ${cardsHtml}
    </div>
  `;
}

function renderConfiguration(drawers, unplacedSets, errors) {
  const container = document.getElementById("recommendationsGrid");
  if (!container) return;

  container.innerHTML = "";

  if (!drawers.length) {
    container.innerHTML = `
      <div class="rounded-lg border border-gray-200 bg-white p-6 text-center text-sm text-gray-500">
        ${escapeHtml(t("noConfigurationRendered", "No configuration rendered."))}
      </div>
    `;
    return;
  }

  if (unplacedSets.length || errors.length) {
    container.appendChild(createUnplacedSection(unplacedSets, errors));
  }

  drawers.forEach((drawer) => {
    container.appendChild(createDrawerSection(drawer));
  });
}

function createDrawerSection(drawer) {
  const section = document.createElement("section");

  const canvasStyle =
    drawer.drawerWidth && drawer.drawerDepth
      ? ` style="width:min(100%, ${drawer.drawerWidth}px); aspect-ratio:${drawer.drawerWidth} / ${drawer.drawerDepth};"`
      : "";

  const listEntries = (drawer.placements || [])
    .slice()
    .sort((a, b) => (a.y - b.y) || (a.x - b.x))
    .map((item) => item.set);

  const drawerLabel = drawer.storageLocalDrawerIndex || drawer.drawerIndex;
  const storageLabel = drawer.storageSelectionCount > 1
    ? `${escapeHtml(drawer.storageProductType || t("toolStorage", "Tool storage"))} ${escapeHtml(drawer.storageItemId || "")}`.trim()
    : "";
  const {
    currentWeightGrams,
    capacityGrams,
    percent: drawerWeightPercent,
    level: drawerWeightLevel,
  } = getDrawerWeightUsage(drawer);
  const drawerLockLabel = drawer.locked
    ? escapeHtml(t("lockedDrawer", "Locked drawer"))
    : escapeHtml(t("unlockedDrawer", "Unlocked drawer"));
  const drawerLockAction = drawer.locked ? "locked-drawer" : "unlocked-drawer";
  const drawerLockIcon = drawer.locked
    ? `
      <svg viewBox="0 0 24 24" aria-hidden="true" fill="none" class="print:hidden h-6 w-6 pb-1 text-red-600 stroke-current" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="12" cy="16" r="1"></circle>
        <rect x="3" y="10" width="18" height="12" rx="2"></rect>
        <path d="M7 10V7a5 5 0 0 1 10 0v3"></path>
      </svg>
    `
    : `
      <svg viewBox="0 0 24 24" aria-hidden="true" fill="none" class="print:hidden h-6 w-6 pb-1 text-emerald-500 stroke-current" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="12" cy="16" r="1"></circle>
        <rect width="18" height="12" x="3" y="10" rx="2"></rect>
        <path d="M7 10V7a5 5 0 0 1 9.33-2.5"></path>
      </svg>
    `;
  const lockedOverlay = drawer.locked
    ? `<div class="absolute inset-0 z-20 cursor-not-allowed bg-gray-900/40 print:hidden" data-drawer-locked-overlay="true"></div>`
    : "";

  const hasNoSets = listEntries.length === 0;
  const setListHtml = listEntries.length
    ? listEntries
        .map((set) => {
          const escapedSetId = escapeHtml(set.itemId);
          const escapedDescription = escapeHtml(set.description);

          return `
          <li data-drawer-set-list-item="true" data-set-id="${escapedSetId}" data-drawer-index="${drawer.drawerIndex}">
            <button
              type="button"
              class="drawer-set-list-button flex w-full items-start gap-2 bg-white px-3 py-2 text-left text-sm leading-snug transition hover:bg-gray-50"
              data-action="open-product-modal"
              data-item-type="toolset"
              data-item-id="${escapedSetId}"
              aria-label="${escapeHtml(t("openProductDetailsFor", "Open product details for"))} ${escapedSetId}"
            >
               <svg viewBox="0 0 24 24" aria-hidden="true" stroke="rgba(200, 200, 200, 1)" fill="none" class="print:hidden h-6 w-6 pb-1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 7v14"></path><path d="M16 12h2"></path><path d="M16 8h2"></path><path d="M3 18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a4 4 0 0 1 4 4 4 4 0 0 1 4-4h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-6a3 3 0 0 0-3 3 3 3 0 0 0-3-3z"></path><path d="M6 12h2"></path><path d="M6 8h2"></path></svg>
              <strong class="shrink-0">${escapedSetId}</strong><span class="text-gray-600">${escapedDescription}</span>
            </button>
          </li>
        `;
        })
        .join("")
    : `<li class="p-3 text-sm text-gray-500 print:hidden">${escapeHtml(t("noSetsPlacedInDrawer", "No sets placed in this drawer."))}</li>`;
  const progressBarColorClass = drawerWeightLevel === "danger"
    ? "bg-red-600"
    : drawerWeightLevel === "warning"
      ? "bg-orange-500"
      : "bg-emerald-500";
  const drawerWeightTitle = `${formatWeightKg(currentWeightGrams)} / ${formatWeightKg(capacityGrams)}`;
  const progressBarHtml = `
    <div class="flex items-center gap-3 px-3 pb-3 print:hidden" title="${escapeHtml(drawerWeightTitle)}" aria-label="${escapeHtml(drawerWeightTitle)}">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="h-6 w-6 shrink-0 pb-1 text-gray-500"><circle cx="12" cy="5" r="3"></circle><path d="M6.5 8a2 2 0 0 0-1.905 1.46L2.1 18.5A2 2 0 0 0 4 21h16a2 2 0 0 0 1.925-2.54L19.4 9.5A2 2 0 0 0 17.48 8Z"></path></svg>
      <div class="h-2 flex-1 overflow-hidden rounded-full bg-gray-200">
        <div class="h-full rounded-full transition-[width] ${progressBarColorClass}" style="width:${drawerWeightPercent}%;"></div>
      </div>
    </div>
  `;

  section.className = `grid items-center gap-8 border-t border-gray-200 pt-8 grid-cols-1 md:grid-cols-2 print:break-inside-avoid print:grid-cols-[100mm_1fr] print:gap-[6mm] print:pb-[9mm] print:px-[9mm] ${hasNoSets ? " print:hidden" : ""}`;

  const visualItems = buildDrawerVisualItems(drawer);
  const isDesktop = typeof window !== "undefined" && window.matchMedia
    ? window.matchMedia("(min-width: 768px)").matches
    : true;
  const openAttr = isDesktop ? " open" : "";

  section.innerHTML = `
    <div class="min-w-0 print:break-inside-avoid">
      <details class="group relative bg-white"${openAttr}>
        <button
          type="button"
          class="absolute right-8 top-1 z-10 inline-flex items-center justify-center rounded p-1 text-gray-600 hover:text-gray-900 print:hidden"
          data-action="${drawerLockAction}"
          data-drawer-index="${drawer.drawerIndex}"
          aria-label="${drawerLockLabel}"
          draggable="false"
        >
          ${drawerLockIcon}
        </button>
        <summary class="flex cursor-pointer items-center justify-between gap-3 px-3 py-2 pr-16 border-b border-gray-200 text-sm font-semibold text-gray-900">
          <div class="flex min-w-0 flex-1 items-center gap-3">
            <span>${escapeHtml(t("drawer", "Drawer"))} ${drawerLabel}</span>
            ${storageLabel ? `<span class="text-xs font-medium text-gray-600">${storageLabel}</span>` : ""}
          </div>
          <svg viewBox="0 0 24 24" aria-hidden="true" class="h-4 w-4 text-gray-500 transition-transform group-open:rotate-180 print:hidden" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="6 9 12 15 18 9"></polyline>
          </svg>
        </summary>
        <div class="">
          <ul class="grid gap-1 p-3">${setListHtml}</ul>
          ${progressBarHtml}
        </div>
      </details>
    </div>
    <div class="min-w-0 print:break-inside-avoid">
      <div class="relative w-full overflow-hidden border border-gray-200 bg-gray-200 shadow-sm print:shadow-none print:bg-none print:border-0" data-dropzone="true" data-drawer-index="${drawer.drawerIndex}"${canvasStyle}>
        <div class="absolute inset-0">
          ${visualItems
            .map((item) =>
              createPlacedSetTile(
                item.set,
                item.leftPct,
                item.topPct,
                item.widthPct,
                item.heightPct,
                drawer.drawerIndex,
                item.x,
                item.y,
                item.width,
                item.depth,
              ),
            )
            .join("")}
        </div>
        <div class="absolute inset-0 pointer-events-none" data-drop-overlay="true"></div>
        ${lockedOverlay}
      </div>
    </div>
  `;

  return section;
}

function formatWeightKg(weightGrams) {
  return `${((Number(weightGrams) || 0) / 1000).toFixed(1)} kg`;
}

function buildDrawerVisualItems(drawer) {
  const items = [];
  const usableWidth = drawer.drawerUsableWidth || 0;
  const usableDepth = drawer.drawerUsableDepth || 0;
  if (usableWidth <= 0 || usableDepth <= 0) {
    return items;
  }

  const toPercent = (value, total) => {
    if (total <= 0) return 0;
    return Math.max(0, Math.min(100, (value / total) * 100));
  };

  (drawer.placements || []).forEach((placement) => {
    items.push({
      set: placement.set,
      x: placement.x,
      y: placement.y,
      width: placement.width,
      depth: placement.depth,
      leftPct: toPercent(placement.x, usableWidth),
      topPct: toPercent(placement.y, usableDepth),
      widthPct: toPercent(placement.width, usableWidth),
      heightPct: toPercent(placement.depth, usableDepth),
    });
  });

  return items;
}

function createPlacedSetTile(
  set,
  leftPct = 0,
  topPct = 0,
  widthPct = 0,
  heightPct = 0,
  drawerIndex,
  x,
  y,
  width,
  depth,
) {
  const imageUrl = set.itemImageUrl || "";
  const safeLeft = Math.max(leftPct || 0, 0);
  const safeTop = Math.max(topPct || 0, 0);
  const safeWidth = Math.max(widthPct || 0, 0);
  const safeHeight = Math.max(heightPct || 0, 0);

  return `
    <div
      class="absolute grid min-w-0 place-items-stretch select-none touch-none"
      draggable="true"
      data-placed-set-tile="true"
      data-set-id="${escapeHtml(set.itemId)}"
      data-drawer-index="${drawerIndex}"
      data-x="${x ?? 0}"
      data-y="${y ?? 0}"
      data-width="${width ?? 0}"
      data-depth="${depth ?? 0}"
      style="left:${safeLeft}%; top:${safeTop}%; width:${safeWidth}%; height:${safeHeight}%;">
      <div class="relative h-full w-full">
        <div class="drawer-set-hover-overlay pointer-events-none absolute inset-0 z-10 rounded bg-white opacity-0 transition-opacity duration-150"></div>
        <button
          type="button"
          class="absolute right-1 top-1 z-20 inline-flex items-center justify-center rounded p-1 text-gray-600 hover:text-gray-900 print:hidden"
          data-action="remove-set"
          aria-label="${escapeHtml(t("removeSet", "Remove set"))}"
          draggable="false"
        >
          <svg viewBox="0 0 24 24" aria-hidden="true" stroke="#fcc20e" class="h-4 w-4" stroke-width="2" fill="#000000" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"></circle><path d="m15 9-6 6"></path><path d="m9 9 6 6"></path>
          </svg>
        </button>
        <div class="h-full w-full overflow-hidden rounded bg-white">
          ${
            imageUrl
              ? `
            <img
              class="block h-full w-full object-contain"
              src="${escapeHtml(imageUrl)}"
              alt="${escapeHtml(set.description || set.itemId)}"
              onerror="this.style.display='none'; this.parentElement.innerHTML='<div class=&quot;grid h-full w-full place-items-center px-1 text-center text-xs text-gray-600&quot;>${escapeHtml(set.itemId)}</div>';">
          `
              : `
            <div class="grid h-full w-full place-items-center px-1 text-center text-xs text-gray-600">${escapeHtml(set.itemId)}</div>
          `
          }
        </div>
      </div>
    </div>
  `;
}

function createUnplacedSection(unplacedSets, errors) {
  const section = document.createElement("section");
  section.className =
    "mt-5 border border-red-300 bg-red-200 px-4 py-4 text-gray-900 shadow-sm print:hidden";

  const errorHtml = errors.length
    ? `<ul class="list-disc space-y-1 pl-5 text-sm">${errors.map((e) => `<li>${escapeHtml(e)}</li>`).join("")}</ul>`
    : "";

  const unplacedHtml = unplacedSets.length
    ? `
      <div class="">
        <h3 class="text-sm font-semibold uppercase tracking-wide">${escapeHtml(t("upgradeStorageToFitSets", "Upgrade your storage to fit these sets:"))}</h3>
        <ul class="mt-2 list-disc space-y-1 pl-5 text-sm">
          ${unplacedSets
            .map(
              (set) => `
            <li data-set-id="${escapeHtml(set.itemId)}">
              <strong>${escapeHtml(set.itemId)}</strong> ${escapeHtml(set.description)}
              <button
                type="button"
                class="relative top-[0.3rem] right-1 inline-flex items-center justify-center rounded p-1 text-gray-600 hover:text-gray-900 print:hidden"
                data-action="remove-set"
                aria-label="${escapeHtml(t("removeSet", "Remove set"))}"
                draggable="false"
              >
                <svg viewBox="0 0 24 24" aria-hidden="true" stroke="#fcc20e" class="h-4 w-4" stroke-width="2" fill="#000000" stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="12" cy="12" r="10"></circle>
                  <path d="m15 9-6 6"></path>
                  <path d="m9 9 6 6"></path>
                </svg>
              </button>
            </li>
          `,
            )
            .join("")}
        </ul>
      </div>
    `
    : "";

  section.innerHTML = `
    <div class="grid gap-3">
      ${errorHtml}
      ${unplacedHtml}
    </div>
  `;

  return section;
}

exports.renderEmptyState = renderEmptyState;
exports.renderSelectedToolstorage = renderSelectedToolstorage;
exports.renderConfiguration = renderConfiguration;
});

__define("features/drawer-layout/drawer-weight-service.js", (exports, __require) => {
function nearlyEqual(a, b, epsilon = 0.001) {
  return Math.abs((a || 0) - (b || 0)) <= epsilon;
}

function matchesExcludedPlacement(placement, excludedPlacement) {
  if (!excludedPlacement) return false;
  if (placement?.set?.itemId !== excludedPlacement.itemId) return false;

  return (
    nearlyEqual(placement.x, excludedPlacement.x) &&
    nearlyEqual(placement.y, excludedPlacement.y) &&
    nearlyEqual(placement.width, excludedPlacement.width) &&
    nearlyEqual(placement.depth, excludedPlacement.depth)
  );
}

function getSetWeightGrams(set) {
  return Number(set?.itemWeight) || 0;
}

function getDrawerCapacityGrams(drawer) {
  const capacityKg = Number(drawer?.drawerCapacity) || 0;
  return capacityKg > 0 ? capacityKg * 1000 : 0;
}

function getDrawerCurrentWeightGrams(drawer, { excludePlacement = null } = {}) {
  const placements = Array.isArray(drawer?.placements) ? drawer.placements : [];

  return placements.reduce((totalWeight, placement) => {
    if (!placement?.set) return totalWeight;
    if (matchesExcludedPlacement(placement, excludePlacement)) return totalWeight;
    return totalWeight + getSetWeightGrams(placement.set);
  }, 0);
}

function canDrawerAcceptSetWeight(drawer, set, { excludePlacement = null } = {}) {
  const capacityGrams = getDrawerCapacityGrams(drawer);
  if (capacityGrams <= 0) return true;

  const currentWeightGrams = getDrawerCurrentWeightGrams(drawer, { excludePlacement });
  const setWeightGrams = getSetWeightGrams(set);

  return currentWeightGrams + setWeightGrams <= capacityGrams;
}

function getDrawerWeightUsage(drawer) {
  const currentWeightGrams = getDrawerCurrentWeightGrams(drawer);
  const capacityGrams = getDrawerCapacityGrams(drawer);
  const ratio = capacityGrams > 0 ? currentWeightGrams / capacityGrams : 0;
  const percent = Math.max(0, Math.min(100, ratio * 100));

  let level = "safe";
  if (ratio >= 0.9) {
    level = "danger";
  } else if (ratio >= 0.75) {
    level = "warning";
  }

  return {
    currentWeightGrams,
    capacityGrams,
    ratio,
    percent,
    level,
  };
}

exports.getSetWeightGrams = getSetWeightGrams;
exports.getDrawerCapacityGrams = getDrawerCapacityGrams;
exports.getDrawerCurrentWeightGrams = getDrawerCurrentWeightGrams;
exports.canDrawerAcceptSetWeight = canDrawerAcceptSetWeight;
exports.getDrawerWeightUsage = getDrawerWeightUsage;
});

__define("features/drawer-layout/maxrects-service.js", (exports, __require) => {
function roundRect(value) {
  return Math.round(value * 1000) / 1000;
}

function rectsOverlap(a, b) {
  return (
    a.x < b.x + b.width &&
    a.x + a.width > b.x &&
    a.y < b.y + b.height &&
    a.y + a.height > b.y
  );
}

function rectContainedIn(rect, container) {
  return (
    rect.x >= container.x &&
    rect.y >= container.y &&
    rect.x + rect.width <= container.x + container.width &&
    rect.y + rect.height <= container.y + container.height
  );
}

function dedupeRects(rects) {
  const seen = new Set();
  const result = [];

  rects.forEach((rect) => {
    const key = `${roundRect(rect.x)}:${roundRect(rect.y)}:${roundRect(rect.width)}:${roundRect(rect.height)}`;
    if (!seen.has(key)) {
      seen.add(key);
      result.push(rect);
    }
  });

  return result;
}

function dedupePlacements(rects) {
  const seen = new Set();
  const result = [];

  rects.forEach((rect) => {
    const key = `${roundRect(rect.x)}:${roundRect(rect.y)}:${roundRect(rect.width)}:${roundRect(rect.height)}`;
    if (!seen.has(key)) {
      seen.add(key);
      result.push(rect);
    }
  });

  return result;
}

function maxRectsSplitFreeRectangles(freeRects, usedRect) {
  const result = [];

  freeRects.forEach((freeRect) => {
    if (!rectsOverlap(freeRect, usedRect)) {
      result.push(freeRect);
      return;
    }

    if (usedRect.x > freeRect.x) {
      result.push({
        x: freeRect.x,
        y: freeRect.y,
        width: usedRect.x - freeRect.x,
        height: freeRect.height,
      });
    }

    if (usedRect.x + usedRect.width < freeRect.x + freeRect.width) {
      result.push({
        x: usedRect.x + usedRect.width,
        y: freeRect.y,
        width: freeRect.x + freeRect.width - (usedRect.x + usedRect.width),
        height: freeRect.height,
      });
    }

    if (usedRect.y > freeRect.y) {
      result.push({
        x: freeRect.x,
        y: freeRect.y,
        width: freeRect.width,
        height: usedRect.y - freeRect.y,
      });
    }

    if (usedRect.y + usedRect.height < freeRect.y + freeRect.height) {
      result.push({
        x: freeRect.x,
        y: usedRect.y + usedRect.height,
        width: freeRect.width,
        height: freeRect.y + freeRect.height - (usedRect.y + usedRect.height),
      });
    }
  });

  return result.filter((rect) => rect.width > 0 && rect.height > 0);
}

function maxRectsPruneFreeList(rects) {
  const filtered = rects.filter((rect) => rect.width > 0 && rect.height > 0);
  const pruned = [];

  for (let i = 0; i < filtered.length; i += 1) {
    let contained = false;

    for (let j = 0; j < filtered.length; j += 1) {
      if (i === j) continue;
      if (rectContainedIn(filtered[i], filtered[j])) {
        contained = true;
        break;
      }
    }

    if (!contained) {
      pruned.push(filtered[i]);
    }
  }

  return dedupeRects(pruned);
}

function computeDepthPreferenceBias(y, depth, drawerDepth) {
  if (drawerDepth <= 0) return 0;
  const depthRatio = depth / drawerDepth;
  if (depthRatio <= 0.5) {
    return y;
  }
  const bottomGap = drawerDepth - (y + depth);
  return Math.max(bottomGap, 0);
}

function scoreMaxRectsPackingPlacement(freeRect, width, height, drawerDepth) {
  const leftoverHoriz = freeRect.width - width;
  const leftoverVert = freeRect.height - height;

  return {
    shortSideFit: Math.min(leftoverHoriz, leftoverVert),
    areaFit: freeRect.width * freeRect.height - width * height,
    depthPreference: computeDepthPreferenceBias(freeRect.y, height, drawerDepth),
    y: freeRect.y,
    x: freeRect.x,
  };
}

function compareMaxRectsPackingScores(a, b) {
  if (a.shortSideFit !== b.shortSideFit) return a.shortSideFit - b.shortSideFit;
  if (a.areaFit !== b.areaFit) return a.areaFit - b.areaFit;
  if (a.depthPreference !== b.depthPreference) return a.depthPreference - b.depthPreference;
  if (a.y !== b.y) return a.y - b.y;
  if (a.x !== b.x) return a.x - b.x;
  return 0;
}

function findBestMaxRectsPlacementForPacking(freeRects, set, drawerDepth) {
  const width = set.setWidth || 0;
  const height = set.setDepth || 0;
  if (width <= 0 || height <= 0) return null;

  let best = null;
  let bestScore = null;

  freeRects.forEach((freeRect) => {
    if (width > freeRect.width || height > freeRect.height) return;

    const score = scoreMaxRectsPackingPlacement(freeRect, width, height, drawerDepth);

    if (!bestScore || compareMaxRectsPackingScores(score, bestScore) < 0) {
      bestScore = score;
      best = {
        x: freeRect.x,
        y: freeRect.y,
        width,
        height,
      };
    }
  });

  return best;
}

function getPlacementAnchors(freeRect, width, height) {
  const anchors = [
    { x: freeRect.x, y: freeRect.y }, // top-left
    { x: freeRect.x + freeRect.width - width, y: freeRect.y }, // top-right
    { x: freeRect.x, y: freeRect.y + freeRect.height - height }, // bottom-left
    { x: freeRect.x + freeRect.width - width, y: freeRect.y + freeRect.height - height }, // bottom-right
  ];

  return dedupeRects(
    anchors.map((anchor) => ({
      x: roundRect(anchor.x),
      y: roundRect(anchor.y),
      width,
      height,
    })),
  ).map(({ x, y }) => ({ x, y }));
}

function scorePlacementCandidate(freeRect, anchor, width, height) {
  const leftoverLeft = anchor.x - freeRect.x;
  const leftoverRight = freeRect.x + freeRect.width - (anchor.x + width);
  const leftoverTop = anchor.y - freeRect.y;
  const leftoverBottom = freeRect.y + freeRect.height - (anchor.y + height);

  return {
    shortSideFit: Math.min(leftoverLeft, leftoverRight, leftoverTop, leftoverBottom),
    longSideFit: Math.max(leftoverLeft, leftoverRight, leftoverTop, leftoverBottom),
  };
}

function buildMaxRectsState(drawer, excludePlacement) {
  const usableWidth = drawer.drawerUsableWidth || 0;
  const usableDepth = drawer.drawerUsableDepth || 0;

  if (usableWidth <= 0 || usableDepth <= 0) {
    return [];
  }

  let freeRects = [
    {
      x: 0,
      y: 0,
      width: usableWidth,
      height: usableDepth,
    },
  ];

  const occupied = (drawer.placements || [])
    .filter((p) => p.set && !isExcludedPlacement(p, excludePlacement))
    .map((p) => ({
      x: p.x,
      y: p.y,
      width: p.width,
      height: p.depth,
    }));

  occupied.forEach((rect) => {
    freeRects = maxRectsSplitFreeRectangles(freeRects, rect);
    freeRects = maxRectsPruneFreeList(freeRects);
  });

  return freeRects;
}

function findMaxRectsPlacements(freeRects, set) {
  const width = set.setWidth || 0;
  const height = set.setDepth || 0;
  if (width <= 0 || height <= 0) return [];

  const candidates = [];

  freeRects.forEach((freeRect) => {
    if (width > freeRect.width || height > freeRect.height) return;

    const anchors = getPlacementAnchors(freeRect, width, height);

    anchors.forEach((anchor) => {
      const score = scorePlacementCandidate(freeRect, anchor, width, height);

      candidates.push({
        x: anchor.x,
        y: anchor.y,
        width,
        height,
        _scoreShort: score.shortSideFit,
        _scoreLong: score.longSideFit,
        _sourceArea: freeRect.width * freeRect.height,
      });
    });
  });

  candidates.sort((a, b) => {
    if (a._scoreShort !== b._scoreShort) return a._scoreShort - b._scoreShort;
    if (a._scoreLong !== b._scoreLong) return a._scoreLong - b._scoreLong;
    if (a.y !== b.y) return a.y - b.y;
    if (a.x !== b.x) return a.x - b.x;
    return a._sourceArea - b._sourceArea;
  });

  return dedupePlacements(candidates).map(({ _scoreShort, _scoreLong, _sourceArea, ...rect }) => rect);
}

function getValidFreeRectangles(drawer, set, excludePlacement) {
  if (!drawer || !set) return [];
  if ((set.setHeight || 0) > (drawer.drawerHeight || 0)) return [];

  const freeRects = buildMaxRectsState(drawer, excludePlacement);
  return findMaxRectsPlacements(freeRects, set);
}

function nearlyEqual(a, b, epsilon = 0.001) {
  return Math.abs((a || 0) - (b || 0)) <= epsilon;
}

function isExcludedPlacement(placement, excludePlacement) {
  if (!excludePlacement) return false;

  const excludeId = excludePlacement.itemId || "";
  const placementId = placement?.set?.itemId || "";
  if (excludeId && placementId && excludeId !== placementId) return false;

  return (
    nearlyEqual(placement.x, excludePlacement.x) &&
    nearlyEqual(placement.y, excludePlacement.y) &&
    nearlyEqual(placement.width, excludePlacement.width) &&
    nearlyEqual(placement.depth, excludePlacement.height)
  );
}

function pickTargetRect(rects, x, y) {
  if (!rects.length) return null;

  let best = rects[0];
  let bestDistance = distanceToRect(rects[0], x, y);

  for (let i = 1; i < rects.length; i += 1) {
    const dist = distanceToRect(rects[i], x, y);
    if (dist < bestDistance) {
      best = rects[i];
      bestDistance = dist;
    }
  }

  return best;
}

function distanceToRect(rect, x, y) {
  const dx =
    x < rect.x ? rect.x - x : x > rect.x + rect.width ? x - (rect.x + rect.width) : 0;

  const dy =
    y < rect.y ? rect.y - y : y > rect.y + rect.height ? y - (rect.y + rect.height) : 0;

  return Math.sqrt(dx * dx + dy * dy);
}

function distanceToRectCenter(rect, x, y) {
  const centerX = rect.x + rect.width / 2;
  const centerY = rect.y + rect.height / 2;
  const dx = centerX - x;
  const dy = centerY - y;
  return Math.sqrt(dx * dx + dy * dy);
}

function pointInRect(rect, x, y) {
  return x >= rect.x && y >= rect.y && x <= rect.x + rect.width && y <= rect.y + rect.height;
}

exports.maxRectsSplitFreeRectangles = maxRectsSplitFreeRectangles;
exports.maxRectsPruneFreeList = maxRectsPruneFreeList;
exports.findBestMaxRectsPlacementForPacking = findBestMaxRectsPlacementForPacking;
exports.buildMaxRectsState = buildMaxRectsState;
exports.findMaxRectsPlacements = findMaxRectsPlacements;
exports.getValidFreeRectangles = getValidFreeRectangles;
exports.pickTargetRect = pickTargetRect;
exports.distanceToRect = distanceToRect;
exports.distanceToRectCenter = distanceToRectCenter;
exports.pointInRect = pointInRect;
});

__define("features/fab-actions/fab-actions.js", (exports, __require) => {
const { byId } = __require("shared/dom/dom-helpers.js");
function closeFab(fab) {
  fab.classList.remove("active");
}

function wireFabActions() {
  const fab = byId("fabActions");
  if (!fab) return;

  const toggleButton =
    fab.querySelector("[data-fab-toggle=\"true\"]") || fab.querySelector("button");
  if (!toggleButton) return;

  toggleButton.addEventListener("click", (event) => {
    event.preventDefault();
    event.stopPropagation();
    fab.classList.toggle("active");
  });

  document.addEventListener("click", () => closeFab(fab));

  document.addEventListener("keydown", (event) => {
    if (event.key !== "Escape") return;
    closeFab(fab);
  });

  const actions = fab.querySelector("ul");
  if (actions) {
    actions.addEventListener("click", () => closeFab(fab));
  }
}


exports.wireFabActions = wireFabActions;
});

__define("features/product-details/product-detail-modal.js", (exports, __require) => {
const { t } = __require("shared/i18n/toolkit-i18n.js");
const { escapeHtml } = __require("shared/utils/string-utils.js");
function wireProductModal(state) {
  const modal = document.getElementById("productDetailModal");
  if (!modal) return;

  const closeBtn = document.getElementById("productDetailClose");
  if (closeBtn) {
    closeBtn.addEventListener("click", closeProductModal);
  }

  modal.addEventListener("click", (event) => {
    if (event.target === modal) closeProductModal();
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") closeProductModal();
  });

  document.addEventListener("click", (event) => handleProductModalClick(event, state));
}

function lockPageScroll() {
  const body = document.body;
  const html = document.documentElement;
  if (!body || !html) return;

  const currentLocks = Number.parseInt(body.dataset.scrollLockCount || "0", 10) || 0;
  body.dataset.scrollLockCount = String(currentLocks + 1);
  if (currentLocks > 0) return;

  const state = {
    body: {
      overflow: body.style.overflow,
      paddingRight: body.style.paddingRight,
    },
    html: {
      overflow: html.style.overflow,
    },
  };

  body.dataset.scrollLockState = JSON.stringify(state);

  const scrollbarWidth = window.innerWidth - html.clientWidth;
  if (scrollbarWidth > 0) body.style.paddingRight = `${scrollbarWidth}px`;

  html.style.overflow = "hidden";
  body.style.overflow = "hidden";
}

function unlockPageScroll() {
  const body = document.body;
  const html = document.documentElement;
  if (!body || !html) return;

  const currentLocks = Number.parseInt(body.dataset.scrollLockCount || "0", 10) || 0;
  if (currentLocks <= 1) {
    body.dataset.scrollLockCount = "0";

    let state = null;
    try {
      state = JSON.parse(body.dataset.scrollLockState || "null");
    } catch {
      state = null;
    }

    body.style.position = state?.body?.position ?? "";
    body.style.top = state?.body?.top ?? "";
    body.style.left = state?.body?.left ?? "";
    body.style.right = state?.body?.right ?? "";
    body.style.width = state?.body?.width ?? "";
    body.style.overflow = state?.body?.overflow ?? "";
    body.style.paddingRight = state?.body?.paddingRight ?? "";
    html.style.overflow = state?.html?.overflow ?? "";

    delete body.dataset.scrollLockState;
    return;
  }

  body.dataset.scrollLockCount = String(currentLocks - 1);
}

function handleProductModalClick(event, state) {
  const trigger = event.target.closest("[data-action=\"open-product-modal\"]");
  if (!trigger) return;

  event.preventDefault();

  const type = trigger.getAttribute("data-item-type");
  const itemId = trigger.getAttribute("data-item-id");
  if (!type || !itemId) return;

  const item = type === "toolstorage" ? state.toolStorageMap.get(itemId) : state.toolSetMap.get(itemId);
  if (!item) return;

  openProductModal(item, type);
}

function openProductModal(item, type) {
  const modal = document.getElementById("productDetailModal");
  const body = document.getElementById("productDetailBody");
  const title = document.getElementById("productDetailTitle");
  if (!modal || !body || !title) return;

  const wasHidden = modal.classList.contains("hidden");

  const description = escapeHtml(item.description || item.itemId || t("product", "Product"));
  const itemId = escapeHtml(item.itemId || "");
  const imageUrl = escapeHtml(item.itemImageUrl || "data/imgsource.png");
  const imageAlt = escapeHtml(`${item.description || t("product", "Product")} ${item.itemId || ""}`.trim());

  const typeLabel =
    type === "toolstorage"
      ? escapeHtml(item.productType || t("toolStorage", "Tool storage"))
      : escapeHtml(item.typeOfSet || t("toolSet", "Tool set"));

  const rows = type === "toolstorage" ? buildToolstorageDetailRows(item) : buildToolSetDetailRows(item);
  const storageFeatures = type === "toolstorage" ? buildStorageFeaturesList(item) : "";

  title.textContent = item.description || item.itemId || t("productDetails", "Product details");

  body.innerHTML = `
    <div class="flex aspect-square items-center justify-center p-3">
      <img class="max-h-full max-w-full object-contain" src="${imageUrl}" alt="${imageAlt}" loading="lazy" />
    </div>
    <div class="grid gap-3">
      <div>
        <span class="text-xs font-semibold uppercase tracking-wide text-gray-500">${typeLabel}</span>
        <h4 class="my-3 text-base font-semibold uppercase leading-snug text-gray-900">${description}</h4>
        <p class="text-xs text-gray-500">${itemId}</p>
        ${storageFeatures}
      </div>
      <dl class="grid pb-3 pr-3 text-sm text-gray-600">${rows}</dl>
    </div>
  `;

  modal.classList.remove("hidden");
  modal.classList.add("flex");
  if (wasHidden) lockPageScroll();
}

function closeProductModal() {
  const modal = document.getElementById("productDetailModal");
  if (!modal || modal.classList.contains("hidden")) return;
  modal.classList.add("hidden");
  modal.classList.remove("flex");
  unlockPageScroll();
}

function buildToolstorageDetailRows(item) {
  const colour = escapeHtml(item.storageColour || t("notAvailable", "N/A"));
  const drawerCount =
    Number.isFinite(item.numberOfDrawerInStorage) && item.numberOfDrawerInStorage > 0
      ? `${item.numberOfDrawerInStorage} ${t("drawersLowercase", "drawers")}`
      : t("drawerCountNotAvailable", "Drawer count N/A");

  return `
    ${buildDetailRow(t("colour", "Colour"), colour)}
    ${buildDetailRow(t("drawers", "Drawers"), drawerCount)}
  `;
}

function buildToolSetDetailRows(item) {
  const typeOfSet = escapeHtml(item.typeOfSet || t("notAvailable", "N/A"));
  const width = formatNumber(item.setWidth);
  const depth = formatNumber(item.setDepth);
  const height = formatNumber(item.setHeight);
  const weight = formatNumber(item.itemWeight);

  return `
    ${buildDetailRow(t("type", "Type"), typeOfSet)}
    ${buildDetailRow(t("width", "Width"), width)}
    ${buildDetailRow(t("depth", "Depth"), depth)}
    ${buildDetailRow(t("height", "Height"), height)}
    ${buildDetailRow(t("weight", "Weight"), weight)}
  `;
}

function buildDetailRow(label, value, ddExtra = "") {
  return `
    <div class="flex items-center justify-between gap-3 px-3 py-2  odd:bg-gray-100 even:bg-white">
      <dt class="text-gray-600">${label}</dt>
      <dd class="${ddExtra} text-right">${value}</dd>
    </div>
  `;
}

function formatNumber(value) {
  return Number.isFinite(value) && value !== 0 ? String(value) : t("notAvailable", "N/A");
}

function buildStorageFeaturesList(item) {
  const raw = typeof item?.storageFeatures === "string" ? item.storageFeatures : "";
  const points = raw
    .split(";")
    .map((value) => escapeHtml(value.trim()))
    .filter(Boolean)
    .slice(0, 12);

  if (!points.length) return "";

  return `
    <ul class="mt-3 list-disc space-y-1 pl-5 text-sm">
      ${points.map((point) => `<li>${point}</li>`).join("")}
    </ul>
  `;
}

exports.wireProductModal = wireProductModal;
});

__define("features/tabs/tabs-ui.js", (exports, __require) => {
function initTabsUI() {
  const tabButtons = document.querySelectorAll(".tab-btn");
  const tabPanels = document.querySelectorAll(".tab-panel");

  tabButtons.forEach((button) => {
    button.addEventListener("click", () => {
      const targetPanel = button.dataset.tab;

      tabButtons.forEach((btn) => {
        btn.setAttribute("aria-selected", "false");
        btn.classList.remove("text-red-600", "border-red-600");
        btn.classList.add("text-gray-500", "border-transparent");
      });

      tabPanels.forEach((panel) => {
        panel.classList.add("hidden");
      });

      button.setAttribute("aria-selected", "true");
      button.classList.remove("text-gray-500", "border-transparent");
      button.classList.add("text-red-600", "border-red-600");

      if (targetPanel) {
        document.getElementById(targetPanel)?.classList.remove("hidden");
      }
    });
  });
}


exports.initTabsUI = initTabsUI;
});

__define("features/tool-kits/predefined-tool-kit-modal.js", (exports, __require) => {
const { t } = __require("shared/i18n/toolkit-i18n.js");
const { getDataUrls, resolveImagePath } = __require("shared/runtime/app-config.js");
const { escapeHtml } = __require("shared/utils/string-utils.js");
const { applyImportedConfiguration } = __require("features/configurator/configurator-persistence.js");
let modalWired = false;
let toolKits = null;
let toolKitsById = new Map();
let toolKitsLoadPromise = null;

function lockPageScroll() {
  const body = document.body;
  const html = document.documentElement;
  if (!body || !html) return;

  const currentLocks = Number.parseInt(body.dataset.scrollLockCount || "0", 10) || 0;
  body.dataset.scrollLockCount = String(currentLocks + 1);
  if (currentLocks > 0) return;

  const scrollY = window.scrollY || 0;
  const state = {
    scrollY,
    body: {
      position: body.style.position,
      top: body.style.top,
      left: body.style.left,
      right: body.style.right,
      width: body.style.width,
      overflow: body.style.overflow,
      paddingRight: body.style.paddingRight,
    },
    html: {
      overflow: html.style.overflow,
    },
  };

  body.dataset.scrollLockState = JSON.stringify(state);

  const scrollbarWidth = window.innerWidth - html.clientWidth;
  if (scrollbarWidth > 0) body.style.paddingRight = `${scrollbarWidth}px`;

  html.style.overflow = "hidden";
  body.style.overflow = "hidden";
  body.style.position = "fixed";
  body.style.top = `-${scrollY}px`;
  body.style.left = "0";
  body.style.right = "0";
  body.style.width = "100%";
}

function unlockPageScroll() {
  const body = document.body;
  const html = document.documentElement;
  if (!body || !html) return;

  const currentLocks = Number.parseInt(body.dataset.scrollLockCount || "0", 10) || 0;
  if (currentLocks <= 1) {
    body.dataset.scrollLockCount = "0";

    let state = null;
    try {
      state = JSON.parse(body.dataset.scrollLockState || "null");
    } catch {
      state = null;
    }

    body.style.position = state?.body?.position ?? "";
    body.style.top = state?.body?.top ?? "";
    body.style.left = state?.body?.left ?? "";
    body.style.right = state?.body?.right ?? "";
    body.style.width = state?.body?.width ?? "";
    body.style.overflow = state?.body?.overflow ?? "";
    body.style.paddingRight = state?.body?.paddingRight ?? "";
    html.style.overflow = state?.html?.overflow ?? "";

    delete body.dataset.scrollLockState;

    const scrollY = Number.isFinite(state?.scrollY) ? state.scrollY : 0;
    window.scrollTo(0, scrollY);
    return;
  }

  body.dataset.scrollLockCount = String(currentLocks - 1);
}

function closePredefinedToolKitModal() {
  const modal = document.getElementById("predefinedToolKitModal");
  if (!modal || modal.classList.contains("hidden")) return;
  modal.classList.add("hidden");
  modal.classList.remove("flex");
  unlockPageScroll();
}

async function loadToolKits() {
  if (toolKits) return toolKits;
  if (toolKitsLoadPromise) return toolKitsLoadPromise;

  toolKitsLoadPromise = (async () => {
    let lastError = null;

    for (const url of getDataUrls("toolKits")) {
      try {
        const response = await fetch(url);
        if (!response.ok) throw new Error(`Failed to load tool kits (${response.status})`);

        const parsed = await response.json();
        if (!Array.isArray(parsed)) throw new Error("Invalid tool-kits.json: expected an array.");

        toolKits = parsed.filter(Boolean);
        toolKitsById = new Map(toolKits.map((kit) => [String(kit.itemId || ""), kit]).filter(([id]) => id));
        return toolKits;
      } catch (error) {
        lastError = error;
      }
    }

    throw lastError || new Error("Missing tool-kits data URL.");
  })();

  try {
    return await toolKitsLoadPromise;
  } finally {
    toolKitsLoadPromise = null;
  }
}

function renderToolKits(kits) {
  const container = document.getElementById("predefinedToolKitList");
  if (!container) return;

  container.innerHTML = kits
    .map((kit) => {
      const itemId = escapeHtml(kit.itemId || "");
      const description = escapeHtml(kit.description || kit.itemId || t("toolKit", "Tool kit"));
      const imageUrl = escapeHtml(resolveImagePath(kit.itemImageUrl || "") || "data/imgsource.png");
      const imageAlt = escapeHtml(`${kit.description || t("toolKit", "Tool kit")} ${kit.itemId || ""}`.trim());

      return `
        <div class="relative flex w-full flex-col overflow-hidden border border-gray-100 bg-white">
          <a class="relative mx-auto mt-3 flex w-full max-w-[140px] aspect-[8/7] items-center justify-center overflow-hidden sm:max-w-[160px]" href="#" data-action="select-predefined-tool-kit" data-kit-id="${itemId}">
            <img class="h-full w-full object-contain" src="${imageUrl}" alt="${imageAlt}" loading="lazy" />
          </a>

          <div class="mt-3 px-3 pb-3">
            <a href="#" data-action="select-predefined-tool-kit" data-kit-id="${itemId}">
              <h5 class="text-xs font-semibold uppercase tracking-wide text-gray-900 leading-tight">
                ${description}
              </h5>
            </a>

            <div class="flex items-center justify-between gap-3 pt-2">
              <div class="min-w-0 print:break-inside-avoid">
                <ul class="grid gap-1">
                  <li class="grid gap-x-3 bg-white text-xs leading-tight">
                    <span class="text-gray-600">${itemId}</span>
                  </li>
                </ul>
              </div>
              <button class="inline-flex h-8 w-8 items-center justify-center rounded-full border border-gray-200 bg-gray-100 text-gray-700 transition hover:bg-gray-300" type="button" aria-label="${escapeHtml(t("loadToolKit", "Load tool kit"))}" data-action="select-predefined-tool-kit" data-kit-id="${itemId}">
                <svg viewBox="0 0 20 20" aria-hidden="true" class="h-4 w-4 fill-current">
                  <path d="M9 4a1 1 0 0 1 2 0v5h5a1 1 0 0 1 0 2h-5v5a1 1 0 1 1-2 0v-5H4a1 1 0 1 1 0-2h5V4z"></path>
                </svg>
              </button>
            </div>
          </div>
        </div>
      `;
    })
    .join("");
}

function showStatus(message) {
  const status = document.getElementById("predefinedToolKitStatus");
  if (!status) return;
  status.textContent = message || "";
}

function openPredefinedToolKitModal(state) {
  const modal = document.getElementById("predefinedToolKitModal");
  const container = document.getElementById("predefinedToolKitList");
  if (!modal || !container) return;

  if (!modalWired) {
    modalWired = true;

    const closeBtn = document.getElementById("predefinedToolKitClose");
    if (closeBtn) closeBtn.addEventListener("click", closePredefinedToolKitModal);

    modal.addEventListener("click", (event) => {
      if (event.target === modal) closePredefinedToolKitModal();
    });

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") closePredefinedToolKitModal();
    });

    modal.addEventListener("click", (event) => {
      const trigger = event.target.closest("[data-action=\"select-predefined-tool-kit\"]");
      if (!trigger) return;
      event.preventDefault();

      const kitId = trigger.getAttribute("data-kit-id");
      if (!kitId) return;

      const kit = toolKitsById.get(kitId);
      if (!kit) return;

      const applied = applyImportedConfiguration(state, kit);
      if (applied) closePredefinedToolKitModal();
    });
  }

  showStatus(t("loadingToolKits", "Loading tool kits…"));
  container.innerHTML = "";

  modal.classList.remove("hidden");
  modal.classList.add("flex");
  lockPageScroll();

  void loadToolKits()
    .then((kits) => {
      if (!modal.classList.contains("hidden")) {
        renderToolKits(kits);
        showStatus(kits.length ? "" : t("noToolKitsFound", "No tool kits found."));
      }
    })
    .catch((err) => {
      console.error(err);
      if (!modal.classList.contains("hidden")) {
        showStatus(t("configuratorDataCouldNotBeLoaded", "The configurator data could not be loaded."));
      }
    });
}

function wirePredefinedToolKitModal(state) {
  const openBtn = document.getElementById("loadPredefinedToolKit");
  const modal = document.getElementById("predefinedToolKitModal");
  if (!openBtn || !modal) return;

  openBtn.addEventListener("click", (event) => {
    event.preventDefault();
    openBtn.closest("details")?.removeAttribute("open");
    openPredefinedToolKitModal(state);
  });
}

exports.openPredefinedToolKitModal = openPredefinedToolKitModal;
exports.wirePredefinedToolKitModal = wirePredefinedToolKitModal;
});

__define("features/toolstorage-data/toolstorage-data-api.js", (exports, __require) => {
const { getDataUrls } = __require("shared/runtime/app-config.js");
function checkResponse(response) {
  if (!response.ok) {
    throw new Error(`Failed to load ${response.url}: ${response.status}`);
  }
  return response;
}

async function fetchJson(url) {
  const response = await fetch(url).then(checkResponse);
  return response.json();
}

async function fetchFirstAvailableJson(urls, resourceName) {
  let lastError = null;

  for (const url of urls) {
    try {
      return await fetchJson(url);
    } catch (error) {
      lastError = error;
    }
  }

  if (lastError) throw lastError;
  throw new Error(`Missing data URL for ${resourceName}.`);
}

function fetchToolStorageRows() {
  return fetchFirstAvailableJson(getDataUrls("toolStorages"), "toolStorages");
}

function fetchToolSetRows() {
  return fetchFirstAvailableJson(getDataUrls("toolSets"), "toolSets");
}

exports.fetchToolStorageRows = fetchToolStorageRows;
exports.fetchToolSetRows = fetchToolSetRows;
});

__define("features/toolstorage-data/toolstorage-normalizer.js", (exports, __require) => {
const { toInt, toNumber } = __require("shared/utils/number-utils.js");
const { resolveImagePath } = __require("shared/runtime/app-config.js");
const { cleanString } = __require("shared/utils/string-utils.js");
const { getStorageBrand, getStorageSelectionDepth, getStorageSelectionWidth, getStorageTypeKey } = __require("features/toolstorage-selection/toolstorage-selection-service.js");
function parseNumberList(value) {
  return cleanString(value)
    .split(";")
    .map((v) => toNumber(v))
    .filter((v) => Number.isFinite(v));
}

function normalizeToolStorages(rows) {
  return rows.map((row) => {
    const storage = {
      itemId: cleanString(row.itemId),
      altId: cleanString(row.altId),
      description: cleanString(row.description),
      productType: cleanString(row.productType),
      itemTypeOfStorage: cleanString(row.ItemTypeOfStorage),
      productArtistBrand: cleanString(row.ProductArtistBrand),
      itemWidthMm: toNumber(row.ItemWidthMm),
      itemDepthMm: toNumber(row.ItemDepthMm),
      itemImageUrl: resolveImagePath(row.itemImageUrl || ""),
      storageFeatures: cleanString(row.storageFeatures),
      numberOfDrawerInStorage: toInt(row.numberOfDrawerInStorage),
      storagePerDrawerCapacity: parseNumberList(row.storagePerDrawerCapacity),
      storagePerDrawerDepth: parseNumberList(row.storagePerDrawerDepth),
      storagePerDrawerHeight: parseNumberList(row.storagePerDrawerHeight),
      storagePerDrawerWidth: parseNumberList(row.storagePerDrawerWidth),
      storageColour: cleanString(row.storageColour),
      includes: Array.isArray(row.includes) ? row.includes.map(cleanString).filter(Boolean) : [],
    };

    return {
      ...storage,
      storageTypeKey: getStorageTypeKey(storage),
      storageBrand: getStorageBrand(storage),
      storageSelectionWidth: getStorageSelectionWidth(storage),
      storageSelectionDepth: getStorageSelectionDepth(storage),
    };
  });
}

function normalizeToolSets(rows) {
  return rows.map((row) => ({
    itemId: cleanString(row.itemId),
    altId: cleanString(row.altId),
    description: cleanString(row.description),
    typeOfSet: cleanString(row.typeOfSet),
    itemImageUrl: resolveImagePath(row.itemImageUrl || ""),
    itemWeight: toNumber(row.itemWeight),
    setWidth: toNumber(row.setWidth),
    setDepth: toNumber(row.setDepth),
    setHeight: toNumber(row.setHeight),
    raw: row,
  }));
}

exports.normalizeToolStorages = normalizeToolStorages;
exports.normalizeToolSets = normalizeToolSets;
});

__define("features/toolstorage-selection/toolstorage-selection-service.js", (exports, __require) => {
const { cleanString, uniquePreserveOrder } = __require("shared/utils/string-utils.js");
const { t } = __require("shared/i18n/toolkit-i18n.js");
const STORAGE_TYPE_ROLLER_CABINET = "roller-cabinet";
const STORAGE_TYPE_TOOL_CHEST = "tool-chest";
const STORAGE_TYPE_STACK_SYSTEM = "stack-system";
const STORAGE_TYPE_PORTABLE = "portable";

function normalizeStorageType(itemTypeOfStorage, productType) {
  const value = cleanString(itemTypeOfStorage || productType).toLowerCase();

  if (value === "roller cabinet") return STORAGE_TYPE_ROLLER_CABINET;
  if (value === "tool chest") return STORAGE_TYPE_TOOL_CHEST;
  if (value === "stack system") return STORAGE_TYPE_STACK_SYSTEM;
  if (value === "portable") return STORAGE_TYPE_PORTABLE;

  return value;
}

function getStorageTypeKey(storage) {
  return normalizeStorageType(storage?.itemTypeOfStorage, storage?.productType);
}

function getStorageBrand(storage) {
  return cleanString(storage?.productArtistBrand);
}

function getStorageSelectionWidth(storage) {
  return Number(storage?.itemWidthMm) || 0;
}

function getStorageSelectionDepth(storage) {
  return Number(storage?.itemDepthMm) || 0;
}

function getStorageNominalWidthInches(storage) {
  const description = cleanString(storage?.description);
  const match = description.match(/(\d+(?:\.\d+)?)\s*["”]/);
  return match ? Number(match[1]) || 0 : 0;
}

function parseSelectedToolStorageIds(value) {
  return cleanString(value)
    .split(/\r?\n/)
    .map(cleanString)
    .filter(Boolean);
}

function serializeSelectedToolStorageIds(ids) {
  return uniquePreserveOrder(ids || []).join("\n");
}

function compareSelectedToolStorages(left, right) {
  const leftType = getStorageTypeKey(left);
  const rightType = getStorageTypeKey(right);
  const leftIsToolChest = leftType === STORAGE_TYPE_TOOL_CHEST;
  const rightIsToolChest = rightType === STORAGE_TYPE_TOOL_CHEST;
  const leftIsRoller = leftType === STORAGE_TYPE_ROLLER_CABINET;
  const rightIsRoller = rightType === STORAGE_TYPE_ROLLER_CABINET;

  if (leftIsToolChest !== rightIsToolChest) {
    return leftIsToolChest ? -1 : 1;
  }

  if (leftIsRoller !== rightIsRoller) {
    return leftIsRoller ? 1 : -1;
  }

  if (leftIsToolChest && rightIsToolChest) {
    const drawerDifference = (Number(right?.numberOfDrawerInStorage) || 0) - (Number(left?.numberOfDrawerInStorage) || 0);
    if (drawerDifference !== 0) return drawerDifference;
  }

  const widthDifference = getStorageSelectionWidth(right) - getStorageSelectionWidth(left);
  if (widthDifference !== 0) return widthDifference;

  return String(left?.itemId || "").localeCompare(String(right?.itemId || ""));
}

function sortSelectedToolStorages(storages) {
  return (storages || []).slice().sort(compareSelectedToolStorages);
}

function resolveSelectedToolStorages(ids, toolStorageMap) {
  const selected = uniquePreserveOrder(ids || [])
    .map((itemId) => toolStorageMap.get(itemId))
    .filter(Boolean);

  return sortSelectedToolStorages(selected);
}

function buildToolStorageSelectionKey(storages) {
  return sortSelectedToolStorages(storages)
    .map((storage) => storage.itemId)
    .join("|");
}

function validateToolStorageSelection(storages) {
  const selected = sortSelectedToolStorages(storages);
  if (selected.length > 3) {
    return {
      valid: false,
      message: t("toolStorageSelectionMaxThree", "You can select up to three storage units."),
    };
  }

  const rollerCabinets = selected.filter((storage) => getStorageTypeKey(storage) === STORAGE_TYPE_ROLLER_CABINET);
  const toolChests = selected.filter((storage) => getStorageTypeKey(storage) === STORAGE_TYPE_TOOL_CHEST);
  const stackSystems = selected.filter((storage) => getStorageTypeKey(storage) === STORAGE_TYPE_STACK_SYSTEM);
  const portableStorages = selected.filter((storage) => getStorageTypeKey(storage) === STORAGE_TYPE_PORTABLE);
  const brands = uniquePreserveOrder(selected.map(getStorageBrand).filter(Boolean));

  if (stackSystems.length > 0) {
    if (selected.length > 1) {
      return {
        valid: false,
        message: t("stackSystemCannotBeCombined", "A stack system cannot be combined with other storage units."),
      };
    }

    if (stackSystems.length > 1) {
      return {
        valid: false,
        message: t("onlyOneStackSystem", "You can only select one stack system."),
      };
    }

    return {
      valid: true,
      message: "",
    };
  }

  if (portableStorages.length > 0) {
    if (selected.length > 1) {
      return {
        valid: false,
        message: t("portableCannotBeCombined", "A portable storage unit cannot be combined with other storage units."),
      };
    }

    if (portableStorages.length > 1) {
      return {
        valid: false,
        message: t("onlyOnePortableStorage", "You can only select one portable storage unit."),
      };
    }

    return {
      valid: true,
      message: "",
    };
  }

  if (rollerCabinets.length > 1) {
    return {
      valid: false,
      message: t("onlyOneRollerCabinet", "You can only select one roller cabinet."),
    };
  }

  if (toolChests.length > 2) {
    return {
      valid: false,
      message: t("upToTwoToolChests", "You can select up to two tool chests."),
    };
  }

  if (brands.length > 1) {
    return {
      valid: false,
      message: t("toolStorageSelectionSameBrandOnly", "You can only combine storage units from the same product range."),
    };
  }

  if (rollerCabinets.length === 1) {
    const rollerCabinet = rollerCabinets[0];
    const rollerCabinetWidth = getStorageSelectionWidth(rollerCabinet);
    const rollerCabinetDepth = getStorageSelectionDepth(rollerCabinet);
    const rollerCabinetNominalWidth = getStorageNominalWidthInches(rollerCabinet);
    const mismatchedNominalWidthChest = toolChests.find((storage) => {
      const toolChestNominalWidth = getStorageNominalWidthInches(storage);
      return toolChestNominalWidth > 0
        && rollerCabinetNominalWidth > 0
        && toolChestNominalWidth !== rollerCabinetNominalWidth;
    });

    if (mismatchedNominalWidthChest) {
      return {
        valid: false,
        message: t(
          "toolChestMustMatchRollerCabinetNominalWidth",
          "A tool chest must match the selected roller cabinet size family.",
        ),
      };
    }

    const tooWideChest = toolChests.find((storage) => getStorageSelectionWidth(storage) > rollerCabinetWidth);

    if (tooWideChest) {
      return {
        valid: false,
        message: t("toolChestCannotBeWiderThanRollerCabinet", "A tool chest cannot be wider than the selected roller cabinet."),
      };
    }

    const tooDeepChest = toolChests.find((storage) => getStorageSelectionDepth(storage) > rollerCabinetDepth);
    if (tooDeepChest) {
      return {
        valid: false,
        message: t("toolChestCannotBeDeeperThanRollerCabinet", "A tool chest cannot be deeper than the selected roller cabinet."),
      };
    }
  }

  if (toolChests.length > 1) {
    const toolChestIds = new Set(toolChests.map((storage) => cleanString(storage?.itemId)).filter(Boolean));
    if (toolChestIds.size !== toolChests.length) {
      return {
        valid: false,
        message: t("toolChestIdsMustBeDifferent", "You cannot combine two identical tool chests."),
      };
    }

    const drawerCounts = new Set(toolChests.map((storage) => Number(storage?.numberOfDrawerInStorage) || 0));
    if (drawerCounts.size !== toolChests.length) {
      return {
        valid: false,
        message: t("toolChestDrawerCountsMustDiffer", "Selected tool chests must have different drawer counts."),
      };
    }

    const widths = new Set(toolChests.map((storage) => getStorageSelectionWidth(storage)));
    const depths = new Set(toolChests.map((storage) => getStorageSelectionDepth(storage)));
    if (widths.size > 1 || depths.size > 1) {
      return {
        valid: false,
        message: t("toolChestDimensionsMustMatch", "Selected tool chests must have matching width and depth."),
      };
    }
  }

  return {
    valid: true,
    message: "",
  };
}

exports.getStorageTypeKey = getStorageTypeKey;
exports.getStorageBrand = getStorageBrand;
exports.getStorageSelectionWidth = getStorageSelectionWidth;
exports.getStorageSelectionDepth = getStorageSelectionDepth;
exports.getStorageNominalWidthInches = getStorageNominalWidthInches;
exports.parseSelectedToolStorageIds = parseSelectedToolStorageIds;
exports.serializeSelectedToolStorageIds = serializeSelectedToolStorageIds;
exports.sortSelectedToolStorages = sortSelectedToolStorages;
exports.resolveSelectedToolStorages = resolveSelectedToolStorages;
exports.buildToolStorageSelectionKey = buildToolStorageSelectionKey;
exports.validateToolStorageSelection = validateToolStorageSelection;
});

__define("shared/dom/dom-helpers.js", (exports, __require) => {
const { cleanString } = __require("shared/utils/string-utils.js");
function byId(id) {
  return document.getElementById(id);
}

function getTrimmedValue(id) {
  const el = byId(id);
  return cleanString(el?.value);
}

exports.byId = byId;
exports.getTrimmedValue = getTrimmedValue;
});

__define("shared/i18n/toolkit-i18n.js", (exports, __require) => {
const { cleanString } = __require("shared/utils/string-utils.js");
const DEFAULT_TOOLKIT_TRANSLATIONS = {
  actions: "Actions",
  addAnother: "Add",
  addToList: "Add to list",
  clear: "Clear",
  clearFilters: "Clear filters",
  clipboardUnavailable: "Clipboard unavailable in this browser.",
  close: "Close",
  colour: "Colour",
  configurationExport: "Configuration export",
  configurationExportTxt: "Configuration export (.txt)",
  configuratorDataCouldNotBeLoaded: "The configurator data could not be loaded.",
  configureTheToolStorage: "Configure the tool storage",
  copied: "Copied.",
  copy: "Copy",
  copyFailed: "Copy failed.",
  copyFailedSelectManually: "Copy failed. Select and copy manually.",
  copyJson: "Copy JSON",
  copyPasteFourColumnTable: "Copy and paste this four-column table into Excel or Sheets.",
  customised: "CUSTOMISED",
  depth: "Depth",
  designedInSweden: "Designed in Sweden",
  detailsPrefix: " Details:",
  dismissHint: "Dismiss hint",
  doesNotFitCurrentDrawerLayout: "Does not fit in the current drawer layout.",
  downloadConfiguration: "Download Configuration",
  downloadMobileHint: "If downloading fails on mobile, use browser Share/Save from this page, or copy the JSON below.",
  drawer: "Drawer",
  drawerCountNotAvailable: "Drawer count N/A",
  drawers: "Drawers",
  drawersLowercase: "drawers",
  emptyDownloadHint: "If your browser creates empty downloads, use the link below (a real tap) to download the export.",
  expertSolutionsForIndustrialEfficiency: "EXPERT SOLUTIONS FOR INDUSTRIAL EFFICIENCY",
  exportGenerated: "Export generated",
  exportHeadingCount: "Count",
  exportHeadingDescription: "Description",
  exportHeadingDrawerIndex: "DrawerIndex",
  exportHeadingItemId: "ItemId",
  exportSelectedItems: "Export Selected Items",
  exportTable: "Export table",
  failedToReadSelectedFile: "Failed to read the selected file.",
  failedToSaveFile: "Failed to save file:",
  file: "File",
  filterByItemId: "Filter by Item Id",
  filters: "Filters",
  height: "Height",
  invalidConfigurationExportSelectTxt: "Invalid configuration export. Please select a .txt file containing JSON exported from this configurator.",
  invalidExportDrawerIndex: "Invalid configuration export: a drawer is missing 'drawerIndex'.",
  invalidExportDrawerLocked: "Invalid configuration export: a drawer has invalid 'locked' (expected a boolean).",
  invalidExportDrawerObject: "Invalid configuration export: each drawer must be an object.",
  invalidExportDrawerSets: "Invalid configuration export: a drawer has invalid 'sets' (expected an array).",
  invalidExportDrawers: "Invalid configuration export: invalid 'drawers' (expected an array).",
  invalidExportExpectedJsonObject: "Invalid configuration export: expected a JSON object.",
  invalidExportSavedAt: "Invalid configuration export: invalid 'savedAt' (expected an ISO timestamp string).",
  invalidExportToolstorageIds: "Invalid configuration export: missing or invalid 'toolstorageIds' (expected a string).",
  invalidExportToolsetIds: "Invalid configuration export: missing or invalid 'toolsetIds' (expected a string).",
  invalidExportToolstorageId: "Invalid configuration export: missing or invalid 'toolstorageId' (expected a string).",
  invalidToolStorageSelection: "This storage selection is not allowed.",
  invalidExportVersion: "Invalid configuration export: invalid 'version' (expected a number).",
  loadConfiguration: "Load configuration",
  loadPredefinedToolKit: "Load predefined tool kit",
  loadToolKit: "Load tool kit",
  loadToolkit: "Load toolkit",
  loadingToolKits: "Loading tool kits…",
  lockedDrawer: "Locked drawer",
  missingAppConfigData: "Missing APP_CONFIG.data configuration.",
  missingToolkitConfiguratorAppMount: "Missing #toolkit-configurator-app mount.",
  missingToolkitMountElement: "Missing toolkit configurator mount element.",
  noConfigurationRendered: "No configuration rendered",
  noFiltersAvailable: "No filters available.",
  noSetsPlacedInDrawer: "No sets placed in this drawer.",
  noToolKitsFound: "No tool kits found.",
  noToolSetsMatchFilters: "No tool sets match your filters.",
  noToolStorageSelected: "No tool storage selected.",
  noToolStoragesMatchFilters: "No tool storages match your filters.",
  notAvailable: "N/A",
  notFound: "Not found",
  openProductDetailsFor: "Open product details for",
  organiseStorage: "3. Organise your storage with drag and drop.",
  pasteOneToolSetIdPerLine: "Paste one tool set ID per line",
  placeListItems: "Place list items",
  pleaseEnterValidToolStorageId: "Please enter a valid tool storage ID.",
  printIntroLine1: "TengTools provide demanding professionals with hand tools in",
  printIntroLine2: "modular storage solutions that are built to last.",
  printPdf: "Print PDF",
  product: "Product",
  productDetails: "Product details",
  productType: "Product type",
  removeSet: "Remove set",
  sampleTabs: "Sample tabs",
  saveConfiguration: "Save configuration",
  searchByNameIdType: "Search by name, ID, or type",
  selectToolKitToMakeCustomLayout: "Select a TengTools tool kit to make a custom layout.",
  setHeightGreaterThanDrawerHeight: "Set height is greater than drawer height.",
  stackSystemCannotBeCombined: "A stack system cannot be combined with other storage units.",
  selectToolStorage: "Select tool storage",
  selectToolStorageAndConfigure: "Select a tool storage and configure its contents.",
  selectYourSets: "2. Select your sets.",
  selectYourStorage: "1. Select your storage.",
  selected: "Selected",
  selectedToolStorage: "Selected tool storage",
  selectedToolStorageColon: "Selected tool storage:",
  portableCannotBeCombined: "A portable storage unit cannot be combined with other storage units.",
  toolStorageSelectionSameBrandOnly: "You can only combine storage units from the same product range.",
  toolChestCannotBeWiderThanRollerCabinet: "A tool chest cannot be wider than the selected roller cabinet.",
  toolChestCannotBeDeeperThanRollerCabinet: "A tool chest cannot be deeper than the selected roller cabinet.",
  toolChestDimensionsMustMatch: "Selected tool chests must have matching width and depth.",
  toolChestDrawerCountsMustDiffer: "Selected tool chests must have different drawer counts.",
  toolChestIdsMustBeDifferent: "You cannot combine two identical tool chests.",
  toolChestMustMatchRollerCabinetNominalWidth: "A tool chest must match the selected roller cabinet size family.",
  tapToDownload: "Tap to download",
  toolKit: "TOOL KIT",
  toolSet: "Tool set",
  toolSets: "Tool sets",
  toolStorageSelectionMaxThree: "You can select up to three storage units.",
  toolStorage: "Tool storage",
  upToTwoToolChests: "You can select up to two tool chests.",
  unlockedDrawer: "Unlocked drawer",
  type: "Type",
  unplaced: "Unplaced",
  onlyOnePortableStorage: "You can only select one portable storage unit.",
  onlyOneRollerCabinet: "You can only select one roller cabinet.",
  onlyOneStackSystem: "You can only select one stack system.",
  upgradeStorageToFitSets: "Upgrade your storage to fit these sets:",
  wasNotInsertedSetHeightGreater: "was not inserted. The set height is greater than the height of any drawer.",
  weight: "Weight",
  width: "Width",
};

function getWindowTranslations() {
  if (typeof window === "undefined") return null;
  if (!window.TOOLKIT_TRANSLATIONS || typeof window.TOOLKIT_TRANSLATIONS !== "object") return null;
  return window.TOOLKIT_TRANSLATIONS;
}

function getToolkitTranslations() {
  return {
    ...DEFAULT_TOOLKIT_TRANSLATIONS,
    ...getWindowTranslations(),
  };
}

function t(key, fallback = "") {
  const dynamicTranslations = getWindowTranslations();
  const dynamicValue = cleanString(dynamicTranslations?.[key]);
  if (dynamicValue) return dynamicValue;

  const defaultValue = cleanString(DEFAULT_TOOLKIT_TRANSLATIONS[key]);
  if (defaultValue) return defaultValue;

  return cleanString(fallback) || key;
}

exports.getToolkitTranslations = getToolkitTranslations;
exports.t = t;
exports.DEFAULT_TOOLKIT_TRANSLATIONS = DEFAULT_TOOLKIT_TRANSLATIONS;
});

__define("shared/runtime/app-config.js", (exports, __require) => {
const { cleanString } = __require("shared/utils/string-utils.js");
const DEFAULT_DATA_URLS = {
  toolKits: "./data/tool-kits.json",
  toolSets: "./data/tool-sets.json",
  toolStorages: "./data/tool-storages.json",
};

function getWindowAppConfig() {
  if (typeof window === "undefined") return null;
  if (!window.APP_CONFIG || typeof window.APP_CONFIG !== "object") return null;
  return window.APP_CONFIG;
}

function getAppConfig() {
  const runtimeConfig = getWindowAppConfig();

  return {
    baseUrl: cleanString(runtimeConfig?.baseUrl),
    locale: cleanString(runtimeConfig?.locale) || "en",
    data: {
      ...DEFAULT_DATA_URLS,
      ...(runtimeConfig?.data || {}),
    },
    fallbackData: {
      ...(runtimeConfig?.fallbackData || {}),
    },
    imageMap: runtimeConfig?.imageMap && typeof runtimeConfig.imageMap === "object"
      ? runtimeConfig.imageMap
      : {},
  };
}

function getDataUrls(key) {
  const config = getAppConfig();
  const primary = cleanString(config.data?.[key]);
  const fallback = cleanString(config.fallbackData?.[key]);

  if (!primary && !fallback) return [];
  if (primary && fallback && primary !== fallback) return [primary, fallback];
  return [primary || fallback].filter(Boolean);
}

function getAppLocale() {
  return getAppConfig().locale || "en";
}

function resolveImagePath(url) {
  const value = cleanString(url);
  if (!value) return "";
  if (value.startsWith("http://") || value.startsWith("https://") || value.startsWith("/")) {
    return value;
  }

  const config = getAppConfig();
  const mappedUrl = cleanString(config.imageMap?.[value]);
  if (mappedUrl) return mappedUrl;

  return `/configurator/data/${value}`;
}

exports.getAppConfig = getAppConfig;
exports.getDataUrls = getDataUrls;
exports.getAppLocale = getAppLocale;
exports.resolveImagePath = resolveImagePath;
});

__define("shared/utils/number-utils.js", (exports, __require) => {
const { cleanString } = __require("shared/utils/string-utils.js");
function toNumber(value) {
  const normalized = cleanString(value).replace(",", ".");
  const num = Number(normalized);
  return Number.isFinite(num) ? num : 0;
}

function toInt(value) {
  return parseInt(cleanString(value), 10) || 0;
}


exports.toNumber = toNumber;
exports.toInt = toInt;
});

__define("shared/utils/string-utils.js", (exports, __require) => {
function cleanString(value) {
  return String(value ?? "").trim();
}

function escapeHtml(value) {
  return String(value ?? "")
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;")
    .replaceAll("'", "&#39;");
}

function uniquePreserveOrder(values) {
  const seen = new Set();
  const result = [];

  for (const value of values) {
    if (!seen.has(value)) {
      seen.add(value);
      result.push(value);
    }
  }

  return result;
}


exports.cleanString = cleanString;
exports.escapeHtml = escapeHtml;
exports.uniquePreserveOrder = uniquePreserveOrder;
});

window.__TOOLKIT_CONFIGURATOR_DISABLE_AUTO_INIT__ = true;

const { startConfiguratorApp } = __require("app.js");
const { t } = __require("shared/i18n/toolkit-i18n.js");

function renderStartupError(mount) {
  if (!mount) return;
  mount.innerHTML = `
    <p class="toolkit-configurator-app__error">${t("configuratorDataCouldNotBeLoaded", "The configurator data could not be loaded.")}</p>
  `;
}

async function bootstrapShopifyConfigurator() {
  const mount = document.getElementById("toolkit-configurator-app");

  if (!mount) {
    throw new Error(t("missingToolkitConfiguratorAppMount", "Missing #toolkit-configurator-app mount."));
  }

  mount.innerHTML = SHOPIFY_SHELL_HTML;
  await startConfiguratorApp();
}

bootstrapShopifyConfigurator().catch((error) => {
  console.error(error);
  const mount = document.getElementById("toolkit-configurator-app");
  renderStartupError(mount);
});
